{
  "schemaVersion": 1,
  "alphabet": "აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰ",
  "statuses": {
    "unicode-native": 293,
    "download-only": 29,
    "needs-review": 506,
    "verified-letters": 54,
    "verified": 9,
    "unavailable": 1,
    "partial": 2
  },
  "fonts": {
    "1": {
      "name": "BPG Glaho",
      "asset": "preview-fonts/1.woff2",
      "sha256": "8fa0007a8fa63fa867cc15a62222698d8a5e7e2dbc74aa2689d7b12a9562f0e4",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "2": {
      "name": "AcadNusx",
      "asset": "fonts/2.ttf",
      "sha256": "86ad8787db202657a06b0547418d24dce13504fc01a28b838aab186de519bf61",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "3": {
      "name": "AcadMtavr",
      "asset": "fonts/3.ttf",
      "sha256": "f26130e3d9669105950010699d8cd3779fa3adcfd9b6c68f77547d05124d9bbf",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "4": {
      "name": "Aladini",
      "asset": "preview-fonts/4.woff2",
      "sha256": "af2b6b6ed0d42600a0889d6d2c324715998c26292b21ae55f8491756b8009741",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "5": {
      "name": "Geo_Times",
      "asset": "preview-fonts/5.woff2",
      "sha256": "074498a5161a692ff4cc7683078529049a245ac26bf9b2e7aa192c375f22babe",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "6": {
      "name": "Elguja",
      "asset": "preview-fonts/6.woff2",
      "sha256": "7680c7b2aa7bee45105c27f08d97679c4d53a1e7951f417bf6ae121b7918a3da",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "7": {
      "name": "goturi goturi",
      "asset": "preview-fonts/7.woff2",
      "sha256": "6801f6a4afd41db3236994dedd2510236ac150d87e4a1214fe8e2a05be8fc0d5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "8": {
      "name": "BPG Glaho Arial SP V5",
      "asset": "preview-fonts/8.woff2",
      "sha256": "e0af37b5ac0c78387b51bf470f5445e1968bd54733560e372f26076d3a88ccff",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "9": {
      "name": "GeoPixel",
      "asset": "preview-fonts/9.woff2",
      "sha256": "d3fb5f82881a04e9818b94776ae3b718d31199e66200c34cb8e5df78a3b89c6d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "10": {
      "name": "Geo_Times Bold",
      "asset": "preview-fonts/10.woff2",
      "sha256": "89f2178b88b8d3ac7e5811a1d34cd172f6dfd279fa3697316d79c3f37502ec1b",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "11": {
      "name": "Geo_Times Italic",
      "asset": "preview-fonts/11.woff2",
      "sha256": "0f0e1b42ca9938e857b4c18c5ba728aeb692007c27233444be6bb4aea09d004c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "12": {
      "name": "Geo_Times Bold Italic",
      "asset": "preview-fonts/12.woff2",
      "sha256": "ab97857256a66d78cf609aa9d29c89105b82f461064d0ad2bf725825cb046eea",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "13": {
      "name": "BPG Arial",
      "asset": "preview-fonts/13.woff2",
      "sha256": "3ec61162d707ef6837f085e63abeeb8664df830b815d5b615c2482a3d3214bc4",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "14": {
      "name": "BPG ExtraSquare",
      "asset": "preview-fonts/14.woff2",
      "sha256": "21045d526d6dc70ff3b2a4fdef4cdcc6da9070d785630a5fab14888fb9792b39",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "15": {
      "name": "BPG ExtraSquare Mtavruli",
      "asset": "preview-fonts/15.woff2",
      "sha256": "172b2834ad0d3ff1d7d657767b86a2892c4d61af7d5ab52c9b9109f0688ba68d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "16": {
      "name": "LitNusx",
      "asset": "fonts/16.ttf",
      "sha256": "119d2415b374dcdd9686d4ba370efdab04828f1f4332379e07babb7ce178516c",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "17": {
      "name": "Academiury-ITV",
      "asset": "preview-fonts/17.woff2",
      "sha256": "80bb3793cd7607116a6d181385ed7f936c1241586e099b7a55c2294c7d31d264",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "18": {
      "name": "Academiury-ITV Bold",
      "asset": "preview-fonts/18.woff2",
      "sha256": "59e826a70f13faeb22fa0fb27e477061f9927b04353effab84c80a8817e791f3",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "19": {
      "name": "Academiury-ITV Italic",
      "asset": "preview-fonts/19.woff2",
      "sha256": "4b443e438a0bdfd5d954560ee2d3f316498a3c040f163e406cf02756ff658e53",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "20": {
      "name": "AsoMtavruly-ITV",
      "asset": "preview-fonts/20.woff2",
      "sha256": "85da7a6eac8aba8d8db835fc0586801a023382c65a8050487a6c5ffb8b8ee558",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified; source spaces and conflicting punctuation rendered in InterfaceGeo to avoid legacy letter-slot collisions",
      "fallbackCharacters": [
        " ",
        ",",
        ".",
        ";",
        "'",
        "/"
      ],
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "21": {
      "name": "Academiury-ITV Bold Italic",
      "asset": "preview-fonts/21.woff2",
      "sha256": "af294933479c14d3f07fc498cda6a8ddc1b5d5393a81fffe31278808f21e1c5f",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "22": {
      "name": "Academiury-ITV",
      "asset": "preview-fonts/22.woff2",
      "sha256": "9a7e0f4b68e0ae353d1c42f22a39cf53459e66ceececee9a813aa65824f754f1",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "-",
        ".": "=",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "23": {
      "name": "Academiury-ITV Bold",
      "asset": "preview-fonts/23.woff2",
      "sha256": "903584bda021317c1e10cec07f58a75ba2792a31a21a23fd9d3fb875cd247458",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "-",
        ".": "=",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "24": {
      "name": "Academiury-ITV Italic",
      "asset": "preview-fonts/24.woff2",
      "sha256": "59d24724cfef00af92b1554c4fab54105b2533107227b0bbdc2f450b28ccadaa",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "-",
        ".": "=",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "25": {
      "name": "Academiury-ITV Bold Italic",
      "asset": "preview-fonts/25.woff2",
      "sha256": "3e9669cb302793a25e6a505f70e5a12f22e8ea33637a2c596048e0833ca8b57d",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "-",
        ".": "=",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "26": {
      "name": "Chveulebrivy-ITV",
      "asset": "preview-fonts/26.woff2",
      "sha256": "65bcee315a7574c9a2c95e27ba7780bd44578ac8626e1ba393217e54e477548c",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "-",
        ".": "=",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "27": {
      "name": "Chveulebrivy-ITV Bold",
      "asset": "preview-fonts/27.woff2",
      "sha256": "707a9030e96aeb75c8b73180982e94188e2ff3319dc30ef7449dd137613f16df",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "-",
        ".": "=",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "28": {
      "name": "Chveulebrivy-ITV Italic",
      "asset": "preview-fonts/28.woff2",
      "sha256": "d79b2796991b0bd1401d378b2b239dccba934bf81c7e241fe3eb03359d6b89e2",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "-",
        ".": "=",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "29": {
      "name": "Chveulebrivy-ITV Bold Italic",
      "asset": "preview-fonts/29.woff2",
      "sha256": "f1bcaf3c2131d09d38c73ca956e2868c2ed0a3ee3444f0fa151444f14f0cad35",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "-",
        ".": "=",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "30": {
      "name": "Dumbadze GGE",
      "asset": "preview-fonts/30.woff2",
      "sha256": "0627df12fe9eb966351e9d857208047cf65fc8d7abb12aa2f91049f993568d58",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "31": {
      "name": "Dumbadze cond GGE",
      "asset": "preview-fonts/31.woff2",
      "sha256": "4b008b74cfe58528ab85e75dadc772dbc576e882d7b36efdfbb00a9046ca94f6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "32": {
      "name": "Dumbadze Italic GGE",
      "asset": "preview-fonts/32.woff2",
      "sha256": "f60c7454f45252423e2cc79a7847a874ebc372ffde31720a54c93309539eb738",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "33": {
      "name": "Dumbadze_TF",
      "asset": "preview-fonts/33.woff2",
      "sha256": "400e8c3a6314168c3d1b4200d08ed515a9f242ce74ec9e065c1d67beb350ec93",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "34": {
      "name": "Dumbadze-ITV",
      "asset": "preview-fonts/34.woff2",
      "sha256": "3ac7d63c4432d81f8cc2348cc65c6dbd66363933e286351f6870699c3617b33f",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "35": {
      "name": "Dumbadze-ITV Bold",
      "asset": "preview-fonts/35.woff2",
      "sha256": "a6f529c957a35e8bcee92c7e134d791a33266c4ea27f517c13b558717a0c190a",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "36": {
      "name": "Dumbadze-ITV Italic",
      "asset": "preview-fonts/36.woff2",
      "sha256": "4728e4f97208cb77af7d4e1494f6301f131e976dfb14573761b7e422acdf9a0b",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "37": {
      "name": "Dumbadze-ITV Bold Italic",
      "asset": "preview-fonts/37.woff2",
      "sha256": "5ce0cbcf5b0a3daed9ae9e0a9e5b8ee503fd8ee445fb19cd5838785662017411",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "38": {
      "name": "Gogebashvili-ITV",
      "asset": "preview-fonts/38.woff2",
      "sha256": "c3c27a442875bbfbe27a3c7e95acd774597d54c3910b96a2ffb60bf0d16fb625",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "39": {
      "name": "Gogebashvili-ITV Bold",
      "asset": "preview-fonts/39.woff2",
      "sha256": "b630b86b86b31307a7fecda0e587006d7fbc5fe3c8c13a21080a9dd5bad51fb8",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "40": {
      "name": "Gogebashvili-ITV Italic",
      "asset": "preview-fonts/40.woff2",
      "sha256": "e7ddcb0b2171af65849f9dc3de191c5b6d2fc7b72bf8f1327a9782f283373df1",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "41": {
      "name": "Gogebashvili-ITV Bold Italic",
      "asset": "preview-fonts/41.woff2",
      "sha256": "568cd9b58d5c84de79ca786f96cb5d20e43c7515de0eee4147acae3185a8a807",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "42": {
      "name": "Kolkhety-ITV",
      "asset": "preview-fonts/42.woff2",
      "sha256": "a9778df85d065a605848da8e7cca7ddcf6b3539952c26812ef5186fc43fd90ab",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "43": {
      "name": "Kolkhety-ITV Bold",
      "asset": "preview-fonts/43.woff2",
      "sha256": "8b4800bfbee1f1597891cba9efdb56e06069002e1e25f07106e434a796338d5e",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "44": {
      "name": "Kolkhety-ITV Italic",
      "asset": "preview-fonts/44.woff2",
      "sha256": "f021f40b82549d26bfba54f753a4e9cca5ac59e9f6a7711abaa288b0240de7a5",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "45": {
      "name": "Kolkhety-ITV Bold Italic",
      "asset": "preview-fonts/45.woff2",
      "sha256": "65175f6e96378797ed0b30b10e406a15f2d9200485e4d3d9492b68373791e09c",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "46": {
      "name": "Literaturuly-ITV",
      "asset": "preview-fonts/46.woff2",
      "sha256": "9b75d30036898e2c95a491bee72ba9df2ba13a77725fcf34a6bb7d6f58bf5e1e",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "47": {
      "name": "Literaturuly-ITV Bold",
      "asset": "preview-fonts/47.woff2",
      "sha256": "302fa3d56e38f93398c6bc7b73714517323a6a675fcf02b2f9c1fd5279112891",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "48": {
      "name": "Literaturuly-ITV Italic",
      "asset": "preview-fonts/48.woff2",
      "sha256": "9272dc83b1982b60da3ccae191fc9a425de5de0a0576ea37598be982fcaaff57",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "49": {
      "name": "Literaturuly-ITV Bold Italic",
      "asset": "preview-fonts/49.woff2",
      "sha256": "3b5712ed5127e55df5cbf2d4e736426f41492bbe5f679e8103f2621f05c7f638",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "`",
        "%": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "50": {
      "name": "# Grigolia",
      "asset": "preview-fonts/50.woff2",
      "sha256": "66bc2db54b8b96c3b68f8792fb6647e9b2af8de539faf95cc7786ed5c60843eb",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "0": ")",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "&",
        "8": "*",
        "9": "(",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "6",
        ".": "7",
        ":": "5",
        ";": "8",
        "!": "=",
        "?": "9",
        "(": "~",
        ")": "`",
        "%": "0"
      },
      "missing": [],
      "evidence": "Rendered 33-letter chart reviewed on 2026-09-30; missing characters recorded separately",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "51": {
      "name": "# Grigolia Mta",
      "asset": "preview-fonts/51.woff2",
      "sha256": "8be9dc55473a14bec074c622bebd92484f75b41a3e9358b81d58f69716e7c911",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "0": ")",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "&",
        "8": "*",
        "9": "(",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "6",
        ".": "7",
        ":": "5",
        ";": "8",
        "!": "=",
        "?": "9",
        "(": "~",
        ")": "`",
        "%": "0"
      },
      "missing": [],
      "evidence": "Rendered 33-letter chart reviewed on 2026-09-30; missing characters recorded separately",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "52": {
      "name": "_! Kolhety Normal",
      "asset": "preview-fonts/52.woff2",
      "sha256": "59121dccb3e1f6d5d1b4826213a9cebd7fb101acc27775d27f578fd7e3193a47",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "53": {
      "name": "Akademiuri_BJG",
      "asset": "preview-fonts/53.woff2",
      "sha256": "8f6f351c05f6de73e076f657323c449d64f9d4f85665dbde2df9757854162832",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "54": {
      "name": "G_Gogebashvili Normal",
      "asset": "preview-fonts/54.woff2",
      "sha256": "a143fe1f89c604c6c24ddb8e20b1ab1914b9568ccca68c83feb8e97a958ed5b8",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "55": {
      "name": "Literaturuli ITV",
      "asset": "preview-fonts/55.woff2",
      "sha256": "716f6d29b8d37e9f84da42738d167b9534665305bcb2954a61835cf4730d3cf9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "56": {
      "name": "AAAcademiury Bold",
      "asset": "preview-fonts/56.woff2",
      "sha256": "4deb0c5ddaf0e784e72bdd1def677b8c41c95844c06358b2455e510f93142aa7",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "ã",
        "დ": "ä",
        "ე": "å",
        "ვ": "â",
        "ზ": "ç",
        "თ": "û",
        "ი": "è",
        "კ": "ê",
        "ლ": "ë",
        "მ": "ì",
        "ნ": "í",
        "ო": "î",
        "პ": "ï",
        "ჟ": "æ",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "ü",
        "ღ": "é",
        "ყ": "þ",
        "შ": "ø",
        "ჩ": "÷",
        "ც": "ö",
        "ძ": "ý",
        "წ": "ù",
        "ჭ": "ÿ",
        "ხ": "õ",
        "ჯ": "ú",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "Browser glyph charts U+00A0–U+00FF reviewed 2026-09-30; modern Mkhedruli letters in Cyrillic-style order, not standard STD8; punctuation unchanged",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "57": {
      "name": "AAAcademiury Italic",
      "asset": "preview-fonts/57.woff2",
      "sha256": "907a2415eb6d8a3b2a967e41c939833e00097b3081047f92ea591cc5a84abfd3",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "ã",
        "დ": "ä",
        "ე": "å",
        "ვ": "â",
        "ზ": "ç",
        "თ": "û",
        "ი": "è",
        "კ": "ê",
        "ლ": "ë",
        "მ": "ì",
        "ნ": "í",
        "ო": "î",
        "პ": "ï",
        "ჟ": "æ",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "ü",
        "ღ": "é",
        "ყ": "þ",
        "შ": "ø",
        "ჩ": "÷",
        "ც": "ö",
        "ძ": "ý",
        "წ": "ù",
        "ჭ": "ÿ",
        "ხ": "õ",
        "ჯ": "ú",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "Browser glyph charts U+00A0–U+00FF reviewed 2026-09-30; modern Mkhedruli letters in Cyrillic-style order, not standard STD8; punctuation unchanged",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "58": {
      "name": "AALiteraturuli bold",
      "asset": "preview-fonts/58.woff2",
      "sha256": "7ac7cd3643804d791b4f4ad12d4f8a695438a360e8b3667eb820a2f7803fb8a9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "59": {
      "name": "Acad Nusx Geo",
      "asset": "preview-fonts/59.woff2",
      "sha256": "9f04c681b895bca512c5ea44587a531059753a3c842361c6846bb1cdd519cbf5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "60": {
      "name": "Academic Normal",
      "asset": "preview-fonts/60.woff2",
      "sha256": "110730566ef732eab06c56bb082df232641e4555067a8196ab095327a59ceb70",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "61": {
      "name": "academiury",
      "asset": "preview-fonts/61.woff2",
      "sha256": "83d39130c97138698ef435e78ae168e81e616ed4a9e80e084b36d7bf2994df50",
      "status": "verified",
      "profile": {
        "table": "Academic",
        "layout": "unchanged",
        "label": "Legacy typewriter"
      },
      "map": {
        "0": "_",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "*",
        "8": "(",
        "9": ")",
        "ა": "g",
        "ბ": ".",
        "გ": "u",
        "დ": ";",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "f",
        "ი": "n",
        "კ": "r",
        "ლ": "l",
        "მ": "b",
        "ნ": "y",
        "ო": "k",
        "პ": "h",
        "ჟ": "'",
        "რ": "j",
        "ს": "v",
        "ტ": "m",
        "უ": "e",
        "ფ": "a",
        "ქ": ",",
        "ღ": "q",
        "ყ": "c",
        "შ": "i",
        "ჩ": "x",
        "ც": "]",
        "ძ": "s",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "w",
        "ჰ": "/",
        ",": "7",
        ".": "8",
        ":": "5",
        ";": "9",
        "!": "=",
        "?": "0",
        "(": "~",
        ")": "`",
        "%": "+",
        "-": "2",
        "/": "-"
      },
      "missing": [],
      "evidence": "Actual browser ASCII charts reviewed 2026-09-30: typewriter lowercase layout differs from capital slots; 33 modern letters, digit and punctuation samples checked",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "62": {
      "name": "ACADEMIURY_P",
      "asset": "preview-fonts/62.woff2",
      "sha256": "a1917da7c09a5ad77f3f77545dcd5e38f5f274576d28a7d3f376d956fb066c25",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "63": {
      "name": "ACADEMIURY A&V",
      "asset": "preview-fonts/63.woff2",
      "sha256": "1898c891363444c9dcbb9b28e3c85cf2bdfe671374229eb23f22b33180f2e789",
      "status": "verified",
      "profile": {
        "table": "av-academy",
        "layout": "unchanged",
        "label": "Academiury A&V"
      },
      "map": {
        "0": "_",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "*",
        "8": "(",
        "9": ")",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "7",
        ".": "8",
        ":": "5",
        ";": "9",
        "!": "=",
        "?": "0",
        "(": "~",
        ")": "`",
        "%": "+"
      },
      "missing": [],
      "evidence": "Rendered full alphabet and punctuation chart checked on 2026-09-30",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "64": {
      "name": "ACADEMIURY A&V Bold",
      "asset": "preview-fonts/64.woff2",
      "sha256": "c83641369370ad94730ffaf3065349eb038b0ef4259b174781aa8c48ffabc809",
      "status": "verified",
      "profile": {
        "table": "av-academy-bold",
        "layout": "unchanged",
        "label": "Academiury A&V"
      },
      "map": {
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "=",
        ".": "+",
        ":": "|",
        ";": "\\",
        "!": "!",
        "?": "~",
        "(": "(",
        ")": ")",
        "%": "%"
      },
      "missing": [],
      "evidence": "Rendered full alphabet and punctuation chart checked on 2026-09-30",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "65": {
      "name": "ACADEMIURY A&V +",
      "asset": "preview-fonts/65.woff2",
      "sha256": "e224e3a97682ad934c0f5e573efad65336bf862fa83d863da86d4d6e6e477226",
      "status": "verified",
      "profile": {
        "table": "av-academy",
        "layout": "unchanged",
        "label": "Academiury A&V"
      },
      "map": {
        "0": "_",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "*",
        "8": "(",
        "9": ")",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "7",
        ".": "8",
        ":": "5",
        ";": "9",
        "!": "=",
        "?": "0",
        "(": "~",
        ")": "`",
        "%": "+"
      },
      "missing": [],
      "evidence": "Rendered full alphabet and punctuation chart checked on 2026-09-30",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "66": {
      "name": "AcadNusx_lb",
      "asset": "preview-fonts/66.woff2",
      "sha256": "1cc66439b6221eb11e61f460c48c61246c7e0b46bd1e1c1be50cfe105ec5aa6f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "67": {
      "name": "AcadNusx Wd",
      "asset": "fonts/67.ttf",
      "sha256": "70cb4de69cfecc1eb8ecfa86b085207768768ef96967aa23342b2df9d0ce8457",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "68": {
      "name": "Adamiani (ERI)",
      "asset": "preview-fonts/68.woff2",
      "sha256": "a4dec266ae17b152b36621b75cd9d8618477866f9c85b39f535a363f4643c4d9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "69": {
      "name": "akademiuri",
      "asset": "preview-fonts/69.woff2",
      "sha256": "c3260407e039699f34f3acd96cc1648f942abfed0fb241558d113e21619e3c42",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "70": {
      "name": "Akademiuri",
      "asset": "preview-fonts/70.woff2",
      "sha256": "b0c1c2b8e814e12575a304b9b5f10665bcee206683d662d45e3ad6fce73594ec",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "71": {
      "name": "Akademiuri mtavruli",
      "asset": "preview-fonts/71.woff2",
      "sha256": "ba012bd4b806f7e0e0de0646b44227ce8df8eb1401af9a2ca9aea597f446b25f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "72": {
      "name": "Amiran",
      "asset": "preview-fonts/72.woff2",
      "sha256": "c6378797f40c49ddadfda1fcb5070b56d20c42b6a200761d4081e553b0b476b6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "73": {
      "name": "Amiran SP",
      "asset": "preview-fonts/73.woff2",
      "sha256": "6aa075989e6ba01b4be3821bf6efa75fef8d39e835235618c2004498ac8c59e9",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "74": {
      "name": "ALiteraturuliH",
      "asset": "preview-fonts/74.woff2",
      "sha256": "685ca5520d7e479d38c1b45feeed366cf3629cf9c1bab02a73f018b4e73d0d8e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "75": {
      "name": "AmicoGeo",
      "asset": "preview-fonts/75.woff2",
      "sha256": "f245f448603bc3fd6370d7ac25aa94fa47209d873f0682a8e823cfbc1453edf3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "76": {
      "name": "Arachveulebrivi Thin",
      "asset": "preview-fonts/76.woff2",
      "sha256": "43120fc98fe19a66ba26ba1803f6bd1295ce9d1e3d7ea5b0cae031b5fdc92890",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "77": {
      "name": "Arachveulebrivi Thin SP",
      "asset": "preview-fonts/77.woff2",
      "sha256": "1bbda31258c842d4dc8e94cf7f4a20647e0994b919754d16f63fbe2de6c788c9",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "78": {
      "name": "Arial GEO",
      "asset": "preview-fonts/78.woff2",
      "sha256": "3893f367daec011a582b64dfad27e47d4e4dfda5bfa9e1fd99034dd942728bef",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "79": {
      "name": "ARTANUJI",
      "asset": "preview-fonts/79.woff2",
      "sha256": "9d93f42ef91cd608a53451111e69eb9282353d0effbb5da9e0b3eecc6bbb029f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "80": {
      "name": "AsoMtavruly",
      "asset": "preview-fonts/80.woff2",
      "sha256": "67d47c6495136b3bab1abf80f8f38d4e4f037dc6c2b6d9cb0fb05c0134fa50c4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "81": {
      "name": "Avaza",
      "asset": "preview-fonts/81.woff2",
      "sha256": "8d44f4ec291f4ca23735057f5c474a097fa5b5239d78d80ac6a915165c9670aa",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "82": {
      "name": "Avaza Mtavruli",
      "asset": "preview-fonts/82.woff2",
      "sha256": "f4f17c3a58e4e898ecc6cc3d5c80ff351e9cc65e9c827d5c247010a17c99f34a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "83": {
      "name": "Avaza Mtavruli SP",
      "asset": "preview-fonts/83.woff2",
      "sha256": "6bea2c08c5ec9b8454ed48b2ebad4333228f3e8686cc4a5afaa5d130474bfb84",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "84": {
      "name": "AZacademiury",
      "asset": "preview-fonts/84.woff2",
      "sha256": "9babca192bc0ad3300399cd75413a77802094dd74eb03055919ca81dfa17ed38",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "ã",
        "დ": "ä",
        "ე": "å",
        "ვ": "â",
        "ზ": "ç",
        "თ": "û",
        "ი": "è",
        "კ": "ê",
        "ლ": "ë",
        "მ": "ì",
        "ნ": "í",
        "ო": "î",
        "პ": "ï",
        "ჟ": "æ",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "ü",
        "ღ": "é",
        "ყ": "þ",
        "შ": "ø",
        "ჩ": "÷",
        "ც": "ö",
        "ძ": "ý",
        "წ": "ù",
        "ჭ": "ÿ",
        "ხ": "õ",
        "ჯ": "ú",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "AZacademiury Regular, Bold, Italic and Bold Italic U+00A0–U+00FF browser glyph charts reviewed 2026-09-30. Cyrillic-style letter ordering matches AAAcademiury, not generic STD8; ჰ at U+00B8.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "85": {
      "name": "AZacademiury Bold",
      "asset": "preview-fonts/85.woff2",
      "sha256": "8301fd6cd72b8180d1ca344f1222b37ebd82c739dcd7ea954a787d4ddd21acf1",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "ã",
        "დ": "ä",
        "ე": "å",
        "ვ": "â",
        "ზ": "ç",
        "თ": "û",
        "ი": "è",
        "კ": "ê",
        "ლ": "ë",
        "მ": "ì",
        "ნ": "í",
        "ო": "î",
        "პ": "ï",
        "ჟ": "æ",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "ü",
        "ღ": "é",
        "ყ": "þ",
        "შ": "ø",
        "ჩ": "÷",
        "ც": "ö",
        "ძ": "ý",
        "წ": "ù",
        "ჭ": "ÿ",
        "ხ": "õ",
        "ჯ": "ú",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "AZacademiury Regular, Bold, Italic and Bold Italic U+00A0–U+00FF browser glyph charts reviewed 2026-09-30. Cyrillic-style letter ordering matches AAAcademiury, not generic STD8; ჰ at U+00B8.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "86": {
      "name": "AZacademiury Italic",
      "asset": "preview-fonts/86.woff2",
      "sha256": "b5c2192cd18469339e13917781a16d3504a65130bf219d3b1e788c4cee1b3474",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "ã",
        "დ": "ä",
        "ე": "å",
        "ვ": "â",
        "ზ": "ç",
        "თ": "û",
        "ი": "è",
        "კ": "ê",
        "ლ": "ë",
        "მ": "ì",
        "ნ": "í",
        "ო": "î",
        "პ": "ï",
        "ჟ": "æ",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "ü",
        "ღ": "é",
        "ყ": "þ",
        "შ": "ø",
        "ჩ": "÷",
        "ც": "ö",
        "ძ": "ý",
        "წ": "ù",
        "ჭ": "ÿ",
        "ხ": "õ",
        "ჯ": "ú",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "AZacademiury Regular, Bold, Italic and Bold Italic U+00A0–U+00FF browser glyph charts reviewed 2026-09-30. Cyrillic-style letter ordering matches AAAcademiury, not generic STD8; ჰ at U+00B8.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "87": {
      "name": "AZacademiury Bold Italic",
      "asset": "preview-fonts/87.woff2",
      "sha256": "c0e4a6bf4f2a7bdd4f3571a84974d857d9f9d516f072e3e81751d5b91ff9a8be",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "ã",
        "დ": "ä",
        "ე": "å",
        "ვ": "â",
        "ზ": "ç",
        "თ": "û",
        "ი": "è",
        "კ": "ê",
        "ლ": "ë",
        "მ": "ì",
        "ნ": "í",
        "ო": "î",
        "პ": "ï",
        "ჟ": "æ",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "ü",
        "ღ": "é",
        "ყ": "þ",
        "შ": "ø",
        "ჩ": "÷",
        "ც": "ö",
        "ძ": "ý",
        "წ": "ù",
        "ჭ": "ÿ",
        "ხ": "õ",
        "ჯ": "ú",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "AZacademiury Regular, Bold, Italic and Bold Italic U+00A0–U+00FF browser glyph charts reviewed 2026-09-30. Cyrillic-style letter ordering matches AAAcademiury, not generic STD8; ჰ at U+00B8.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "88": {
      "name": "Balaveri",
      "asset": "preview-fonts/88.woff2",
      "sha256": "eb77d7481fcca3ecaf902573207713ad5ec64dce09b0ed3200f142fa25f51591",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "89": {
      "name": "Babuka",
      "asset": "preview-fonts/89.woff2",
      "sha256": "a1a04bbf3dc79d180d260adb9f67ff5daba49b19729c2848aadcc143b488732d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "90": {
      "name": "Babuka Mtavruli",
      "asset": "preview-fonts/90.woff2",
      "sha256": "7db035d060871a63418dffe36e6f100635d23368a93a81c56190302f8e182a86",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "91": {
      "name": "BalavMtavr",
      "asset": "fonts/91.ttf",
      "sha256": "0e18210f3a2521b2990af4886e1a00fc43ee665c6f5fae8f3dad7bbeac69c474",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "92": {
      "name": "Barnaba",
      "asset": "preview-fonts/92.woff2",
      "sha256": "ca9cc47dd3d583bbf023a4beed6eabbc1301c088ac6e5fc64f5ccf078efc239d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "93": {
      "name": "Beka",
      "asset": "preview-fonts/93.woff2",
      "sha256": "e83e7ceefe40d98903774c451ae23247790a6cc8824899dba1e38f4c9f9ec0f2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "94": {
      "name": "Bolnisi",
      "asset": "preview-fonts/94.woff2",
      "sha256": "c2db84d719753e951ca306b97f7e25187de0c07f1fd36249e9dcdbd37c022198",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "95": {
      "name": "Bolnisi Mtavruli",
      "asset": "preview-fonts/95.woff2",
      "sha256": "f764fe6cf646e9b8ed3258c7274f140b2570bcd2012bd1795030590efcbd96d0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "96": {
      "name": "Bordeaux Georgian",
      "asset": "preview-fonts/96.woff2",
      "sha256": "7738bfc4535a90c373877e18eabda5288bbba39c45a3c25c33c7b13262a7470a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "97": {
      "name": "Brush Script Georgian",
      "asset": "preview-fonts/97.woff2",
      "sha256": "b1c0f2c9e84a42fd7854f79920df53b007357ce68af2e723a861172ccc5363ec",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "98": {
      "name": "Bondo",
      "asset": "preview-fonts/98.woff2",
      "sha256": "a2be127b610207874820976c8dfab7566087baf5388d8360e1ab1394b60b8dd4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "99": {
      "name": "BPG Algeti",
      "asset": "preview-fonts/99.woff2",
      "sha256": "80a1bc917ffe213e96068c8eee251a9d8cac2debbf27f23bc1b011843de5428d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 44,
        "ambiguousCharacters": []
      }
    },
    "100": {
      "name": "BPG Algeti",
      "asset": "preview-fonts/100.woff2",
      "sha256": "27568f96d96c4bbedc3095168e42f7427edf0d9b935899a0e4185db36161de27",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 44,
        "ambiguousCharacters": []
      }
    },
    "101": {
      "name": "BPG Algeti Compact",
      "asset": "preview-fonts/101.woff2",
      "sha256": "90ff4c77f30747ccf9efcb2c1a9f90965e3ba40b4077a420135e5cd6c9fc23af",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 44,
        "ambiguousCharacters": []
      }
    },
    "102": {
      "name": "BPG Algeti Compact",
      "asset": "preview-fonts/102.woff2",
      "sha256": "8ec22514b35e310483f18c8e6cee71f7e68cab0933f06891c6779f1d2ebdf24c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 44,
        "ambiguousCharacters": []
      }
    },
    "103": {
      "name": "BPG Boxo",
      "asset": "preview-fonts/103.woff2",
      "sha256": "45ebcb218cdb77db19f58089ce92b6da95219264e660000c703d4d078a9ee09f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 27,
        "ambiguousCharacters": [
          "უ",
          "ფ",
          "ქ",
          "ღ",
          "ყ",
          "შ"
        ]
      }
    },
    "104": {
      "name": "BPG Boxo-Boxo",
      "asset": "preview-fonts/104.woff2",
      "sha256": "1f0fc9fb7808fab2e0a66a360cb4b0a8b4e3557a630f965efd5982e5979fd549",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 27,
        "ambiguousCharacters": [
          "უ",
          "ფ",
          "ქ",
          "ღ",
          "ყ",
          "შ"
        ]
      }
    },
    "105": {
      "name": "BPG Classic Medium",
      "asset": "preview-fonts/105.woff2",
      "sha256": "9e5350f4e01b7f03f06706b8d7c9fd45ae0090291f1dd43f4cac536254012203",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "106": {
      "name": "BPG DedaEna",
      "asset": "preview-fonts/106.woff2",
      "sha256": "b4d4e6cbe3213e591c0364426ba21591b1de30fd1e511f4b3eaa4dca9d01602b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "107": {
      "name": "BPG DedaEna Block",
      "asset": "preview-fonts/107.woff2",
      "sha256": "369282d2a312566a6497cd3febaeee5ca37bade3694734089288a9944288f445",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "108": {
      "name": "BPG DedaEna Nonblock",
      "asset": "preview-fonts/108.woff2",
      "sha256": "8130ebe542811d3e7de1d664ca15513a5ae80569de207e8b5f781505b4cc0b09",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "109": {
      "name": "BPG Glaho 2008",
      "asset": "preview-fonts/109.woff2",
      "sha256": "0183510a74125c1bb53db9476caf36bba1dab224fca10cd628a21e424748e5dc",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "110": {
      "name": "BPG Glaho 2008",
      "asset": "preview-fonts/110.woff2",
      "sha256": "582a21bfa32f7f68139c1eca33a0950fc5596c77307c5600377a716ddd66f9fb",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "111": {
      "name": "BPG Glaho Arial",
      "asset": "preview-fonts/111.woff2",
      "sha256": "f570723fd5c02a476d4f5b263221e885111749ac7d436328bd77e0f5fe3dc734",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "112": {
      "name": "BPG Glaho Arial 2008",
      "asset": "preview-fonts/112.woff2",
      "sha256": "c19b1245e6430cd74c9861da946594730aed32e7defe9113d0a000d08a8e618c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "113": {
      "name": "BPG Glaho Arial 2008",
      "asset": "preview-fonts/113.woff2",
      "sha256": "1868aa5842d561b303d7b5c3f351c9a4506085db4d020d7c75f4bf517a9ada65",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "114": {
      "name": "BPG Glaho Bold",
      "asset": "preview-fonts/114.woff2",
      "sha256": "8cc110ff085ed65846b2145000732b7d547b5621bfedcc44f6cd5d6852445429",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 44,
        "ambiguousCharacters": []
      }
    },
    "115": {
      "name": "BPG Glaho Mix",
      "asset": "preview-fonts/115.woff2",
      "sha256": "d9fb97b8e5cc97af746343e80b284ed4884977ef43c21fa049c38596ac856b3d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "116": {
      "name": "BPG Glaho SP",
      "asset": "preview-fonts/116.woff2",
      "sha256": "c5eaf94145f28d9a04a4dbbaefc0a4d8c02ca4e4652b71d83481d533b5585951",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "117": {
      "name": "BPG Glaho Traditional",
      "asset": "preview-fonts/117.woff2",
      "sha256": "3c435e97ded1d6700b5a7ff3c19378a35c25bc190cdea3d6fe98638394aa457f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "118": {
      "name": "BPG Glaho Traditional Arial",
      "asset": "preview-fonts/118.woff2",
      "sha256": "cb02cdbee1cc2c451a1af21cc406379f8fa67c10a05183afd85b192536c2d23b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "119": {
      "name": "BPG Ingiri 2008",
      "asset": "preview-fonts/119.woff2",
      "sha256": "0efa1de419e65930dc57015e70b6240e34a25724ea0dac9881900512e2af697d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "120": {
      "name": "BPG Ingiri Arial",
      "asset": "preview-fonts/120.woff2",
      "sha256": "e9fb135b9ec3f185ff705befc33be4eab1843e2deab00ba94cd3f363d3dfef6c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "121": {
      "name": "BPG Ingiri Arial 2008",
      "asset": "preview-fonts/121.woff2",
      "sha256": "a66a55dc4d8c5703a63057de4faa249d87be477840176b9d20395d435e76fcc0",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "122": {
      "name": "BPG Ingiri B Arial",
      "asset": "preview-fonts/122.woff2",
      "sha256": "50734a9fde321229c26805406a841b8396be1b4402ec3a7dcebf436f0a1f5710",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "123": {
      "name": "BPG Irubaqidze",
      "asset": "preview-fonts/123.woff2",
      "sha256": "385af9e06e7ead4b5554c5a6b224e1fc14500bda97c5f1be1aec54e00d5b0916",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "124": {
      "name": "BPG Irubaqidze",
      "asset": "preview-fonts/124.woff2",
      "sha256": "7270b7a76a1f7a530561cb2428035a9ee71f422957218fca9517c3245345c81f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "125": {
      "name": "BPG Mikheil Stefane",
      "asset": "preview-fonts/125.woff2",
      "sha256": "bea091898aa285b15d589d0c7bdc0e6d0f95acefd4d2d45edb80fa0df46be26b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "126": {
      "name": "Sylfaen (BPG Glaho Sylfaen)",
      "asset": "preview-fonts/126.woff2",
      "sha256": "59ece0e9284e9519c4e1999716dcc762abf7d9dbe4d4623062776f0bcf4ef8d6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "127": {
      "name": "DejaVu Sans (BPG DejaVu Sans)",
      "asset": "preview-fonts/127.woff2",
      "sha256": "f14965b55723399c51e95f5031d3c49faf155cdef18132ddeca90727790eb256",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "128": {
      "name": "DejaVu Sans (BPG DejaVu Sans)",
      "asset": "preview-fonts/128.woff2",
      "sha256": "088cc48bfff0fcc74054d68df851b7f085d8a48fad9f876048c22db7e93471f7",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "129": {
      "name": "BPG Mrgvlovani",
      "asset": "preview-fonts/129.woff2",
      "sha256": "268adc43033b0f217c5c461978085b7a7c7cfe81bccd710edcbb8e52fb95bccb",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "130": {
      "name": "BPG Nino Elite",
      "asset": "preview-fonts/130.woff2",
      "sha256": "c07515747ad3ef1dcfa455f2688d564d05d3406be29899f8f64a44cb254e1f56",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "131": {
      "name": "BPG Nino Elite Caps",
      "asset": "preview-fonts/131.woff2",
      "sha256": "b01c2c644dcda55d7a3d490e68d8eb866baeb920d61305b52faac4f00eb50db7",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "132": {
      "name": "BPG Nino Elite Cond",
      "asset": "preview-fonts/132.woff2",
      "sha256": "d058b768a78ff228f81451c3f081f6c7e42f0f13b49ef13a96ca7ce21d550ec0",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "133": {
      "name": "BPG Nino Elite Cond Caps",
      "asset": "preview-fonts/133.woff2",
      "sha256": "c79143f5b5dadacfdcac3a78efb6db406800c3fb4bc09fa9d85c2e1adc76720b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "134": {
      "name": "BPG Nino Elite Exp",
      "asset": "preview-fonts/134.woff2",
      "sha256": "eaf68dfc6fea2313fa011795f68409ee3475991bf6089b0fd2ef9d55296f826d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "135": {
      "name": "BPG Nino Elite Exp Caps",
      "asset": "preview-fonts/135.woff2",
      "sha256": "5b43b0bc265806cefdf66e0a2c942b428faa89a6009972825bec23c898545cfe",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "136": {
      "name": "BPG Nino Elite Round",
      "asset": "preview-fonts/136.woff2",
      "sha256": "85e06e9d44e0487404a7cd809dac3e4e9f9d63f27339bd83af705075a4b31cf0",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "137": {
      "name": "BPG Nino Elite Round Cond",
      "asset": "preview-fonts/137.woff2",
      "sha256": "81669eb4183531edca7a870d309c1b8035ba652503f2fc686d2f109e33286257",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "138": {
      "name": "BPG Nino Elite Ultra",
      "asset": "preview-fonts/138.woff2",
      "sha256": "ac4a1fba7a5e988de83ccfce727b0cc19215471020492d9d3412d3dd79d923b7",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "139": {
      "name": "BPG Nino Elite Ultra Caps",
      "asset": "preview-fonts/139.woff2",
      "sha256": "1be1e4ed9e57935b38fbfc868de33119a1d3465f11d720186b16993c0e1c43b2",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "140": {
      "name": "BPG Nino Medium",
      "asset": "preview-fonts/140.woff2",
      "sha256": "ebe1d267838fc3c36e2cf902b7dcec780551cd45084384df47d82aa525a6ffdf",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "141": {
      "name": "BPG Nino Medium Caps",
      "asset": "preview-fonts/141.woff2",
      "sha256": "e9793fcabeeefa3ed881e730c25f1effb2e098f178e8c46e0c398de27d960fb4",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "142": {
      "name": "BPG Nino Medium Condenced",
      "asset": "preview-fonts/142.woff2",
      "sha256": "85794338e44821293110d111f2ed14fdecfb61eb9e9a5835d43fe0eb1f970a0a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "143": {
      "name": "BPG Nino Mtavruli",
      "asset": "preview-fonts/143.woff2",
      "sha256": "426b4838de5581cbaebdd509987aa12c323be63c3b00739a472022ab2391b67d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "144": {
      "name": "BPG Nino Mtavruli Book",
      "asset": "preview-fonts/144.woff2",
      "sha256": "7a7ce757e07efda471a7007e80cb01acacbc877ac6063fb524e6b0fcc6b8d5c5",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "145": {
      "name": "BPG Nino Mtavruli Bold",
      "asset": "preview-fonts/145.woff2",
      "sha256": "9fa3a387938bfc6879073b9fc2e3a75ccbb1fba353f96b5074e16f7fac351238",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "146": {
      "name": "BPG Nino Mkhedruli",
      "asset": "preview-fonts/146.woff2",
      "sha256": "fb7da309d0b6abd29e0b9986484b8307da6f5726e2c41bd8e1e788ea37bcd6c7",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "147": {
      "name": "BPG Nino Mkhedruli Bold",
      "asset": "preview-fonts/147.woff2",
      "sha256": "628ea98752e544cf83503e0fac857f84516e71b5b357a72a06d12ad6dcf42591",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "148": {
      "name": "BPG Nino Mkhedruli Book",
      "asset": "preview-fonts/148.woff2",
      "sha256": "78dc66642d66d3e3e716bec18cbcf8a75227d33816ac6baf7cfed16e0939ef50",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "149": {
      "name": "BPG Nino Mtavruli",
      "asset": "preview-fonts/149.woff2",
      "sha256": "f1258391dcce321c7da4b9809b06cfa7d647d074bad307f6bb7f4d9f63a927e8",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "150": {
      "name": "BPG Nino Mtavruli Book",
      "asset": "preview-fonts/150.woff2",
      "sha256": "a7a752d445e7a72c3986594248089ca64ec4b74a47dc89c8981f6a361ded1a57",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "151": {
      "name": "BPG Nino Mtavruli Bold",
      "asset": "preview-fonts/151.woff2",
      "sha256": "5237f088f329dcbc923917f252963ca473c9bd2c8bea2a3bfafe3b8174c3eb41",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "152": {
      "name": "BPG Nino Mkhedruli",
      "asset": "preview-fonts/152.woff2",
      "sha256": "18c0c9646fcf6c6e0d84b7386556170f177308b21fec5f851e5d00b0d0e18be5",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "153": {
      "name": "BPG Nino Mkhedruli Bold",
      "asset": "preview-fonts/153.woff2",
      "sha256": "9357097149de7d89e367c839e7638b40f0196d11930ff13ff67dab8c065edadc",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "154": {
      "name": "BPG Nino Mkhedruli Book",
      "asset": "preview-fonts/154.woff2",
      "sha256": "b788ed8ec0570aac58c374f688644e3454cc4e4fa866ee5e3aeeeb649ffca32b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "155": {
      "name": "BPG Nuskha Modern",
      "asset": "preview-fonts/155.woff2",
      "sha256": "546755e0e167129e33f1ca7c7df26567f46dff2458d997094e1e452eb05e6f18",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": [
          "ც",
          "შ",
          "დ"
        ]
      }
    },
    "156": {
      "name": "BPG Nostalgia",
      "asset": "preview-fonts/156.woff2",
      "sha256": "b2be6abb24c6b8bac51a676f7503291251fcc0211d85c4a77844960e80642da5",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "157": {
      "name": "BPG Nostalgia Bold",
      "asset": "preview-fonts/157.woff2",
      "sha256": "115da87119b6996901b7d8bd77bb9ee69a5364b460f456495508e77f6e249c75",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "158": {
      "name": "BPG Nostalgia",
      "asset": "preview-fonts/158.woff2",
      "sha256": "1c387fd30e446143c80c8cf5959ab2f9dda92f1ab35e65183303d7554a2248ce",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "159": {
      "name": "BPG Nostalgia Bold",
      "asset": "preview-fonts/159.woff2",
      "sha256": "e789f09b17d9b6dfc51aa2618d00f9c5f86189ec0a6ce7bb48035dfd0405cc4c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "160": {
      "name": "BPG Paata",
      "asset": "preview-fonts/160.woff2",
      "sha256": "e786860ef9c641777edc136bbcf2b5193aac3fd736696fe5fd73b4626d1d8e84",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "161": {
      "name": "BPG Paata Caps",
      "asset": "preview-fonts/161.woff2",
      "sha256": "21598685a029c94a8588cbc66018fbc0230b718cda668f0baaa3cd149e59898f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "162": {
      "name": "BPG Paata Cond",
      "asset": "preview-fonts/162.woff2",
      "sha256": "a28ee9553b28ca3e5da1ed0e5a26fb3c408f104a4081cf75b0cbbb67bc59e09b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "163": {
      "name": "BPG Paata Cond Caps",
      "asset": "preview-fonts/163.woff2",
      "sha256": "fe1e52e81a145257869f8a378099d3dd4de348bf29c74ab8939807f8c4fc94e7",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "164": {
      "name": "BPG Paata Exp",
      "asset": "preview-fonts/164.woff2",
      "sha256": "e973adc2fdc53ef3fc17fd7f91bcc6b918fcfb077bda2edec32f4d36ad812a9e",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "165": {
      "name": "BPG Paata Exp Caps",
      "asset": "preview-fonts/165.woff2",
      "sha256": "4193d3025622fd2d45349ae84793d24590ef9f78d7947b27d872873cf8599746",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "166": {
      "name": "BPG Paata Ultra",
      "asset": "preview-fonts/166.woff2",
      "sha256": "d2cccc63f90f350e1e8fc508d4ea4da5e0cf263084d2965e073c13b8f18e98c8",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "167": {
      "name": "BPG Paata Ultra Caps",
      "asset": "preview-fonts/167.woff2",
      "sha256": "5e7f88fe449abc2eab6691c802ec5b2e80738320b555818558a3cf8b2c8d6fca",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "168": {
      "name": "BPG ParaGraph Chveulebrivi",
      "asset": "preview-fonts/168.woff2",
      "sha256": "7810adb5425c4ec4f605d17d34874ad0abe46261bfb53c7adc07bf7b50b04ddb",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 37,
        "ambiguousCharacters": [
          "ჵ",
          "ჴ"
        ]
      }
    },
    "169": {
      "name": "BPG ParaGraph Chveulebrivi",
      "asset": "preview-fonts/169.woff2",
      "sha256": "3af1215dbb76ba412d370ea855ae4e0a62c94c514529e5a3a5f3c8b22d487cb4",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 37,
        "ambiguousCharacters": [
          "ჵ",
          "ჴ"
        ]
      }
    },
    "170": {
      "name": "BPG Square",
      "asset": "preview-fonts/170.woff2",
      "sha256": "f6e75afd7c2ace68b0ef22a49bf4663ea02bd90ed754e0c034a10dc690c416ac",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "171": {
      "name": "BPG Square Mtavruli",
      "asset": "preview-fonts/171.woff2",
      "sha256": "9385b0074c937e8c3d02b1ffd96af83c03d06ebe30fac7d4bd5422ba0aab69d1",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "172": {
      "name": "BPG SuperSquare",
      "asset": "preview-fonts/172.woff2",
      "sha256": "532dbeb5d3ed97c625057fe4c62421a4ad65d167022c39f46c5bbc4d7696fe4f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "173": {
      "name": "BPG SuperSquare Mtavruli",
      "asset": "preview-fonts/173.woff2",
      "sha256": "ecdbfd599ac2ec663dc7412db4b9d063f6c0908f1282e573fda8bee46b61652e",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "174": {
      "name": "BPG QuadroSquare",
      "asset": "preview-fonts/174.woff2",
      "sha256": "0cded74825855d9d485f16a32ba22adfd36fbdedaa35d890442a19a30c8e26eb",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "175": {
      "name": "BPG QuadroSquare Mtavruli",
      "asset": "preview-fonts/175.woff2",
      "sha256": "e4158047b37db58ea46e48f38f1e374e4d5bd4694eb8cc483b934dfdbbc3b52b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "176": {
      "name": "BPG Sans (wo cyrillic)",
      "asset": null,
      "sha256": null,
      "status": "unavailable",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "177": {
      "name": "BPG Sans (w cyrillic)",
      "asset": "preview-fonts/177.woff2",
      "sha256": "b54105c879e3cd81a13b7db0409f19f489dea11cc936126c95c4197c5a98458a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "178": {
      "name": "BPG Serif (wo cyrillic)",
      "asset": "preview-fonts/178.woff2",
      "sha256": "59b493c4d63caae36c273e6bec8d2f1ceb0baf85230c18452a4b60cb290b52db",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "179": {
      "name": "BPG Serif (w cyrillic)",
      "asset": "preview-fonts/179.woff2",
      "sha256": "e1e8cf8f2fa7362ebdd1d3f939cd329099421edb97bafd91f8d3a29dfa098450",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "180": {
      "name": "BPG Tahoma Glaho",
      "asset": "preview-fonts/180.woff2",
      "sha256": "d4b930c8932b6a8e9614e14f70476ea85cded2ec7d1add68195efd3f2cf87ca2",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "181": {
      "name": "BPG Typewriter",
      "asset": "preview-fonts/181.woff2",
      "sha256": "0e107ef76a013bb3cb108f126217922678a3810b8a304155ae2e4e87a9102778",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "182": {
      "name": "BPG Ucnobi",
      "asset": "preview-fonts/182.woff2",
      "sha256": "86b3296358edf7bad0e3a384d0bd9cbaf73e09613132f60b45f963151fdef647",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "183": {
      "name": "BPG Ucnobi",
      "asset": "preview-fonts/183.woff2",
      "sha256": "f9f30f239bc3ffc6b986b63a8cfd93162b91f061607a2a8ef941b508fb91ba1a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "184": {
      "name": "BPG Rioni",
      "asset": "preview-fonts/184.woff2",
      "sha256": "5ff41b55c0b117c1555433591bfc80015ae975ff1b1be4219941f5f86f2d7a2f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "185": {
      "name": "BPG Rioni Arial",
      "asset": "preview-fonts/185.woff2",
      "sha256": "c4e108d185c83ba9082b10b7d87d2a2579bb48ed664ed0b873b607cdace8d1e2",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "186": {
      "name": "BPG Rioni Vera",
      "asset": "preview-fonts/186.woff2",
      "sha256": "12042cbde0e7ff582dd3122741fbbcd91b2e251e2c19d34ee9f5015f299cbe0c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "187": {
      "name": "BPG Rioni Vera Condensed Light",
      "asset": "preview-fonts/187.woff2",
      "sha256": "8149155ff3df3b00d111f2373c8b95d610c12f9492161b4e16ce06dab6b5de95",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "188": {
      "name": "BPG Rioni Contrast",
      "asset": "preview-fonts/188.woff2",
      "sha256": "49817f86fd7a6b35878f4d11f71f0d875a91d105cf2688ecae77108fe6ac6cf5",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "189": {
      "name": "BPG Rioni Vera Light",
      "asset": "preview-fonts/189.woff2",
      "sha256": "6d0be3919e229144ef5a4077f48edb2ca868a3892bdcb926ae46643550bfa954",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "190": {
      "name": "BPG Classic 2008",
      "asset": "preview-fonts/190.woff2",
      "sha256": "cf4bef4249308d09a0acd959908be7209bb573ce001936d2737b4fe38d195316",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "191": {
      "name": "G_NRustaveli",
      "asset": "preview-fonts/191.woff2",
      "sha256": "ba216936b3c527ac9459aedd70b1bdbfb592347445c1a3f1beae1ad519432f5a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "192": {
      "name": "Calligraphy",
      "asset": "preview-fonts/192.woff2",
      "sha256": "f0127fc9c122733a3d5c1241ec31017fb1389f8898e730a50c592b91bfb5a928",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "193": {
      "name": "Chveul",
      "asset": "fonts/193.ttf",
      "sha256": "56ab6dfcc09af0975b198f782c4618b692a06145d1319289a557f1180a010031",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "194": {
      "name": "Chveulebrivi TD Bold",
      "asset": "preview-fonts/194.woff2",
      "sha256": "1124bee20d6a50d188b2d97bf1474b30c8ae99c2b3f70b1e5005b7f06f649538",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "=",
        ".": "\\",
        ":": "|",
        ";": "+",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "Individual browser ASCII glyph chart reviewed 2026-09-30: Russian TD layout; თ=s, ძ=period, ყ=apostrophe, ჯ=slash, ჰ=right bracket. Comma and full stop use equals and backslash.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "195": {
      "name": "Chveulebrivi TD",
      "asset": "preview-fonts/195.woff2",
      "sha256": "0bdf166bd4cde4529fe691a33aa42ab6b4b051be945d75226aab4d9dfb4da489",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "=",
        ".": "\\",
        ":": "|",
        ";": "+",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "Individual browser ASCII glyph chart reviewed 2026-09-30: Russian TD layout; თ=s, ძ=period, ყ=apostrophe, ჯ=slash, ჰ=right bracket. Comma and full stop use equals and backslash.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "196": {
      "name": "Chveulebrivi TD Italic",
      "asset": "preview-fonts/196.woff2",
      "sha256": "edfad7e34d8afe14ec34097d03f10f0082a4fc8d3df70868f6a0eff35b335653",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "=",
        ".": "\\",
        ":": "|",
        ";": "+",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "Individual browser ASCII glyph chart reviewed 2026-09-30: Russian TD layout; თ=s, ძ=period, ყ=apostrophe, ჯ=slash, ჰ=right bracket. Comma and full stop use equals and backslash.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "197": {
      "name": "Chveulebrivi TD Bold-Italic",
      "asset": "preview-fonts/197.woff2",
      "sha256": "244aff4fe142c5cfb7776fee7184105200fb1d29ecb0a5abd4a6a79c3997cfe5",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "=",
        ".": "\\",
        ":": "|",
        ";": "+",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "Individual browser ASCII glyph chart reviewed 2026-09-30: Russian TD layout; თ=s, ძ=period, ყ=apostrophe, ჯ=slash, ჰ=right bracket. Comma and full stop use equals and backslash.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "198": {
      "name": "Chveulebrivi TT",
      "asset": "preview-fonts/198.woff2",
      "sha256": "75e36cc01e31a2c12e91e1eb0f1ecd55e5b749cfdc09ebed0541ef76ca52c50e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "199": {
      "name": "Chveulebrivi TT Oki",
      "asset": "preview-fonts/199.woff2",
      "sha256": "005ab67e5aaa9215daaa67912c238598581b11df1060b86dcff0a7f8f70c7820",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "200": {
      "name": "Chveulebrivy-DB",
      "asset": "preview-fonts/200.woff2",
      "sha256": "b90f4850173c22bbc6a6a176c94701f6bfeb4176046dd1522c370666c2e51ff7",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "201": {
      "name": "ChveuMtavr",
      "asset": "preview-fonts/201.woff2",
      "sha256": "3c0cb52c2e2bdb67ddcfade057a6705f427daee0ea27faf302b8cdd941d36ee9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "202": {
      "name": "ChveuNusx",
      "asset": "preview-fonts/202.woff2",
      "sha256": "3daff3c6dbc5872d7d19c1aec867be3126f65a2bab9c365a18cba4a79ba1cc37",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "203": {
      "name": "Chweulebrivi-Book",
      "asset": "preview-fonts/203.woff2",
      "sha256": "e7a52310673f4099c0a3f5558b831609186148f671bd4eb4af252dce08b80484",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "204": {
      "name": "Constitution",
      "asset": "preview-fonts/204.woff2",
      "sha256": "69109c030b38d619754d26c7856bc31aa0f08c4e41139bd04e427f12a600a381",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "205": {
      "name": "Daviti",
      "asset": "preview-fonts/205.woff2",
      "sha256": "90b944650c2e99fd85ce30775179748a387560b5e58d3495748cc2274d286e87",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "206": {
      "name": "DlgGeo",
      "asset": "preview-fonts/206.woff2",
      "sha256": "a9e79df1355dbe98116b175555692d8879194cbfac13a54b10f5a65d78839883",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "207": {
      "name": "Dumbadze Normal",
      "asset": "preview-fonts/207.woff2",
      "sha256": "2f1f4c8b93fe85b6a7239ddaf6d44d67b4e8d84b6188db30e061ef0c27ecbabb",
      "status": "verified",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "0": ")",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "&",
        "8": "*",
        "9": "(",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "7",
        ".": "8",
        ":": "5",
        ";": "9",
        "!": "+",
        "?": "0",
        "(": "~",
        ")": "`",
        "%": "_",
        "/": "=",
        "—": "2",
        "„": "3",
        "“": "4",
        "№": "1"
      },
      "missing": [],
      "evidence": "2026-10-27: rendered actual preview asset glyph chart and checked all 33 modern Georgian letters, digits, punctuation and newspaper masthead. Russian catalog profile wrongly maps თ to T (ე); use s. Normal and _st have distinct ყ/ძ and punctuation/digit slots.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "208": {
      "name": "Dumbadze Caps GGE",
      "asset": "preview-fonts/208.woff2",
      "sha256": "c523b73cb92f34b8a2cbb111497762e6a636028320bdd1c5a219cc6a7bba49e1",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "209": {
      "name": "Dumbadze Small GGE",
      "asset": "preview-fonts/209.woff2",
      "sha256": "973445998a2e476ccdfa0c2e7b1952d9e7ce0136676ab5f53c251d3d34fcfe76",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "210": {
      "name": "Dumbadze TD",
      "asset": "preview-fonts/210.woff2",
      "sha256": "7d07570a58dd9ea3945e8783b0c331fe6b8758d53b7d4a9e07d2147aee91bc33",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "211": {
      "name": "DumbaMtavr",
      "asset": "fonts/211.ttf",
      "sha256": "94de8cdb869482193f812485e30ef0ec718fc34fa80c48434943b20237fe1cb9",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "212": {
      "name": "DumbaNusx",
      "asset": "fonts/212.ttf",
      "sha256": "65b6918ad8509bf91dc7efef5e7c85b36b8457d6ad38709f436bcb852ba6e95f",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "213": {
      "name": "Eka",
      "asset": "preview-fonts/213.woff2",
      "sha256": "16f8390d0c42cac104a7541152e06961b49cd53727b4078fe48a144391e41997",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "214": {
      "name": "EkaHor",
      "asset": "preview-fonts/214.woff2",
      "sha256": "607ad7062de8e4af983c4d31bc735888bfc1d47be60b49fc8b6446f5f18aa75d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "215": {
      "name": "Fido",
      "asset": "preview-fonts/215.woff2",
      "sha256": "a368bceb64d1037a0173f101b2f34f892c76d35ab3ed06cb18672b2d1c59264b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "216": {
      "name": "GEO DumbaMtavr",
      "asset": "preview-fonts/216.woff2",
      "sha256": "c923f3a5b298125e1f029c63c06e777ac06966058beb69c1de9431687ff64086",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "217": {
      "name": "misha.nd-cristal",
      "asset": "preview-fonts/217.woff2",
      "sha256": "1350eb09f7cc88a3c0537322dc34392ad29a82fb45ea0f836b70eb51b8da6125",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "218": {
      "name": "G&G_Ilia Normal",
      "asset": "preview-fonts/218.woff2",
      "sha256": "b87ebdd9e21c293c8b2e846f06614e46eb5f9d7cf86ad698759d08d3f9809fd8",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "219": {
      "name": "G&G_Ilia Bold",
      "asset": "preview-fonts/219.woff2",
      "sha256": "98cd19fbd9aef15e19fae6d7274d727fa35159a8157cf4aad24b61b527d07ac6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "220": {
      "name": "G&G_IliaM",
      "asset": "preview-fonts/220.woff2",
      "sha256": "baa855f7459eb6abcb1484908f9cdb16a35b5b6703e2bbdcb44f86f718d1e7ee",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "221": {
      "name": "G&G_IliaM Bold",
      "asset": "preview-fonts/221.woff2",
      "sha256": "1147cfc50384840a9528cc90b0d123e3737e40e7e6597e5f3b1f2677e156981d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "222": {
      "name": "G&G_IllliaM Normal",
      "asset": "preview-fonts/222.woff2",
      "sha256": "54988aa48796039ea1b483144ea04e07b28f3f12c7bc15493e224d1addd60657",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "223": {
      "name": "G&G_IllliaM Bold",
      "asset": "preview-fonts/223.woff2",
      "sha256": "3dbaff31d70d1c2349136065049aad20a1f5234d1fd21fb0aeef61812662a05e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "224": {
      "name": "G&G_Kolhety",
      "asset": "preview-fonts/224.woff2",
      "sha256": "8ca83305c1f49f8ad4046390287a5df30b5dc3883ccc1c8ac46c772708db6d48",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "225": {
      "name": "G&G_Kolhety Bold",
      "asset": "preview-fonts/225.woff2",
      "sha256": "791543d243cc8472f34bbc622abcec74faa9e9608d6cb0569de968ce7a554fb6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "226": {
      "name": "G&G_Shirim Normal",
      "asset": "preview-fonts/226.woff2",
      "sha256": "50c8142e4e6a282acd330822d17c75616ecab885a6669e2d95321e301f105931",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "227": {
      "name": "GNMmamuk",
      "asset": "preview-fonts/227.woff2",
      "sha256": "dab80d6e8f52a4b1a2ca61ea0761e4113e4ee299c10b93bb7d34eb8b5442e8c2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "228": {
      "name": "GRustv",
      "asset": "preview-fonts/228.woff2",
      "sha256": "c9de470469097cf93d01da740e11b5b278357348f3597b798261e4bdc55f39bf",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "229": {
      "name": "Geo AcadMtavr",
      "asset": "preview-fonts/229.woff2",
      "sha256": "9ff11c4c631b17d25d3e0dbc356dec63d255d6df353d49dea073e351029f6bbe",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "230": {
      "name": "Geo AcadMtavr Bold",
      "asset": "preview-fonts/230.woff2",
      "sha256": "89826f7e2a081dec3b86b4f378769bdf3add2213add4232b9214e31a16cd8607",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "231": {
      "name": "Geo AcadNusx Normal",
      "asset": "preview-fonts/231.woff2",
      "sha256": "904e4d179c56e8e552905aa6acbbccef00add80583ed59dbe1dd4e08388fb199",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "232": {
      "name": "Geo AcadNusx Bold",
      "asset": "preview-fonts/232.woff2",
      "sha256": "6456779eb522388ecc9f71bdb8a00c0b3f77a1a3ce89303c23c30d09d93f4e8d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "233": {
      "name": "Geo Aladdin",
      "asset": "preview-fonts/233.woff2",
      "sha256": "ac91bc575a821bc239e9dced9ead2d47a3d1565203bf2b25053f621c3196d8d3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "234": {
      "name": "Geo Alami",
      "asset": "preview-fonts/234.woff2",
      "sha256": "5c2f5bd83209442b26d8e957cf03b32e7ef03661da7e40093e49e70dd0c9bf4f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "235": {
      "name": "Geo Amiran",
      "asset": "preview-fonts/235.woff2",
      "sha256": "fadeed67c7c1880622ec7482071c3fac4f0bf18874198ac95fb678a6a6ed378b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "236": {
      "name": "Geo Avaza Mtavr",
      "asset": "preview-fonts/236.woff2",
      "sha256": "fa4edae0047b36532708a7ed676459f9702c1e638d4d201383fe3cf3557e4b80",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "237": {
      "name": "Geo Avaza Nusx",
      "asset": "preview-fonts/237.woff2",
      "sha256": "9388854ea89f927d6cdef1b1ea957d2142c8debd093d5fdd31b0660d00d7f9c9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "238": {
      "name": "Geo Balaveri",
      "asset": "preview-fonts/238.woff2",
      "sha256": "4b481b0011bc707ec00d9684e7c9d2612d1e566fb31b1161730b53540acaca78",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "239": {
      "name": "Geo Bauhaus Nusx",
      "asset": "preview-fonts/239.woff2",
      "sha256": "694569dbaaafeb98d3652ed8262727f3040f1590fa9b30834a8264363c8d77d4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "240": {
      "name": "Geo Bauhaus Mtavr",
      "asset": "preview-fonts/240.woff2",
      "sha256": "e7dea698b85e9bcf70a444db325bea998662e729b669ed52dd1166099611b2be",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "241": {
      "name": "Geo Becker",
      "asset": "preview-fonts/241.woff2",
      "sha256": "fd8cc9b4dd891bd990ee998d534196f79bfa7d9d5f00c3f09dc93a7320b888f3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "242": {
      "name": "Geo Bernhard Fashion",
      "asset": "preview-fonts/242.woff2",
      "sha256": "a13cc4dfd53392b84d752079fcf3d94faf4d338c7733cbccde1d0c4bd092df63",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "243": {
      "name": "Geo Bodoni",
      "asset": "preview-fonts/243.woff2",
      "sha256": "83fb42dbd37a0bd280d48955f156350bafc011e11994b7e1c98d0ad70639a079",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "244": {
      "name": "Geo Bombay",
      "asset": "preview-fonts/244.woff2",
      "sha256": "4b06a585047dc2cbb77756f6adc3bcc5f59f6b5d21190ab358fae8507a526153",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "245": {
      "name": "Geo Bordeaux Mtavr",
      "asset": "preview-fonts/245.woff2",
      "sha256": "ed3866ee338e3b6e4f1b0c0b5a57b1da542d78e99f8198f0e3fe3f3809546f1c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "246": {
      "name": "Geo Bordeaux Nusx",
      "asset": "preview-fonts/246.woff2",
      "sha256": "ec8eb079a38d00611c02be7df4f768ef7191eb171252aec0b1af101f67e4d983",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "247": {
      "name": "Geo Brush Script",
      "asset": "preview-fonts/247.woff2",
      "sha256": "49ba96fc1feed020e0104c6dca52977d5d0082a1c9cd20bc499dda87f3966307",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "248": {
      "name": "Geo Calligraphy",
      "asset": "preview-fonts/248.woff2",
      "sha256": "e708bbd4f2dc0e403d19e1b17cbb3cd3d26a5ef7687117cff7828602ef933965",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "249": {
      "name": "Geo ChveuMtavr Normal",
      "asset": "preview-fonts/249.woff2",
      "sha256": "d5cb11b3620625c33beb9965c2558907415aa1de02b4c306e5cdef0c7689de0d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "250": {
      "name": "Geo ChveuMtavr Bold",
      "asset": "preview-fonts/250.woff2",
      "sha256": "29ceec13693fde1b9ea144830625ab85d402d9a2603a8883779e560c225274d2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "251": {
      "name": "Geo ChveuNusx Normal",
      "asset": "preview-fonts/251.woff2",
      "sha256": "7956876b36a10bbd76e90a5344b9d97985b95a8c86c5d3f12dea9faed18cb0c4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "252": {
      "name": "Geo ChveuNusx Bold",
      "asset": "preview-fonts/252.woff2",
      "sha256": "0b3f0c7d1ee3de2e4fa07101b90f056e8ffac2e7bbe9deaa74a1c0a9dc0ff0cd",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "253": {
      "name": "Geo Dabali",
      "asset": "preview-fonts/253.woff2",
      "sha256": "403ffc2da178d9d984ed97f6d0d9f4bcff793998b4eb4ca1154f8ea22121af36",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "254": {
      "name": "Geo Dedaena",
      "asset": "preview-fonts/254.woff2",
      "sha256": "953fb4217b59e77d5f88a5bf59bb8568187a598c18efaed4217c10374fc65754",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "255": {
      "name": "Geo Devi",
      "asset": "preview-fonts/255.woff2",
      "sha256": "8bd0449643a0cf07991d0b16f52f33e1a82c4e9bab98fc05dc8e68c5f41f5a1c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "256": {
      "name": "Geo Dochanashvili Mtavr",
      "asset": "preview-fonts/256.woff2",
      "sha256": "3788ad52239b4c27d9692f9308437b1692856b53a9c3eef8b3df645d942e9449",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "257": {
      "name": "Geo Dochanashvili Nusx",
      "asset": "preview-fonts/257.woff2",
      "sha256": "13dccd7084663291a71f697bdaf992ed0fcf49021aeeb7e1c21552198b5c51d7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "258": {
      "name": "Geo Dumbadze Mtavr",
      "asset": "preview-fonts/258.woff2",
      "sha256": "bd0953034e679ee655a327983359c7049e0b77261a2415a5b8e65f9a758bcae7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "259": {
      "name": "Geo Dumbadze Mtavr Bold",
      "asset": "preview-fonts/259.woff2",
      "sha256": "149b8d167dff52ddff3fcd7201f4eedc990fd927f15c2516c7b912bab859413d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "260": {
      "name": "Geo Dumbadze Mtavr Bold Italic",
      "asset": "preview-fonts/260.woff2",
      "sha256": "1df75459778c101b636af5aceab4097b9314e203a4d2bc6a8918d453a777825d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "261": {
      "name": "Geo Dumbadze Mtavr Italic",
      "asset": "preview-fonts/261.woff2",
      "sha256": "1b3d354bcfc7572ae51777f2d1e76a3cae7b065217551638b081f5693d149930",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "262": {
      "name": "Geo Dumbadze Nusx",
      "asset": "preview-fonts/262.woff2",
      "sha256": "f273b031066ae6066311352d02d6d930ed8fec71217da646f1da0716d144ced0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "263": {
      "name": "Geo Dumbadze Nusx Bold",
      "asset": "preview-fonts/263.woff2",
      "sha256": "7e1bef4068e2f1cec3c7439399e85d839b4a5b66f1a9597761410668dc554033",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "264": {
      "name": "Geo Dumbadze Nusx Bold Italic",
      "asset": "preview-fonts/264.woff2",
      "sha256": "f72529cae6657adb21e7a0adc322f6914426a82d96e1dd66d6db2e78e9d32674",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "265": {
      "name": "Geo Dumbadze Nusx Italic",
      "asset": "preview-fonts/265.woff2",
      "sha256": "b7932411203f567c3528b4b337c255f4a636571e9659d562fb540e71b2b7d82d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "266": {
      "name": "Geo Eka",
      "asset": "preview-fonts/266.woff2",
      "sha256": "65c2b81c4409296ce01b3e357b4e2b37161f54e3586375bb6e43ab1a0128d2e0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "267": {
      "name": "Geo Eklesia",
      "asset": "preview-fonts/267.woff2",
      "sha256": "51e1a9c9027e41785492f3a2f8bd4cf02e2c4e2d97b071a42da61a36b251baa7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "268": {
      "name": "Geo Elguja",
      "asset": "preview-fonts/268.woff2",
      "sha256": "30197054359aa82b503cb0a7f119d824bba76b7143068770665fe8c6c0810ddf",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "269": {
      "name": "Geo Gedi Mze",
      "asset": "preview-fonts/269.woff2",
      "sha256": "f247b902f9279eff2e2033693d85cfcf12a49961f7f40edbd1634a763912cbac",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "270": {
      "name": "Geo George",
      "asset": "preview-fonts/270.woff2",
      "sha256": "79e1e60fcd8f1e013b7c49b3c3ae6ef8c0a635e26153d1de70995d286f1ec348",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "271": {
      "name": "Geo Gogebashvili Regular",
      "asset": "preview-fonts/271.woff2",
      "sha256": "55683ea8d7cbe8007b1d14dc484eecb21c903190431fa8cbfdfc8b48cc3c54c3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "272": {
      "name": "Geo Gorda",
      "asset": "preview-fonts/272.woff2",
      "sha256": "037c6bb588cc272c8255f7aeeac56bd99fd73e29cc3ee051be2e87187564033f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "273": {
      "name": "Geo Gordeladze",
      "asset": "preview-fonts/273.woff2",
      "sha256": "87d0fff3dde2a5a689e25c1f002fb1be3eb0fe19998e3b88544c255a3b698f58",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "274": {
      "name": "Geo Gothic",
      "asset": "preview-fonts/274.woff2",
      "sha256": "82aa159f0b56a446fadec5d2405c171c56e2ead8d0d4fcbf573c39d750768acb",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "275": {
      "name": "Geo Graniti",
      "asset": "preview-fonts/275.woff2",
      "sha256": "3af6a5ed61e7dfad14f9399f3167e9fda9d7e2c80c46490e1dbad209f5d40182",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "276": {
      "name": "Geo Gremi",
      "asset": "preview-fonts/276.woff2",
      "sha256": "9d9c68ca6a341979d09884e31b2aa0db46100b7cb230c300056f5ff37e203f1a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "277": {
      "name": "Geo Grigolia Mtavr",
      "asset": "preview-fonts/277.woff2",
      "sha256": "2cf450600d23db1fc0d2bdcea95914d846d5828b90f9c63573796e9d68b8c949",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "278": {
      "name": "Geo Grigolia Mtavr Bold",
      "asset": "preview-fonts/278.woff2",
      "sha256": "f047965744a76b9e5c0404907dd94bba723cbc0cd726b2b6ae272bdd178281df",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "279": {
      "name": "Geo Grigolia Nusx",
      "asset": "preview-fonts/279.woff2",
      "sha256": "49824da4430c40adb0b89ea1ea9f23e3af72ae155221ac2cdbeab7ebc17d47a1",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "280": {
      "name": "Geo Grigolia Nusx Bold",
      "asset": "preview-fonts/280.woff2",
      "sha256": "e03e0b2dc475caaf7c53ec8fef25d2f70576e2430b117c139bf9fb94bafeda63",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "281": {
      "name": "Geo GrigoliaPolygraph",
      "asset": "preview-fonts/281.woff2",
      "sha256": "b77d8f729976427f73dc0a9943a1c040f17b5127851aa8d598efe12136330fef",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "282": {
      "name": "Geo GrigoliaPolygraph Bold",
      "asset": "preview-fonts/282.woff2",
      "sha256": "f003a4550bd994d7544e94d2e9facd1cdc8553e4e299942926e3bbc1cbedf3b4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "283": {
      "name": "Geo Grotesk",
      "asset": "preview-fonts/283.woff2",
      "sha256": "ca9e4bf22cf2829e24fbe7223aae7c5cda6cecfc76d73076515914f9b0aad431",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "284": {
      "name": "Geo Ilia Mtavr Normal",
      "asset": "preview-fonts/284.woff2",
      "sha256": "cdd443b869f6bb45fd74b1f14ffb4ad7d054e197d1de0912ab2776c2bd0cb461",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "285": {
      "name": "Geo Ilia Mtavr Bold",
      "asset": "preview-fonts/285.woff2",
      "sha256": "fdca2e863a5c846a48c78e65ca3e2453f73b8cd8a1674e79dfb8aa5ee65ec858",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "286": {
      "name": "Geo Ilia Nusx Normal",
      "asset": "preview-fonts/286.woff2",
      "sha256": "d04fd0b3a2659b5784529cc8fecc3eb3c0e963bb34adbb9b4b21130603e11816",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "287": {
      "name": "Geo Ilia Nusx Bold",
      "asset": "preview-fonts/287.woff2",
      "sha256": "534bcd635598ffae2c32be3d3c57ed89002e32d1950917ddd533ec969f61c855",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "288": {
      "name": "Geo Institution",
      "asset": "preview-fonts/288.woff2",
      "sha256": "5b56b79da4beb7da7a772035e057d4d8f685be2248fc8cd16c7680b0a43a5122",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "289": {
      "name": "Geo Kalami Mtavr",
      "asset": "preview-fonts/289.woff2",
      "sha256": "23f9dbc0f38adf50cdf669acdac17f7a1701f651c33e365fbe4ab192301abab0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "290": {
      "name": "Geo Kalami Nusx",
      "asset": "preview-fonts/290.woff2",
      "sha256": "9d546daf10423d591d1519b09f4a7daddeb7a55ed1d881d6cbe31980db144fe2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "291": {
      "name": "Geo Katerina",
      "asset": "preview-fonts/291.woff2",
      "sha256": "2846265a5bef94524f3e715326873303640b5768324b0cf1939c68eb30fac963",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "292": {
      "name": "Geo Kiknadze",
      "asset": "preview-fonts/292.woff2",
      "sha256": "c3434a9cd271ad21ec6b7c369fa24057567a0e868ced46a6f73d45deae290057",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "293": {
      "name": "Geo Kokhodze",
      "asset": "preview-fonts/293.woff2",
      "sha256": "03ca83b92ed1e438e93bc4c766fd0f9e026672949c3cac48008d7683af22e9ad",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "295": {
      "name": "Geo Kolkheti Mtavr Normal",
      "asset": "preview-fonts/295.woff2",
      "sha256": "54d1fdc6de8ad815fe77a819d44fb99be995662617fe614ff57cff7a46badfb0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "296": {
      "name": "Geo Kolkheti Mtavr Bold",
      "asset": "preview-fonts/296.woff2",
      "sha256": "5d2a2dfaf36371c16bc6758d82d6fd06bfbe8b84071d49e706b74ed18494f51b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "297": {
      "name": "Geo Kolkheti Nusx Bold",
      "asset": "preview-fonts/297.woff2",
      "sha256": "b232d91ecd6ddf85a6575238bafbfa7735714270d842dcc943ce61f259ad5c80",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "298": {
      "name": "Geo Kolkheti Nusx Normal",
      "asset": "preview-fonts/298.woff2",
      "sha256": "73974c7ce6e6faccb8d96cd384295ee8e0fdf9e5f96757b53642d0296970c6c8",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "299": {
      "name": "Geo Kvamli",
      "asset": "preview-fonts/299.woff2",
      "sha256": "c42c6487b79e615a84dd2c59885643eb89bf310ada8a1e7fcb7d66a4c3b6fa50",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "300": {
      "name": "Geo Kvebliani",
      "asset": "preview-fonts/300.woff2",
      "sha256": "dcd3e37059fa6a8d6d006456acb7fdb0321c3230a8f9f88a4bca48a246038667",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "301": {
      "name": "Geo Lado Grigolia",
      "asset": "preview-fonts/301.woff2",
      "sha256": "7576357197f2124fddef35b09a405a689803c6adf7528542cd7d323d87e737e1",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "302": {
      "name": "Geo LiterMtavr Normal",
      "asset": "preview-fonts/302.woff2",
      "sha256": "90b799582b95515c8fb38d1c67cb7f35fec5e742ae1f728323ef867d88bc125d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "303": {
      "name": "Geo LiterMtavr Bold",
      "asset": "preview-fonts/303.woff2",
      "sha256": "31a82922b37930c86b33dd02a4b846f03e7183cc51688a5c5cb1aa4fa0fa335a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "304": {
      "name": "Geo LiterNusx Normal",
      "asset": "preview-fonts/304.woff2",
      "sha256": "841555d979bb801c264327f2da7e7bc7a06587f502fd145ccfb5dd134dde73d3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "305": {
      "name": "Geo LiterNusx Bold",
      "asset": "preview-fonts/305.woff2",
      "sha256": "6c0fc727cccff22290b21409a1eaa52117948c78e651b7b1e92f12ee92ab9487",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "306": {
      "name": "Geo Lordkipanidze TT",
      "asset": "preview-fonts/306.woff2",
      "sha256": "73e46589c05b9aa5b51dc6a7906c58063595adeb9da333b59eb7a3c33e8a5eb7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "307": {
      "name": "Geo Lortkipanidze Normal",
      "asset": "preview-fonts/307.woff2",
      "sha256": "2aaa976540234c8bd37fdfe7aef2f13ef4a56db5597dc8e197589c9b9337eec4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "308": {
      "name": "Geo Lortkipanidze Bold",
      "asset": "preview-fonts/308.woff2",
      "sha256": "83f1e57bc0dc43f72a77750897f8beaabd3de1a06cc749a4e55e53a80abbc36c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "309": {
      "name": "Geo LortkipanidzeMtavr Normal",
      "asset": "preview-fonts/309.woff2",
      "sha256": "a248c9151d7b2afd24c1b0b187d3ae144e90af80805aa5cfac953d082d7ffaab",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "310": {
      "name": "Geo LortkipanidzeMtavr Bold",
      "asset": "preview-fonts/310.woff2",
      "sha256": "835a5dc144dce984795673c4d437c440562c514323c4da67599a1e9fda399f10",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "311": {
      "name": "Geo Maghali",
      "asset": "preview-fonts/311.woff2",
      "sha256": "17d350986fc755de79366721e39cae2fff03224e98b41ebc599bcd5a2bdf31f5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "312": {
      "name": "Geo Martve",
      "asset": "preview-fonts/312.woff2",
      "sha256": "e52df8d6c570e885800176297965d9ca3c2b03523e5f4f2b1d1d51a2490f3358",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "313": {
      "name": "Geo Mdzimiseburi Normal",
      "asset": "preview-fonts/313.woff2",
      "sha256": "eca1009190653b10dd4ca367ca12014be92c1c9245d18adcf6f61edcddb213a6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "314": {
      "name": "Geo Mistral",
      "asset": "preview-fonts/314.woff2",
      "sha256": "c4dba2cd2a2cdeaab1bf50a65ff53752f9729db7ef82caa201c059b8f4e1539b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "315": {
      "name": "Geo Mrgvlovani Normal",
      "asset": "preview-fonts/315.woff2",
      "sha256": "a65d769912920185c7ba520abba32597d0911e1e33bff0b363e36d223a68f547",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "316": {
      "name": "Geo Mrude Normal",
      "asset": "preview-fonts/316.woff2",
      "sha256": "7ae600dd22fc950419de88fcaf344e16e2a281c935a9b04518b5cd2cb22789fd",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "317": {
      "name": "Geo Mziuri Mtavr",
      "asset": "preview-fonts/317.woff2",
      "sha256": "8ce24a403668c48d1673232915365e44568d9c8df775bca8202111884a251ef0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "318": {
      "name": "Geo Mziuri Nusx",
      "asset": "preview-fonts/318.woff2",
      "sha256": "7a76b2b35248f1b62f9d1466aa654cb3d0976f68a6f71f4fe8630f96b8caa16e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "319": {
      "name": "Geo Naniko",
      "asset": "preview-fonts/319.woff2",
      "sha256": "b526a54dea1fb04bf3ec8ded89c6277ba3a08f19c59ab4f2a29ea43b13f81af1",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "320": {
      "name": "Geo Nana Zhorzholadze",
      "asset": "preview-fonts/320.woff2",
      "sha256": "b552d5adb32776a62868a6b31f9502fdec6577e30d2e159969c6540a02493338",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "321": {
      "name": "Geo Napraliani",
      "asset": "preview-fonts/321.woff2",
      "sha256": "018d5a522f734a1222db53b976623876a36068cac1cba7334f09020b3a9e6c5e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "322": {
      "name": "Geo Orqidea",
      "asset": "preview-fonts/322.woff2",
      "sha256": "4bdf41cb3216871a9b8ea2994eca94d1213449f93ff36c219d7a73218f3edc3a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "323": {
      "name": "Geo Pakizi",
      "asset": "preview-fonts/323.woff2",
      "sha256": "43779b2e12af57c9fc5a0cb230d8f64861c11ed4b87b4b5c75b0ee84ea3b6210",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "324": {
      "name": "Geo Paragraphic",
      "asset": "preview-fonts/324.woff2",
      "sha256": "7d87126ddbac44dad8ea4815f060f75181309596f47830672c2040f3453fdc93",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "325": {
      "name": "Geo Phunji Mtavr",
      "asset": "preview-fonts/325.woff2",
      "sha256": "ca20f7c57502293c1bf608d754b40eb226c191b0bd8eb1b9067be2f5f4fafc1c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "326": {
      "name": "Geo Phunji Nusx",
      "asset": "preview-fonts/326.woff2",
      "sha256": "e479b8be0c8e33c1db3bb7d514c1e072a745e350af53587141b4171c8d2e5991",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "327": {
      "name": "Geo Picasso",
      "asset": "preview-fonts/327.woff2",
      "sha256": "0dffdfc0950e91fb224bdab41166086ecb85c91eafc4b62dde6b6e337248f90c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "328": {
      "name": "Geo Preston",
      "asset": "preview-fonts/328.woff2",
      "sha256": "1e1b729b84efb4cc62e6e70766143d8ae08a4207b62b85e7d1486985bf0ee6a7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "329": {
      "name": "Geo Rustaveli",
      "asset": "preview-fonts/329.woff2",
      "sha256": "146fb7e2b93f71af84b1ea04e138d78c9a3524fbece18cc77b1e1abd97056515",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "330": {
      "name": "Geo Sabechdi Nusx",
      "asset": "preview-fonts/330.woff2",
      "sha256": "1cb496d62d90b1059146a8fbddd27bf78c176256d8542707c8963503ff73e037",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "331": {
      "name": "Geo Sabechdi Mtavr",
      "asset": "preview-fonts/331.woff2",
      "sha256": "575733801a103801e3c2c6a2a48d5d97fecf6dad97ce923797c7d06f09407b77",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "332": {
      "name": "Geo SakarMtavr",
      "asset": "preview-fonts/332.woff2",
      "sha256": "615e9cab6b8852c0d58d055fa58f62781482b6db1962f1f167a65b6f56584579",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "333": {
      "name": "Geo Salkhino",
      "asset": "preview-fonts/333.woff2",
      "sha256": "6fc5883cb3c9ad7ff14926a980dbd4bf1a9d4dc761427e51f1e07d9573fa0f9f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "334": {
      "name": "Geo Script",
      "asset": "preview-fonts/334.woff2",
      "sha256": "fc4b8e9736fb1f5fb9e46b770717e7a3413475a34bcd4e7e164f0415d0807d74",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "335": {
      "name": "Geo Shemoqmedi",
      "asset": "preview-fonts/335.woff2",
      "sha256": "cf9eed3359c3a4263cc78311ea0fcb0fbbf254cceee9f771766699cd9cab8d92",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "336": {
      "name": "Geo Shesha",
      "asset": "preview-fonts/336.woff2",
      "sha256": "28f6d805319be391c40479fb658ad0fd600e06b32979084c6b17e22e5ce3d90d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "337": {
      "name": "Geo Shirim",
      "asset": "preview-fonts/337.woff2",
      "sha256": "e72b57d8d86e3268c6c7fc98f09e98d790d49ea1728e07067bff09150c050729",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "338": {
      "name": "Geo Siradze",
      "asset": "preview-fonts/338.woff2",
      "sha256": "fe0fa118dec1a5e58f81d47bb052ac6545ed81967fa0516ae5615e015e377f27",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "339": {
      "name": "Geo Slim",
      "asset": "preview-fonts/339.woff2",
      "sha256": "ad628b66a1c9b94e5e511592b2c7d22e7a16886f1d7345752782c4ddefa6228d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "340": {
      "name": "Geo Tabidze",
      "asset": "preview-fonts/340.woff2",
      "sha256": "7e738dbe92d148dcb2a3a7651724ebd4a8f650b858d3df9d77a96a3f86159a07",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "341": {
      "name": "Geo Tbilisi Nusx",
      "asset": "preview-fonts/341.woff2",
      "sha256": "571f7035f80e26722cffcda245270600e3af2781f070c54be0ba7eadc09214dc",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "342": {
      "name": "Geo Tbilisi Mtavr",
      "asset": "preview-fonts/342.woff2",
      "sha256": "32b1160b00bab6e1fe410b291fd54da06611c1a7fef8d7e4744f9ce26ddc6270",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "343": {
      "name": "Geo Tiko",
      "asset": "preview-fonts/343.woff2",
      "sha256": "2dd3d246a30b14d1ef557689885038db8feff6c7b964fdc2a9b5f26433564b04",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "344": {
      "name": "Geo Times Georgian",
      "asset": "preview-fonts/344.woff2",
      "sha256": "bdb6009590157ee48e14cbe84324d728a8d2948bda9c49f7eaf2a94a50bdf8fb",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "345": {
      "name": "Geo Times Mtavr",
      "asset": "preview-fonts/345.woff2",
      "sha256": "9cb8b6cc86cf2dc84b10a9648a98c2f20edc69190f3125efe9742e4826f01ea1",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "346": {
      "name": "Geo Times Nusx",
      "asset": "preview-fonts/346.woff2",
      "sha256": "c6a31bb1eec70ba536ddb8106a5eb2736ebbcaa91ce035a6b9e699ddc843c536",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "347": {
      "name": "Geo Veziri Mtavr",
      "asset": "preview-fonts/347.woff2",
      "sha256": "03113ce374c0ff97495c37dc0615784223eebd1cce637cc00683c503e0e9e060",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "348": {
      "name": "Geo Veziri Nusx",
      "asset": "preview-fonts/348.woff2",
      "sha256": "e75588fbb4067f404869e3b63980b41292c1e2ffd4f864af92696eaa031e5099",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "349": {
      "name": "Geo Vicro",
      "asset": "preview-fonts/349.woff2",
      "sha256": "16c5a24ef26ebd3322758b8a6b12843ed61dfb13656497cddaca2dacf4ff7579",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "350": {
      "name": "Geo Vicro ASTER",
      "asset": "preview-fonts/350.woff2",
      "sha256": "c1dc1942cfc8df7b45cbfefaa3b7a7f96f43ca8d5736ed1563db444c555494fa",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "351": {
      "name": "Geo Victoria Normal",
      "asset": "preview-fonts/351.woff2",
      "sha256": "bc2ec4d5967b2cfe50aee69ed87eb0a55d88fe91392e0cfcdc4579346806e32b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "352": {
      "name": "Geo Xelnaceri",
      "asset": "preview-fonts/352.woff2",
      "sha256": "06b548822db7d5a569afb983421496bf9a5c7862a7aa6c84ca13766fff6c238e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "353": {
      "name": "Geo Xibli",
      "asset": "preview-fonts/353.woff2",
      "sha256": "9024eb5b0e92e0aab44b65e42328670bffc31a7b735263a3b24697f77511423e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "354": {
      "name": "Geo XucurNusx",
      "asset": "preview-fonts/354.woff2",
      "sha256": "fb56e622c999f18b8d73ef55f4a94919067905aaec299051d8e63917f221f819",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "355": {
      "name": "Geo Zaza",
      "asset": "preview-fonts/355.woff2",
      "sha256": "07f818b89848ec3753a5a77938aac18646363a5d9a7cfbcac0afcd61cc01e7a4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "356": {
      "name": "Geo Zghapari Nusx",
      "asset": "preview-fonts/356.woff2",
      "sha256": "97135fe1f1a6e386299fa1cfb80ff6575692786569a35d150e9b4080b2772969",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "357": {
      "name": "Geo Zghapari Nusx ASTER",
      "asset": "preview-fonts/357.woff2",
      "sha256": "4b3e027b124de5ec86a9bc6cad36609be2adafe9972063fc9e97738b49fbc3b7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "358": {
      "name": "Geo Zghapari Mtavr",
      "asset": "preview-fonts/358.woff2",
      "sha256": "7a3c11099e6af18898022432f64ec40c56a9f543d285da3bbacc8de1efca34b3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "359": {
      "name": "Geo Zghapari Mtavr ASTER",
      "asset": "preview-fonts/359.woff2",
      "sha256": "8b86f93eb7b61b22575fde14a633277101697b23474f6d4a8050ae7c2f81f9f2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "360": {
      "name": "G_Beker",
      "asset": "preview-fonts/360.woff2",
      "sha256": "c1a8deb5c30f207a7a82d69413ae1e789d080a020af323e9f56b4403f02917f2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "361": {
      "name": "Gancxadebebi",
      "asset": "fonts/361.ttf",
      "sha256": "6486aa5f63f554a5807711ba7af2f5bea819b0059ef6d46f1a22e55147b0ae22",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "362": {
      "name": "Geo ABC",
      "asset": "preview-fonts/362.woff2",
      "sha256": "1ba948b96e7b5e343c408a3f2682f2b0a7cf8d72446fbd54600b919fe3a1188c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "363": {
      "name": "Geo_Academiuri",
      "asset": "preview-fonts/363.woff2",
      "sha256": "887852ea85a7e919dcd5dd23fcbf49e34cc9c6ba263e919dc9cf23de55c82105",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "364": {
      "name": "Geo_Academiuri Italic",
      "asset": "preview-fonts/364.woff2",
      "sha256": "f8793e53b329ffd9b78d657c723f213f3c3b2b2955262b203d25933249d00952",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "365": {
      "name": "GEO_AKADEMIURI",
      "asset": "preview-fonts/365.woff2",
      "sha256": "64c54f2d096fe9129cdd0e8b2a93ce64405f3d64e8974cc0de49b783a8bb93ca",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "366": {
      "name": "Geo_Arial",
      "asset": "preview-fonts/366.woff2",
      "sha256": "11694bf6cff336237b81a13e30f5b4f92f84f434fd71ed786de65e67f5a77364",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "367": {
      "name": "Geo_Arial Bold",
      "asset": "preview-fonts/367.woff2",
      "sha256": "6518a61eb267de678c86e2c66a7b5d0202b9e98ad521f3043c731f8352cd33d4",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "368": {
      "name": "Geo_Arial Italic",
      "asset": "preview-fonts/368.woff2",
      "sha256": "a409be3ee8135ebec4c7cf5b8eb7adc685968b9fe684088d8d77d5c18912f5ca",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "369": {
      "name": "Geo_Arial Bold Italic",
      "asset": "preview-fonts/369.woff2",
      "sha256": "d4c6ca1a3fddcf41efca2388e478d4a7bafbe1819f8e8be1231e179103f5e5f8",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "370": {
      "name": "Geo_Courier",
      "asset": "preview-fonts/370.woff2",
      "sha256": "7746d2e7dc55b531eb5be705345e3b1990deca50b1aa4d409d1b77e3fc069a37",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "371": {
      "name": "Geo_Courier Bold",
      "asset": "preview-fonts/371.woff2",
      "sha256": "006262b693d704a69b56abb248b578b15dd73704355ff7ba5daac0b8bec61c2f",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "372": {
      "name": "Geo_Courier Italic",
      "asset": "preview-fonts/372.woff2",
      "sha256": "0cd67bbeb9986f39f41f0d0d84eb846e276604e0046cf547fda494792af681b0",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "373": {
      "name": "Geo_Courier Bold Italic",
      "asset": "preview-fonts/373.woff2",
      "sha256": "fba5d57e43f38e3c1507a2dfbdcd574752be49016c6132c074f68d76396a02e9",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "374": {
      "name": "Geo_Dumbadze",
      "asset": "preview-fonts/374.woff2",
      "sha256": "b668f306b947bbb789b34e638a5d1126f1c02aac43d132ed2856eea787efca2e",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "375": {
      "name": "Geo_Dumbadze Italic",
      "asset": "preview-fonts/375.woff2",
      "sha256": "6b7cfcafb4bbcef1feb0e0d6df96f065928f0b8802ed1d132bbfbe694277aa12",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "376": {
      "name": "GEO_DUMBADZE_MT",
      "asset": "preview-fonts/376.woff2",
      "sha256": "3cff13bc0287f70c7ea802d7fdc26d895462353fc43320ccdd949b53b90d5154",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "377": {
      "name": "GEO_KOLHETI",
      "asset": "preview-fonts/377.woff2",
      "sha256": "f248503e4b42651c06f01c8d32b32a6447baea354cc2eefb763af4925bae0c92",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "378": {
      "name": "GEO_KOLHETI_MT",
      "asset": "preview-fonts/378.woff2",
      "sha256": "9f1ee7fa9ef35e8b5f7800c8526e4518cd28342e4d9fc001e1c4317301e3bddd",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "379": {
      "name": "Geo_Kolkheti",
      "asset": "preview-fonts/379.woff2",
      "sha256": "9facd8209a85aaa2d5d1ff714a48699077c7c2e2e73abdb0d96e181e8b26a56c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "380": {
      "name": "Geo_Kolkheti Bold",
      "asset": "preview-fonts/380.woff2",
      "sha256": "5f57875301bc59ce42245fe1b304aeac8da2fd228b26bec958347770c668b4f5",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "381": {
      "name": "Geo_Kolkheti Italic",
      "asset": "preview-fonts/381.woff2",
      "sha256": "fe34d6683f6c9dd2c754d1ae5b4f4098536667c95cb4d920c2e81af9967c3f0c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "382": {
      "name": "Geo_Kolkheti Bold Italic",
      "asset": "preview-fonts/382.woff2",
      "sha256": "5255c93fd0b57a1ad5de9919bf63e56679f192f0f04523479abdb58696e60a89",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "383": {
      "name": "Geo_Lit",
      "asset": "preview-fonts/383.woff2",
      "sha256": "32e593886245fcd8bf3ac2a711c070a27b6b1bf85e03f3ab18199651e37a9ed3",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "384": {
      "name": "Geo_Literaturuli",
      "asset": "preview-fonts/384.woff2",
      "sha256": "5d061993ac03cafe4fae5cd40175aa8c02a8aa43d784e6d343c86cbe0289d8e3",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "385": {
      "name": "Geo_Literaturuli Bold",
      "asset": "preview-fonts/385.woff2",
      "sha256": "a61c4ca2e8a04fca9f03f3678c14ff40cd6d0a4d0510afd14970b7930e1f2b8d",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "386": {
      "name": "Geo_Literaturuli Italic",
      "asset": "preview-fonts/386.woff2",
      "sha256": "fdab855955472480d8df5c73b2c939f2d99f9501621799438f582dd9be2d3648",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "387": {
      "name": "Geo_Literaturuli Bold Italic",
      "asset": "preview-fonts/387.woff2",
      "sha256": "1732f9f0f13438c6a4c23af968570594e1ee68f92195df69f4b73a27997fa9a9",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "388": {
      "name": "Geo Literaturuly N",
      "asset": "preview-fonts/388.woff2",
      "sha256": "fc356981ceb5d929d65ebc3238a616441e54683724be27b0958e8b194e3d7d25",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "â",
        "დ": "ã",
        "ე": "ä",
        "ვ": "å",
        "ზ": "æ",
        "თ": "ç",
        "ი": "è",
        "კ": "é",
        "ლ": "ê",
        "მ": "ë",
        "ნ": "ì",
        "ო": "í",
        "პ": "î",
        "ჟ": "ï",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "õ",
        "ღ": "ö",
        "ყ": "÷",
        "შ": "ø",
        "ჩ": "ù",
        "ც": "ú",
        "ძ": "û",
        "წ": "ü",
        "ჭ": "ý",
        "ხ": "þ",
        "ჯ": "ÿ",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "Individual U+00A0–U+00FF browser glyph chart reviewed 2026-09-30: modern Georgian alphabet at E0–FF and ჰ at B8; not generic STD8.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "389": {
      "name": "Geo Literaturuly N Italic",
      "asset": "preview-fonts/389.woff2",
      "sha256": "ef0b54c99eaf24b9746885ef3feee7bdd6232d444b30aab5bcd44aaba1519bf5",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "â",
        "დ": "ã",
        "ე": "ä",
        "ვ": "å",
        "ზ": "æ",
        "თ": "ç",
        "ი": "è",
        "კ": "é",
        "ლ": "ê",
        "მ": "ë",
        "ნ": "ì",
        "ო": "í",
        "პ": "î",
        "ჟ": "ï",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "õ",
        "ღ": "ö",
        "ყ": "÷",
        "შ": "ø",
        "ჩ": "ù",
        "ც": "ú",
        "ძ": "û",
        "წ": "ü",
        "ჭ": "ý",
        "ხ": "þ",
        "ჯ": "ÿ",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "Individual U+00A0–U+00FF browser glyph chart reviewed 2026-09-30: modern Georgian alphabet at E0–FF and ჰ at B8; not generic STD8.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "390": {
      "name": "Geo Literaturuly N Bold",
      "asset": "preview-fonts/390.woff2",
      "sha256": "fa25a50be417f3887450560eabae67a4ea7dd4f14e649d3dd6d45d2aae1d8af8",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "â",
        "დ": "ã",
        "ე": "ä",
        "ვ": "å",
        "ზ": "æ",
        "თ": "ç",
        "ი": "è",
        "კ": "é",
        "ლ": "ê",
        "მ": "ë",
        "ნ": "ì",
        "ო": "í",
        "პ": "î",
        "ჟ": "ï",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "õ",
        "ღ": "ö",
        "ყ": "÷",
        "შ": "ø",
        "ჩ": "ù",
        "ც": "ú",
        "ძ": "û",
        "წ": "ü",
        "ჭ": "ý",
        "ხ": "þ",
        "ჯ": "ÿ",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "Individual U+00A0–U+00FF browser glyph chart reviewed 2026-09-30: modern Georgian alphabet at E0–FF and ჰ at B8; not generic STD8.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "391": {
      "name": "Geo Literaturuly N Bold Italic",
      "asset": "preview-fonts/391.woff2",
      "sha256": "a344875b76b9673368de078437e6bb7460faca15561ae688766b9bf66fe00f5f",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "à",
        "ბ": "á",
        "გ": "â",
        "დ": "ã",
        "ე": "ä",
        "ვ": "å",
        "ზ": "æ",
        "თ": "ç",
        "ი": "è",
        "კ": "é",
        "ლ": "ê",
        "მ": "ë",
        "ნ": "ì",
        "ო": "í",
        "პ": "î",
        "ჟ": "ï",
        "რ": "ð",
        "ს": "ñ",
        "ტ": "ò",
        "უ": "ó",
        "ფ": "ô",
        "ქ": "õ",
        "ღ": "ö",
        "ყ": "÷",
        "შ": "ø",
        "ჩ": "ù",
        "ც": "ú",
        "ძ": "û",
        "წ": "ü",
        "ჭ": "ý",
        "ხ": "þ",
        "ჯ": "ÿ",
        "ჰ": "¸"
      },
      "missing": [],
      "evidence": "Individual U+00A0–U+00FF browser glyph chart reviewed 2026-09-30: modern Georgian alphabet at E0–FF and ჰ at B8; not generic STD8.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "392": {
      "name": "Geo_sts",
      "asset": "preview-fonts/392.woff2",
      "sha256": "6f20348ffb8c4fb760037debb5457b9530dabe63b9f3c156c07899d40886a856",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "393": {
      "name": "Geo STS Fixed",
      "asset": "preview-fonts/393.woff2",
      "sha256": "757e6738cf592b38ce3dd3482be0beb9c6b545c7d04fffe2dd39ef1c424a399a",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "394": {
      "name": "Geo_Venuri",
      "asset": "preview-fonts/394.woff2",
      "sha256": "a235c4901ac1d1864ebf84edb06592792378620e176a6eacbc588bcccc3528a9",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "395": {
      "name": "Geo_Venuri Bold",
      "asset": "preview-fonts/395.woff2",
      "sha256": "84c3c249ec8a67f019356e2c371f07c21aa557f4a80e782ad0384d828fd8fadd",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "396": {
      "name": "Geo_Venuri Italic",
      "asset": "preview-fonts/396.woff2",
      "sha256": "69b96a202772ddc230cf6f6c8ec33c6f3ef2632c16c4febdc620f8c980541140",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "397": {
      "name": "Geo_Venuri Bold Italic",
      "asset": "preview-fonts/397.woff2",
      "sha256": "a8087933db8dd3c746acfed0ef0cbbd00d3aa569af75ee79b8dba8d01542e86c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "398": {
      "name": "Geo_WWW_Courier",
      "asset": "preview-fonts/398.woff2",
      "sha256": "3f4f097deed7c92f44bb4ffcd9a366a6c10f7432bfb341ecbf3d1e8e99dac5d1",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "399": {
      "name": "Geo_WWW_Courier Bold",
      "asset": "preview-fonts/399.woff2",
      "sha256": "6da6ee391dbe29850acc2f951d47a8df256b68548d69b2802a6394d4361dc0ce",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "400": {
      "name": "Geo_WWW_Courier Italic",
      "asset": "preview-fonts/400.woff2",
      "sha256": "525ba994b0e1317ebf50fa3259a3cb0594ad553ec3e7f3fbb9d9fc09632c331e",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "401": {
      "name": "Geo_WWW_Courier Bold Italic",
      "asset": "preview-fonts/401.woff2",
      "sha256": "bdcd003177cfa50381ffaa8b7928e94c91eb014526b5fb80a9d6531bedec5825",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "402": {
      "name": "Geo_WWW_Times",
      "asset": "preview-fonts/402.woff2",
      "sha256": "0bd3b7bca947418e7a6bfbdfbca3670140a488d26cc4e5b6ac606e7e918a042a",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "403": {
      "name": "Geo_WWW_Times Bold",
      "asset": "preview-fonts/403.woff2",
      "sha256": "b9d7f5e625d1b1c651a4e37d8b1a7890b68748541c59c2b221d19457ff1fc4dc",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "404": {
      "name": "Geo_WWW_Times Italic",
      "asset": "preview-fonts/404.woff2",
      "sha256": "8e69b8c2154655179a967ecc9748128a22ba56f6952c8966b21333cad56db4e6",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "405": {
      "name": "Geo_WWW_Times Bold Italic",
      "asset": "preview-fonts/405.woff2",
      "sha256": "af0dbc6928d68167bfb00830c30e859662076e85448bcc10eb6f18292e0fe9c8",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "406": {
      "name": "GeoABC",
      "asset": "preview-fonts/406.woff2",
      "sha256": "cca0ec9a9b070e78f455561baa67fff6b37082b116206affb437a39f5042b1dc",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "407": {
      "name": "GeoDumba",
      "asset": "fonts/407.ttf",
      "sha256": "5c753c1fb3be10de7d068cf07418fb221fdf483e868ef5f08dd802c101418316",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "408": {
      "name": "GeoDumba Bold",
      "asset": "fonts/408.ttf",
      "sha256": "bc86565ca5542e0b498dca68709c19f5ac544654aa7bfeeafe8b5d93cfd1e42f",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "409": {
      "name": "GeoDumba Italic",
      "asset": "fonts/409.ttf",
      "sha256": "cbcb15eefb891192098d33044628b55c0e6319c40d1b5a80e92f5b2cbd17f956",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "410": {
      "name": "GeoDumba Bold Italic",
      "asset": "fonts/410.ttf",
      "sha256": "a6fde17d8bcee0d6ae9b9012d80a5bcaa02709d5dd8c0db9415d61628a78d497",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "411": {
      "name": "GeoDumbadze Regular",
      "asset": "preview-fonts/411.woff2",
      "sha256": "b037715b0532b86db7e98e539ba53de5b2a20216ff05f00713e1e4403bcfcc2c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "412": {
      "name": "GeoEDumba",
      "asset": "fonts/412.ttf",
      "sha256": "b48abd1e7a10fe9f7c9133776e7de6f13276ae86c02e37c426d7f21d470473f3",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "413": {
      "name": "GeoEDumba Bold",
      "asset": "fonts/413.ttf",
      "sha256": "c444ea9ef1d09aa97e525b0714975d7a9ee8d84ca3ab949789a627908930e8d1",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "414": {
      "name": "GeoEDumba Italic",
      "asset": "fonts/414.ttf",
      "sha256": "31a37079b2f822215e908e43ee42c672355197be360c0360c64ac8e73ae2557e",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "415": {
      "name": "GeoEDumba Bold Italic",
      "asset": "fonts/415.ttf",
      "sha256": "2064e6289f4c11cad49077973db57d89c555434e8cca3c50a63555896e092d14",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "416": {
      "name": "GEO Grigolia",
      "asset": "preview-fonts/416.woff2",
      "sha256": "b57a51d9bd0a00a12cc1e3ea251c6c65d4fcb2ba72c8dfcc6f125bd3e686f2f9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "417": {
      "name": "Geo-Gza",
      "asset": "preview-fonts/417.woff2",
      "sha256": "e8b1d0b6ac43eb06f081159e8601bc3a6622a17f88910b8dbaf2cd957c805c2f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "418": {
      "name": "GeoNUSX",
      "asset": "preview-fonts/418.woff2",
      "sha256": "96d809db0b25f96eca1fa0398cab41521b266b3ac1cd423a2b91143891eca150",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "419": {
      "name": "Georgia NET",
      "asset": "preview-fonts/419.woff2",
      "sha256": "7d19498329edd2472cd503478cd3df4f21b8d99be2bdc9dd109a02dc3ab65201",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "420": {
      "name": "Georgian Times Normal",
      "asset": "preview-fonts/420.woff2",
      "sha256": "1edbd204b90d50189a23e5a7ac7e507704162bf4518e644e57506c63bb4b517a",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "421": {
      "name": "Georgian Times Bold",
      "asset": "preview-fonts/421.woff2",
      "sha256": "83fba04bba00d3d21f5c5332a456f026a0126822744f307311084d3d4aa4d94e",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "422": {
      "name": "GeoSoft Liter",
      "asset": "preview-fonts/422.woff2",
      "sha256": "c5ac04ad5404210ee2481691c5402c4ff8b893d7649c204241748ba864032356",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "423": {
      "name": "GF Satellite 2 Mt",
      "asset": "preview-fonts/423.woff2",
      "sha256": "0c391cd5b78665103f2e6d1ee04103ca37dc2ac6d09afecfd08583f72ee1cceb",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "424": {
      "name": "GF Satellite 2 Mt Bold",
      "asset": "preview-fonts/424.woff2",
      "sha256": "33ec2bf1a280a891148f6977d6941b9bc574096a54ad53ed92d9f54746e835d0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "425": {
      "name": "GF Satellite 2 Mt Italic",
      "asset": "preview-fonts/425.woff2",
      "sha256": "ee0133ea1bafcceef14e0c0de216b842a78f59c7d28f02d43dc64a2a67f72386",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "426": {
      "name": "GF Satellite 2 Mt Bold Italic",
      "asset": "preview-fonts/426.woff2",
      "sha256": "17f8cde83829d3d08a0e808202ced6e29e368d9b91138e94eb1d9a1d030768f6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "427": {
      "name": "GF Satellite 3 Mt Bold",
      "asset": "preview-fonts/427.woff2",
      "sha256": "cc84bfb92995a2e5829f4ba0360a4ec2b9ba223ab772430ca8cc8a60e4198ee4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "428": {
      "name": "GF Satellite 3 Mt Bold Italic",
      "asset": "preview-fonts/428.woff2",
      "sha256": "b6ccf5712c277839e382805b82bbf191c6a34f632ffffe0e8a50570bce5da14e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "429": {
      "name": "GF Satellite 6 Mt",
      "asset": "preview-fonts/429.woff2",
      "sha256": "02a84ebd3bc4cc10ee907f8234c99eda68272c2d72c1e7a8514fba61f6217f78",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "430": {
      "name": "GF Satellite 6 Mt Bold",
      "asset": "preview-fonts/430.woff2",
      "sha256": "5d19c50e6b8c64b22d53e165f22ecd1ca8735766cda69853b1f334452e6e2999",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "431": {
      "name": "GF Satellite 6 Mt Bold Italic",
      "asset": "preview-fonts/431.woff2",
      "sha256": "3c2a319cbfc4a0242f60a510e55505dcb3587a5e4442aabd33afc6534fdfb2df",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "432": {
      "name": "GF Satellite 17 Mt Bold",
      "asset": "preview-fonts/432.woff2",
      "sha256": "c7b6c27628bd17f7c04970d78b13349aba50f36adc7f62c4ce3f37b5b1997726",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "433": {
      "name": "GF Satellite 17 Mt Bold Italic",
      "asset": "preview-fonts/433.woff2",
      "sha256": "78ce40c9f6688c34ff6a8b34f48f649dd4f6cc1857169f73b6a184d26b72cccc",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "434": {
      "name": "GF Satellite 28 Mt",
      "asset": "preview-fonts/434.woff2",
      "sha256": "97b2e1a498cedb10ecebd2b4f8fdbd35dd2c952a69cd99c4bc90999d649f69b2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "435": {
      "name": "GF Satellite 28 Mt Italic",
      "asset": "preview-fonts/435.woff2",
      "sha256": "2ed5e7758dc28665aa5086c8a2cc02fd13bc53b9b2b41ef3e71bccf01c351fe2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "436": {
      "name": "GigaMsxviliMtav Regular",
      "asset": "preview-fonts/436.woff2",
      "sha256": "e94b9fd197fd80801d4de98ad55c5b3fe9c735a445d0b8b865a8daa8aea232f2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "437": {
      "name": "GigaMsxviliNusx Regular",
      "asset": "preview-fonts/437.woff2",
      "sha256": "355a81a58283d5750777dc861b3151d056a9dbe872fa10a5d33f1ad87505a4bc",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "438": {
      "name": "GigaNewMtav",
      "asset": "preview-fonts/438.woff2",
      "sha256": "ac903198706a3e2dd4f9b5357c9a9d057206b767d2120b16d5240b578cd57818",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "439": {
      "name": "GigaPirveliMtav Regular",
      "asset": "preview-fonts/439.woff2",
      "sha256": "9adc565b9a20e56147737cc2b6e5540ce1172a12b9b08a50916bf23241e1f118",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "440": {
      "name": "GigaPirveliNusx Regular",
      "asset": "preview-fonts/440.woff2",
      "sha256": "77e7b0c40aa0f7fa55c1f8e1563805f2f0bb1540ceb5869f06f341116a7c0cc5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "441": {
      "name": "GigaTxeliMtav Regular",
      "asset": "preview-fonts/441.woff2",
      "sha256": "833c412e4989c09524031218a6aabcaa83229649638b04de402ff1852236c186",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "442": {
      "name": "GigaTxeliNusx Regular",
      "asset": "preview-fonts/442.woff2",
      "sha256": "52933dcea5e83608889a9608abe00dd4412c1c75d8298975173935412b9a1f7f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "443": {
      "name": "Gogebashvili Normal",
      "asset": "preview-fonts/443.woff2",
      "sha256": "ca6cde72d8cb0cb235e369333eaf3e16f87ad60e0276bccf1adb32bd390ff275",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "444": {
      "name": "Gogebashvili-TF Normal",
      "asset": "preview-fonts/444.woff2",
      "sha256": "4f680197aab429f473a2ea3904ebe0299d173ea01d1f1d47446c84ae591024bb",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "445": {
      "name": "GordaNew_GENT",
      "asset": "preview-fonts/445.woff2",
      "sha256": "cfcf5e0bda26f89ce8c3f14eddb131f5cde9c89046046193e9b7bfaf91d339dc",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "446": {
      "name": "GremiMtavr",
      "asset": "fonts/446.ttf",
      "sha256": "2c97bcf82ee9f43503020dcf9cd9b64822840861a9919d53478c530a8c361c1e",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "447": {
      "name": "Grigolia",
      "asset": "fonts/447.ttf",
      "sha256": "9ff8bec78b6ea4263ea1c328d5585f47f23dede24f025d1eb51f9315277626d3",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "448": {
      "name": "GrigoliaMtavr",
      "asset": "fonts/448.ttf",
      "sha256": "c05e3e460bf525cbe26a757dd283aaf1431f6139b2b0d22c210b8bc8cc12a3d3",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "449": {
      "name": "GrigoliaPolygraph",
      "asset": "preview-fonts/449.woff2",
      "sha256": "1755b159e2bdcaa1f1115c2ea4cae6820d13d0757ffe6ed0cc5d00f6cc2ed59e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "450": {
      "name": "GrigoliaPolygraph Bold",
      "asset": "preview-fonts/450.woff2",
      "sha256": "ba3abc40a41936afc24e21ac514155022e310a650a67ff28232abe4f73f6cee4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "451": {
      "name": "Grotesk",
      "asset": "preview-fonts/451.woff2",
      "sha256": "3feddb1c0c94c6a90525e306243e9ad7eb99963049c85bfbf3862d9d636d78a7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "452": {
      "name": "Grotesk Mta",
      "asset": "preview-fonts/452.woff2",
      "sha256": "fb4f448a2f3f7d9d0be4575859a329cc2a7c7700f444fbc1419ee61804c6c37b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "453": {
      "name": "Grigolia_DB",
      "asset": "preview-fonts/453.woff2",
      "sha256": "a4d8d486c823db17383577bdf477d17fdca521176a551ac1865a29da19283a12",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "454": {
      "name": "GEO Zaza",
      "asset": "preview-fonts/454.woff2",
      "sha256": "6bfe106436cc6eb2e8abbe4a77580c341e18fa38e8a4648705712379a1954ca6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "455": {
      "name": "GEO Kolkhetmtav",
      "asset": "preview-fonts/455.woff2",
      "sha256": "da35790ffd069e7498853429b01c559be80386876d0b8ddc32eddce185e7d396",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "456": {
      "name": "GEO Kolkhetnusx",
      "asset": "preview-fonts/456.woff2",
      "sha256": "93eb004ec22186310241127a740b2e115c8194dd8494a6ff136a2cb0d52ac38b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "457": {
      "name": "~Kolkhety TeleType Normal",
      "asset": "preview-fonts/457.woff2",
      "sha256": "74af228b47a3da14971ee7c3b569b7712b5cb710739c0149ecdb126ec073b75d",
      "status": "needs-review",
      "profile": {
        "table": "KolkhetiTeleType",
        "layout": "unchanged",
        "label": "Legacy typewriter"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "458": {
      "name": "GEO Kolkhety",
      "asset": "preview-fonts/458.woff2",
      "sha256": "5e7c263f5c28afd4e5702ff44580b63c1a2e921e38485f50f893a0a930417cc5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "459": {
      "name": "GEO Kolkhety Bold",
      "asset": "preview-fonts/459.woff2",
      "sha256": "2ab239e8ae89ef62f3f17e7a1af4069cee194833dbcbc0ebb4c738bd3547a4f5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "460": {
      "name": "GEO-KolkhetyMtav Bold",
      "asset": "preview-fonts/460.woff2",
      "sha256": "2a618b4060defaa4a3894525137d2070e94db200102623c7d39d3f7ad9f9925f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "461": {
      "name": "GEO LitNusx",
      "asset": "preview-fonts/461.woff2",
      "sha256": "2fd9a756e13c7c6a6f3f6ad25530f66b52e23b7998af1b20d3bd2d043298c11b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "462": {
      "name": "GEO Lortkipanidze Normal",
      "asset": "preview-fonts/462.woff2",
      "sha256": "c06854ed0a94304394ec8141a85b75695af504f27a00526c67fe4cb1fdbb0264",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "463": {
      "name": "HKolkhety",
      "asset": "preview-fonts/463.woff2",
      "sha256": "65b2eda201d544766c46e050b39fd21b33667a21211da535c577c8cc822c07a5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "464": {
      "name": "HKolkhetyMtav",
      "asset": "preview-fonts/464.woff2",
      "sha256": "11f8348053ceec4356ee657cc47e9b673feaaf8dc0a7d341d6e671806ef638b7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "465": {
      "name": "HKolkhetyMtav Bold",
      "asset": "preview-fonts/465.woff2",
      "sha256": "561d7fcbb3c8f7038c541c2e6e1aa1d02b2c2e11be7806cbe6b4813fda6266fa",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "466": {
      "name": "Ia",
      "asset": "preview-fonts/466.woff2",
      "sha256": "fdddedc29c6f91e0d55ee8efe149a56e7dd4be6adc214db60d78e9e157e27c8a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "467": {
      "name": "Imedi",
      "asset": "preview-fonts/467.woff2",
      "sha256": "c9f8b1b9613392e451e777464d84d81d4b61549fb7a36d25b35bef339d9ab292",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "468": {
      "name": "ioane",
      "asset": "preview-fonts/468.woff2",
      "sha256": "6dfcbd3746f288a2b54957ca1d224e85f541ed9de3187c31fbcb5015021611a0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "469": {
      "name": "ioane oqropiri",
      "asset": "preview-fonts/469.woff2",
      "sha256": "a1dd86154c6b267c2f2e47992e6477dea9c230c38940e7111db3707f2deeebdb",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "470": {
      "name": "KA_KOLHETI",
      "asset": "preview-fonts/470.woff2",
      "sha256": "977e73b0a445ae1b1138df7fd8f08f57bb6b1ac314ec0d6857d4426b86f421ea",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "471": {
      "name": "KA_LITERATURULI",
      "asset": "preview-fonts/471.woff2",
      "sha256": "f743a548ce71e04eafa4baa018b3a12c24a5bb10772e6ac7f42911b9ef02e2aa",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "472": {
      "name": "KA_LORTKIPANIDZE",
      "asset": "preview-fonts/472.woff2",
      "sha256": "5a4e6bc29b1e092e2b4a3f7731f9fe806cfba2e57d294c0fc176db948f029a34",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "473": {
      "name": "Kolkhety",
      "asset": "preview-fonts/473.woff2",
      "sha256": "52528a38a94d0049523f037235aa7183e66450a88ee57e536beba01210e3a3ce",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "0": "_",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "*",
        "8": "(",
        "9": ")",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "7",
        ".": "8",
        ":": "5",
        ";": "9",
        "!": "=",
        "?": "0",
        "(": "~",
        ")": "`",
        "%": "+",
        "/": "&"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "474": {
      "name": "Kolkhety Bold",
      "asset": "preview-fonts/474.woff2",
      "sha256": "152d67bb73316f9e988528ecfff5397e1862bcca62e7037f1f5d5599662e1f30",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "0": "_",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "*",
        "8": "(",
        "9": ")",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "7",
        ".": "8",
        ":": "5",
        ";": "9",
        "!": "=",
        "?": "0",
        "(": "~",
        ")": "`",
        "%": "+",
        "/": "&"
      },
      "missing": [],
      "evidence": "ITV family browser alphabet review 2026-09-30; per-family punctuation handling; Asomtavruli punctuation not certified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "475": {
      "name": "kvadro mt",
      "asset": "preview-fonts/475.woff2",
      "sha256": "785ac363a77d15109a8b684d36b3a9da142e734fcc9fdab9858b0ed4952a05e7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "476": {
      "name": "Lado Grigolia",
      "asset": "preview-fonts/476.woff2",
      "sha256": "d7eb6515b251e7df436efb2fdddfd35c80a50ec70a256f7d9d95dcf6d6097d76",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "477": {
      "name": "Lali",
      "asset": "preview-fonts/477.woff2",
      "sha256": "1983538f0deb3022f1634eeb43f87460c058825bfc952bf9ccd6c414bbe4344d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "478": {
      "name": "Literaturuli TD",
      "asset": "preview-fonts/478.woff2",
      "sha256": "9522fc84fd796c15a720575d922c37de4d6d4782b41e4d362989de06ed842c09",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "=",
        ".": "\\",
        ":": "|",
        ";": "+",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "Individual browser ASCII glyph chart reviewed 2026-09-30: Russian TD layout; თ=s, ძ=period, ყ=apostrophe, ჯ=slash, ჰ=right bracket. Comma and full stop use equals and backslash.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "479": {
      "name": "Literaturuli TD Bold",
      "asset": "preview-fonts/479.woff2",
      "sha256": "40b4e2169fa4a60b60b3ea410b6c8d4e929908fb6b96ab6f325212fd6e90b1be",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "=",
        ".": "\\",
        ":": "|",
        ";": "+",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "Individual browser ASCII glyph chart reviewed 2026-09-30: Russian TD layout; თ=s, ძ=period, ყ=apostrophe, ჯ=slash, ჰ=right bracket. Comma and full stop use equals and backslash.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "480": {
      "name": "Literaturuli TD Italic",
      "asset": "fonts/480.ttf",
      "sha256": "33c2dce8bc019337b02e90d21ca1cc1cdb9477a8f43f5d90a42c2acc5d1807e0",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "481": {
      "name": "Literaturuli TD Bold-Italic",
      "asset": "preview-fonts/481.woff2",
      "sha256": "29d15e9ddaae662a061c1d771d1df267028b026a607ad728b9b5a38e926bdfdb",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "/",
        "ჰ": "]",
        ",": "=",
        ".": "\\",
        ":": "|",
        ";": "+",
        "?": "~",
        "/": "$"
      },
      "missing": [],
      "evidence": "Individual browser ASCII glyph chart reviewed 2026-09-30: Russian TD layout; თ=s, ძ=period, ყ=apostrophe, ჯ=slash, ჰ=right bracket. Comma and full stop use equals and backslash.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "482": {
      "name": "literaturuli_BJG_2000 Bold",
      "asset": "preview-fonts/482.woff2",
      "sha256": "980ca571fd1b89211b13b555021bf54869b41c0ee29125b1560990a060d08d6c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "483": {
      "name": "LiteraturuliTT",
      "asset": "preview-fonts/483.woff2",
      "sha256": "acac4a466b54059504f33e46652a1b1e1e0a36f5f1d76d7d231e267b61ea9180",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "484": {
      "name": "Literaturuly",
      "asset": "preview-fonts/484.woff2",
      "sha256": "28a7ee15aa96b0299c4bf09484c1f1756dbc5f12084eb1400808cd8d7895ab0c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "485": {
      "name": "LitMtavrPS",
      "asset": "fonts/485.ttf",
      "sha256": "1c0ddcda835da8d9a6d51cd05716c5818b2fd162f095e20303619c3b0e8dac56",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "486": {
      "name": "Liziko",
      "asset": "preview-fonts/486.woff2",
      "sha256": "c2222d299c2002481ee4cd76e574ccb905a50136950cdca20ef7fa1da970c297",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "487": {
      "name": "Lortkipanidze Normal",
      "asset": "preview-fonts/487.woff2",
      "sha256": "d5e7fc1ac651097cc06c846203b22ef7620b7948f7b5db01adafa9195e650e25",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "488": {
      "name": "A_Nusxuri",
      "asset": "preview-fonts/488.woff2",
      "sha256": "5d0a878958060997bc5ea8946ae4178f4ca5bcfe375cc520945d4d2f6976bcab",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "489": {
      "name": "BPG Phone Sans",
      "asset": "preview-fonts/489.woff2",
      "sha256": "b6f0e4b14a653ae632623721f2d815e011a7a441de7c4cb397be8dc4c1558c98",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "490": {
      "name": "BPG Phone Sans Bold",
      "asset": "preview-fonts/490.woff2",
      "sha256": "e8e3896f7191eccf5fbcfaa50727d270328e168676615159f9cbbe1c90569c76",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "491": {
      "name": "BPG Phone Sans Bold Italic",
      "asset": "preview-fonts/491.woff2",
      "sha256": "8fa1ec74ddd3cae3270ec9cb23d0afc0f226a42638f9ef7dfa53e0a3b577a838",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "492": {
      "name": "BPG Phone Sans Italic",
      "asset": "preview-fonts/492.woff2",
      "sha256": "5b4ba62fae19e6e680cbc88ff4782d772ddccb1419bbc8ec283fbef754356277",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "493": {
      "name": "Geo Sabechdi Mtavr ASTER",
      "asset": "preview-fonts/493.woff2",
      "sha256": "0f151e7e9b4854504a4e3617e3bbd825a3a5c68c3a82d3a4e49f477efbffebf4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "494": {
      "name": "Geo Sabechdi Nusx ASTER",
      "asset": "preview-fonts/494.woff2",
      "sha256": "cb6604874937b8680375830a801a7ed60faf02d76f77ffa92dfc4e2129466fb9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "495": {
      "name": "Margo",
      "asset": "preview-fonts/495.woff2",
      "sha256": "1647da66f51fc296ec610e3cbaff07b46675579195affdbf608b870e02267d76",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "496": {
      "name": "metroff",
      "asset": "preview-fonts/496.woff2",
      "sha256": "e93c514dc96dee382bd4241f4f7b5e2e2be0305893fbae09b909f197ff341459",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "497": {
      "name": "Migdebuli",
      "asset": "preview-fonts/497.woff2",
      "sha256": "207ad64d096856cc5e33f0d446242384a6d0340b7141737a71c6f5a752c907b5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "498": {
      "name": "misha.nd",
      "asset": "preview-fonts/498.woff2",
      "sha256": "81a85022ba583cefbd78bfb50e3db5de69c2d5d915accd46ac3cc3749801505f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "499": {
      "name": "Mist Georgian",
      "asset": "preview-fonts/499.woff2",
      "sha256": "7646959e3ab7604ccd5507d0a329c01f17b488c2b98f99aaf2c68b7166b153d9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "500": {
      "name": "MT_Mchedlidze1",
      "asset": "preview-fonts/500.woff2",
      "sha256": "2bfc6d193fe53b582ec79850680e80dabb10f4b0ac08ff55579dc95a9319a465",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "501": {
      "name": "MT_Mchedlidze Helnatceri1",
      "asset": "preview-fonts/501.woff2",
      "sha256": "016147245fbb9265ca36e231d22e13a1896007819ae87842f94a6dda0fce614b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 36,
        "ambiguousCharacters": []
      }
    },
    "502": {
      "name": "MT_Mchedlidze Nushuri",
      "asset": "preview-fonts/502.woff2",
      "sha256": "57ef67c8f252483c100afc68a7ba7061b8823d72fc961873ffd904a9bb26ff03",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "503": {
      "name": "Muqara",
      "asset": "preview-fonts/503.woff2",
      "sha256": "5b49c60935722ab9164a1ee32d2b8d5b49a013b9257ee70a9c8c52dae64664bf",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "504": {
      "name": "MZIURI_1 Light",
      "asset": "preview-fonts/504.woff2",
      "sha256": "745259ebd1cdb262df6d2dcd04458e99a69c9117c1ec5f480bd001c0d2939301",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "505": {
      "name": "Naniko",
      "asset": "preview-fonts/505.woff2",
      "sha256": "2bd81653ca61c24b10900000d86fc90ececd446bc0fecd79db7a2d1e8f7d61e5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "506": {
      "name": "ORIS",
      "asset": "preview-fonts/506.woff2",
      "sha256": "87ae24bfd5c4f4f72976d1be762b069d1fa95e1633dcb9330382441b56548b1e",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "507": {
      "name": "Pakiz",
      "asset": "preview-fonts/507.woff2",
      "sha256": "b92028c4063ae7d30ca277df8b11747a843f3d2a912b63af3ac2f724949f17bc",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "508": {
      "name": "Patara Nino",
      "asset": "preview-fonts/508.woff2",
      "sha256": "0cde05757ca919a82bd8d67c86ce478f5a6d093c062da51997aad77cece9ba6b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "509": {
      "name": "Peikari",
      "asset": "preview-fonts/509.woff2",
      "sha256": "65d3a063c664ef7a69e6a5f808f2d3d387149d9811198a563ba05c11bd50f0b8",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "510": {
      "name": "Phatima",
      "asset": "preview-fonts/510.woff2",
      "sha256": "de0afba91f603fded3fc6d304a9094e72a3c7c728e66e40305347d0f362e93a4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "511": {
      "name": "Phunji",
      "asset": "preview-fonts/511.woff2",
      "sha256": "363d6d381ca28b22b5f29b057b436e6d50c9914bcdeabf113e403f52f6414724",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "512": {
      "name": "Phunji Mtavruli",
      "asset": "preview-fonts/512.woff2",
      "sha256": "9837911a45c23a356abdd9dba5e21b065e8363b959b5d8b1f0334c898241ea52",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "513": {
      "name": "Saba",
      "asset": "preview-fonts/513.woff2",
      "sha256": "03b345fbc5f101e1ef032a7164234d016186a6fc67bea6eb13b3dc226fcf26aa",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "514": {
      "name": "SakarMtavr",
      "asset": "fonts/514.ttf",
      "sha256": "828fa62fcd4ba0fab809ea41ccb6412cb2b3d38fcb5dcbd7e81cad9b96dd0e36",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "515": {
      "name": "Sanet",
      "asset": "preview-fonts/515.woff2",
      "sha256": "c57af6ff5e98597aa9969397e9767ea1f961d6489e4cfc18ca8f687e7058b416",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "516": {
      "name": "SanHel Bold",
      "asset": "preview-fonts/516.woff2",
      "sha256": "3f3c89d7a7c8603a309c174078c9bb3cbc043f1e8c8657cbc3d08f4b28359bf6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "517": {
      "name": "sggg1",
      "asset": "preview-fonts/517.woff2",
      "sha256": "fa7463c8206b804f78a6cdcd93e7d80b157a02d22557fd637b0b81aa835f7011",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "518": {
      "name": "Shalva",
      "asset": "preview-fonts/518.woff2",
      "sha256": "96ddf007b3f7ca32db6c239b97e079bdcf955c0525aaa2f4c0963dbd3cb047f6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "519": {
      "name": "ShemoMtavr",
      "asset": "fonts/519.ttf",
      "sha256": "34e88e4bcaea4bafe591518e4c68ff0f11fa0bbc8f0fdd7d041922304e4b2355",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "520": {
      "name": "SokolxeTy",
      "asset": "preview-fonts/520.woff2",
      "sha256": "7751167e9c06b5916be5ee8a0ea670a49d824bdfd4a5e38dd2925cc450f11dc6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "521": {
      "name": "SokolxeTy Bold",
      "asset": "preview-fonts/521.woff2",
      "sha256": "6464435a38e0ee2ff8941520552516b736abbd97b7092f5a968adbcc930a45d2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "522": {
      "name": "SPAcademi",
      "asset": "preview-fonts/522.woff2",
      "sha256": "368ff09d8bec6375a1f4bb8147f1690d9494d896ef882c6cf62555167bead310",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "523": {
      "name": "SPAcademi Bold",
      "asset": "preview-fonts/523.woff2",
      "sha256": "a964b2fc596086a9c2203f222f6f82e4d5507c5c2de445dca4eb9a51af1483f0",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "524": {
      "name": "SPAcademi MT Bold",
      "asset": "preview-fonts/524.woff2",
      "sha256": "7b6964f3cb2a9da7d8a28bdb69ff7c3c61bee92665010fc90742cafee046df27",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "525": {
      "name": "SPAcademi MT",
      "asset": "preview-fonts/525.woff2",
      "sha256": "019bdcd6c0d0afe88c20a39f97d3b480d23df8cd4b72e1f28ba5da8707e07d30",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "526": {
      "name": "SPBalavari",
      "asset": "preview-fonts/526.woff2",
      "sha256": "6c53d201753073095c203cf36ea86860f576126f172a926306eba1a335defb88",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "527": {
      "name": "SPChveulebrivi Medium",
      "asset": "preview-fonts/527.woff2",
      "sha256": "38317bc098d60cdb8b09e980e8f5273997b7fff3ba213234d4cd8fbfebef0cad",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "528": {
      "name": "SPChveulebrivi Bold",
      "asset": "preview-fonts/528.woff2",
      "sha256": "a07f8a958d300612f8e7e8192609cce773d8e674e2fe14683d4bce174d32293c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "529": {
      "name": "SPChveulebriviMT Medium",
      "asset": "preview-fonts/529.woff2",
      "sha256": "238b2d075b7cbb952b0c9ca63bf3631b460644798faf67352de85fb09309057d",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "530": {
      "name": "SPChveulebriviMT Bold",
      "asset": "preview-fonts/530.woff2",
      "sha256": "f09bcd3d8e6ac1e21cb92ffc92300fca6064dafd8d51330fa56c0d9021cd85dc",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "531": {
      "name": "SPDumbadze Bold",
      "asset": "preview-fonts/531.woff2",
      "sha256": "c47f3dda3748f97ad42920e1d04891350fd680fb0759555982633b0bc59ee080",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "532": {
      "name": "SPDumbadze MT Bold",
      "asset": "preview-fonts/532.woff2",
      "sha256": "a77fad49b4d646ffdfb36144ce7cca2b4742acf7b25db07ae5d316e1bf882b7a",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "533": {
      "name": "SPFebos",
      "asset": "preview-fonts/533.woff2",
      "sha256": "38fec607bda7d8578da0aa570af825179ccd34b8ddcea431047686199f6f6d9f",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "534": {
      "name": "SPGogebashvily",
      "asset": "preview-fonts/534.woff2",
      "sha256": "07fe5b3ae836cc0bed3e855f22cfe7dcc13ccac05c42504c564d5257c378aeb0",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "535": {
      "name": "SPGorda",
      "asset": "preview-fonts/535.woff2",
      "sha256": "bb4ebfbeb6fc40b1fbe00aa0efc1c144e02853b47990ab5b4c4eab0708e3186b",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "536": {
      "name": "SPGremi",
      "asset": "preview-fonts/536.woff2",
      "sha256": "a94ead227258273cd6f61cfde5bd9883b2aa1b3fc3f5e863411dcb33d5bb391e",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "537": {
      "name": "SPGrigolia",
      "asset": "preview-fonts/537.woff2",
      "sha256": "733198f6db148b4895249e90b255fae77c69d7393a9216093c6cf09f7885017c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "538": {
      "name": "SPGrigolia Bold",
      "asset": "preview-fonts/538.woff2",
      "sha256": "fd75e4436c51d4006fe00aebd725cc9f5e30fd4fc80b902e4bdfcbf7e2dcf78a",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "539": {
      "name": "SPGrigolia MT",
      "asset": "preview-fonts/539.woff2",
      "sha256": "dc46afef0b9276998ace444b2ada5c07264dbf796e964ef9922b70ac87caa111",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "540": {
      "name": "SPGrigolia MT Bold",
      "asset": "preview-fonts/540.woff2",
      "sha256": "a1aa4f3944e8cda2c6a6fff987781e52e9ae40950a1c927ad414ae370b2550e7",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "541": {
      "name": "SPGrotesk",
      "asset": "preview-fonts/541.woff2",
      "sha256": "1708c74c0a1915abd8da9d9be916041eabef99f23a5e1104e80b876b6ae755f5",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "542": {
      "name": "SPKolheti Medium",
      "asset": "preview-fonts/542.woff2",
      "sha256": "9b3f079ba8624f800e90963a3997f6b90bcecdbcbbf0f1f027f2a0b72fef5aea",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "543": {
      "name": "SPKolheti Bold",
      "asset": "preview-fonts/543.woff2",
      "sha256": "269245fee6b97fef0c6bd1761965adaf0bdf625b2876f9420605e77c8fd34d9f",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "544": {
      "name": "SPKolhetiMT Medium",
      "asset": "preview-fonts/544.woff2",
      "sha256": "4e0b64468fb99ef4f89fdf29fc86298712fd040cf37c2010517621a5dedd9062",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "545": {
      "name": "SPKolhetiMT Bold",
      "asset": "preview-fonts/545.woff2",
      "sha256": "89d7530b7fdfbbe837da6a7b76b5331d8b1f19b122b66c54b09fdcfe490c29a2",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "546": {
      "name": "SPLiteraturuly",
      "asset": "preview-fonts/546.woff2",
      "sha256": "1e93c46bf4b007d1e1fd83bb8867ba5327e5d4c713e188c287cd8848bd89dd0c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "547": {
      "name": "SPLiteraturuly Bold",
      "asset": "preview-fonts/547.woff2",
      "sha256": "bce282fe5d32da33aeacd4841d027ba7adc37ae32ba2da87fbbd394d4bde1ab4",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "548": {
      "name": "SPLiteraturuly MT",
      "asset": "preview-fonts/548.woff2",
      "sha256": "b5c5666576ff98d4b9acb88826edefcecdaf3a04c4fcf8d4d3dca715f13645aa",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "549": {
      "name": "SPMdzime",
      "asset": "preview-fonts/549.woff2",
      "sha256": "f3ef03a8212f9688ca7e882b1c8a24651ae443a5b9afaaeb4a6db4604bed0e9b",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "550": {
      "name": "SPPakizi",
      "asset": "preview-fonts/550.woff2",
      "sha256": "daf1b624ea1c71fb8f09f83299fc3915610c916462d76b86c05410267e37278d",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "551": {
      "name": "SPParliament Medium",
      "asset": "preview-fonts/551.woff2",
      "sha256": "7cda6bc13e2683afd02a8375fa174b7113211e00d8cc46c7b0d7165fdd2328d7",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "552": {
      "name": "SPParliament Bold",
      "asset": "preview-fonts/552.woff2",
      "sha256": "7c391c0e904514cdcef2e947f8453ed9c25d037febd3735e9d271511fdb446b1",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "553": {
      "name": "SPParliamentMT Medium",
      "asset": "preview-fonts/553.woff2",
      "sha256": "016a472c4f1a2e06ca2ffb31b3bd664279fae8442fbfad8e0b71c59fa7fab4d2",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "554": {
      "name": "SPParliamentMT Bold",
      "asset": "preview-fonts/554.woff2",
      "sha256": "a0e6435b2dd295b46054ff7e2e084139efb574c8112b1589aacc78040b1a0858",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "555": {
      "name": "SPRustavely",
      "asset": "preview-fonts/555.woff2",
      "sha256": "71e053a32b2a84dfee800f9dad48511be692d2a1013b736972293f7f4e8a7b48",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "556": {
      "name": "SPSakartvelo",
      "asset": "preview-fonts/556.woff2",
      "sha256": "eddc8baf23eb122d215f11d968055ddb95aebddc1b5df3431c273d747f07b81d",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "557": {
      "name": "SPShemokmedi",
      "asset": "preview-fonts/557.woff2",
      "sha256": "b6c9a6fa84600baabba08f3787f7d9c442492741450857f683069b9fac15e92b",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "558": {
      "name": "SPSiradze",
      "asset": "preview-fonts/558.woff2",
      "sha256": "ee3d6d6d62ddaad26aa5028a2ba4e5af51cee8655c0e96ddac55e2acc1291b48",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "559": {
      "name": "SPSiradze Bold",
      "asset": "preview-fonts/559.woff2",
      "sha256": "0549f64f7be27976115578125ecd988dda947a5ae7feda9e53f3880f17285848",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "560": {
      "name": "SPVena Medium",
      "asset": "preview-fonts/560.woff2",
      "sha256": "fbde6a31ac8e878349424f6b64e66d9809ae18ab19561c1cf6444277d89187ba",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "561": {
      "name": "SPVena Bold",
      "asset": "preview-fonts/561.woff2",
      "sha256": "0b0c928d95c9736c9a45c86e9665d1c738c748a6235117c7d3fcfc973b09b1ae",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "562": {
      "name": "AacadHN",
      "asset": "preview-fonts/562.woff2",
      "sha256": "c18a6d0181979500419999f735eaa15150385b55fb6924a403f23537cbe9650d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "563": {
      "name": "AacadLN",
      "asset": "preview-fonts/563.woff2",
      "sha256": "c8c7281652ac317632e4349bda24f8e2cb16cd21d2558cf2e304a45473dad8af",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "564": {
      "name": "AchveulH",
      "asset": "preview-fonts/564.woff2",
      "sha256": "c8e08fdbc9d58b1560f9fa653835afdcd7a8de30b3b1c72cb4ebc683715bf9a4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "565": {
      "name": "AchveulL",
      "asset": "preview-fonts/565.woff2",
      "sha256": "2a082b813ecda1a9c1ce0aae379cf60f1e2ad1d4e7c7b67a129e87ffb582a81e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "566": {
      "name": "Achveullbold",
      "asset": "preview-fonts/566.woff2",
      "sha256": "661672252ff3edb743e7bc1e9dc8f9e0cb745f9b5a740f205075aa870d9819e9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "567": {
      "name": "AdumbadzeHN",
      "asset": "preview-fonts/567.woff2",
      "sha256": "af59aa8dd1bc0e8f13e59dd939533d5e83b29bb41764fda4788fd0f6a1d3bce3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "568": {
      "name": "Adumbadzel",
      "asset": "preview-fonts/568.woff2",
      "sha256": "a92969ecba91b730200c1ed01ce4505615b503ee02450448ca8c65cf89051cec",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "569": {
      "name": "Agancxad",
      "asset": "preview-fonts/569.woff2",
      "sha256": "75e8172a379500bf629c535298ea9fba0b93e3cc4b613d77faa79aff7d405db0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "570": {
      "name": "AGogeb",
      "asset": "preview-fonts/570.woff2",
      "sha256": "18bd1a44d6c6de27074670890f57be49c809f2c6fb7172515e042d73fe131ca5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "571": {
      "name": "AGorda",
      "asset": "preview-fonts/571.woff2",
      "sha256": "10cff2ec282ea41cfb57f858ba0a138bd3b17be1c694e878d0e886bb5d8773fc",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "572": {
      "name": "AGremyN",
      "asset": "preview-fonts/572.woff2",
      "sha256": "60bd3a1d2e3a1bf97cca33662b5a2695107ea45657fb07e935a00155a6b39c2f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "573": {
      "name": "AGrigoliaH",
      "asset": "preview-fonts/573.woff2",
      "sha256": "626844824ae1ff0cbf4345a38e7441451bd59b9f3f307239a095429104926a89",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "574": {
      "name": "AGrigoliaL",
      "asset": "preview-fonts/574.woff2",
      "sha256": "c831b0792df4c6876ec8e40825892ced0acc9788b2a4ca6541062e15f3c3f7f9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "575": {
      "name": "AGroteskN",
      "asset": "preview-fonts/575.woff2",
      "sha256": "8cf59a690a44ca792880d9c6bf0b593a70d27ede494c463a029bb6c35808f785",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "576": {
      "name": "Ailial",
      "asset": "preview-fonts/576.woff2",
      "sha256": "5444ec080c593a6e7980797b5c8e64adaae6eea00cdb75427573415885f6958e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "577": {
      "name": "AKolkhetiH",
      "asset": "preview-fonts/577.woff2",
      "sha256": "2a33801e197baf3cdb3765419ba9961a83d06fc1ea98fdae88246f91d596e9d0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "578": {
      "name": "AKolkhetiL",
      "asset": "preview-fonts/578.woff2",
      "sha256": "b2dc4db3f8767b2c96035cf932962f25f1390572c76dd5ab32d4a6c3c03a31f3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "579": {
      "name": "ALortkipanidze",
      "asset": "preview-fonts/579.woff2",
      "sha256": "9462824f906e487d3d31357c6dbaeedb1a802c70c0fe4c5b7f66eaa840345fca",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "580": {
      "name": "Amartve",
      "asset": "preview-fonts/580.woff2",
      "sha256": "41747a696ccbec421684bffbef3aabdf8d64fdd2d4b2873a36a46f411a3f7bdd",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "581": {
      "name": "AMerabgecadzeh",
      "asset": "preview-fonts/581.woff2",
      "sha256": "5f20d4463af722f31649e2f0e36c86284c38ede3e11f744e6edc5f36da6a384b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "582": {
      "name": "ApakizH",
      "asset": "preview-fonts/582.woff2",
      "sha256": "6e5410a2ff312503ccfa74ccd7053796a8cef453496a0a02464adaaea4c697f4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "583": {
      "name": "AParisuli",
      "asset": "preview-fonts/583.woff2",
      "sha256": "13d6c0ddedad8eebf50f858a73439ea101ebc434e6daec748f4bfbd15e690b7a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "584": {
      "name": "ASakartvelo",
      "asset": "preview-fonts/584.woff2",
      "sha256": "4bebf558c6beb5483f68012ca8556326942a48b127ad6aa7ef7a685981cdc403",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "585": {
      "name": "Ashemok",
      "asset": "preview-fonts/585.woff2",
      "sha256": "41945d02e44ecb98a21c3f2076fc0d88b8e3c0d956d23a6b2af727e5cd7a1049",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "586": {
      "name": "AShesha",
      "asset": "preview-fonts/586.woff2",
      "sha256": "55acd8acda95e50405a16b5f952c59d54d423913e8cf269736510a9967a08290",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "587": {
      "name": "AtbilisiL",
      "asset": "preview-fonts/587.woff2",
      "sha256": "2ce99a247dbe2537c447b1260781008c2635e7dd980322ce1dbc64324af5a2b8",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "588": {
      "name": "ATtbilH",
      "asset": "preview-fonts/588.woff2",
      "sha256": "4027f87575a43dd9e8a84c8e8928e550cc6b1d0e31c4a6342fe8e29a63a69fbc",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "589": {
      "name": "Dumbadze_st",
      "asset": "preview-fonts/589.woff2",
      "sha256": "3ff139cdca10ba0bf1eaed65688d8d20bed03858a4cbb3e7750790cdb8f23df1",
      "status": "verified",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": "'",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": ".",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "=",
        ".": "+",
        ":": "|",
        ";": "\\",
        "?": "~",
        "/": "$",
        "—": "_",
        "„": "@",
        "“": "#",
        "№": "`"
      },
      "missing": [],
      "evidence": "2026-10-27: rendered actual preview asset glyph chart and checked all 33 modern Georgian letters, digits, punctuation and newspaper masthead. Russian catalog profile wrongly maps თ to T (ე); use s. Normal and _st have distinct ყ/ძ and punctuation/digit slots.",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "590": {
      "name": "Geo VasikoGoth",
      "asset": "preview-fonts/590.woff2",
      "sha256": "3d4715e21f8b90fa84608f6d25f6b89d25dcbf7046cc9b164b4ebcd634215334",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "591": {
      "name": "Geo Xozo ASTER",
      "asset": "preview-fonts/591.woff2",
      "sha256": "5ef1e5a984be40ab2da9ef4abdfc31c468ff1bdb53bdaab7403e1eaff7bd7f09",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "592": {
      "name": "geo eklesia",
      "asset": "preview-fonts/592.woff2",
      "sha256": "6b6a36495b545ad984c483b0a646bbf6ee97b1d4f68a906464924b736173c962",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "593": {
      "name": "Geo-TabidzeNusx-ASTER",
      "asset": "preview-fonts/593.woff2",
      "sha256": "5d0c50bf921f8f760b2d74d50448b55a898557a7142ea6d3ef779018961a532d",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "594": {
      "name": "GEO Zhorzholadze",
      "asset": "preview-fonts/594.woff2",
      "sha256": "6a2fc740230541cd6b0752fef8b62df1ad2a8437b9f175817a5738d0b7b2f7c4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "595": {
      "name": "GHINURI",
      "asset": "preview-fonts/595.woff2",
      "sha256": "081674101432af35ae5c88c1e40ebc123f61843ccead8b7685777157f7e750fe",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "596": {
      "name": "KABELnusxENG Bold",
      "asset": "preview-fonts/596.woff2",
      "sha256": "6b17b2e6a88a6d468e8c7466f362598fb5676031be4af74c25566dca7b32d0ba",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "597": {
      "name": "Kalami",
      "asset": "preview-fonts/597.woff2",
      "sha256": "96f8af2fa459c7d07e3f2a0a38c1dab3e3ff2c528eef4ca31528d281b0ec6345",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "598": {
      "name": "Kaligraf01",
      "asset": "preview-fonts/598.woff2",
      "sha256": "5618da679f4faea0e46c5f7da4117ad4c08f40226c7d03e1a29d6503c1a79b7b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "599": {
      "name": "KGD",
      "asset": "preview-fonts/599.woff2",
      "sha256": "837f25a986dbc27ef4fbf7c08c9c8963375225d0d4936ee1dc83ce71fc4c2bcd",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "600": {
      "name": "Talguri RS",
      "asset": "preview-fonts/600.woff2",
      "sha256": "309fb03c4f91f72341eb3639aec1c24dca20bfae2f2ded81492af2a21ed23152",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "601": {
      "name": "Tamaz",
      "asset": "preview-fonts/601.woff2",
      "sha256": "331c5e1b50aa8cd328dfe137146573023b706478027563a14a2903a618b65de5",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "602": {
      "name": "Tamta",
      "asset": "preview-fonts/602.woff2",
      "sha256": "442d9cf21a1bf06701e63f38cd1d2767271dc45471513e1676894d9406332b03",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "603": {
      "name": "Targamos",
      "asset": "preview-fonts/603.woff2",
      "sha256": "ca7cf3b70434984b3bb6cc46d1b5c1d515f81cb18273596148ecb0f79994b67b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "604": {
      "name": "TbilisiCaps Regular",
      "asset": "preview-fonts/604.woff2",
      "sha256": "c61b2040314d790f96d0f19e617f936cc48d73482fa22e94732fd1be8ae24f53",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "605": {
      "name": "Tbilisi-Normal",
      "asset": "fonts/605.ttf",
      "sha256": "31245001825cd2c2bcf5c9d5447fd69057fc564049338040964cc37bc20e37e4",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "606": {
      "name": "Teo Heavy",
      "asset": "preview-fonts/606.woff2",
      "sha256": "a2eb96e1e26670d49fd0e1b1b55687d3fc525df0bc4ff30529be9b91c4e87bdd",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "607": {
      "name": "TFLiteraturuli Letter Normal",
      "asset": "preview-fonts/607.woff2",
      "sha256": "51ee00eec3edc055c7ef8c04bd6360c2d7857bf42ed717c89296e845511508ad",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "608": {
      "name": "Times New Roman Georgian",
      "asset": "preview-fonts/608.woff2",
      "sha256": "a8f35a6f18a42811dfa5b153c16d3f1901b0ce2960405858a2f0421d668513c6",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "609": {
      "name": "Tinano",
      "asset": "preview-fonts/609.woff2",
      "sha256": "a78e8bf56fb22ba79fe7f43574e601c312a894e330abe72287c32f33a99b326c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "610": {
      "name": "UCNOBI.COM Thin",
      "asset": "preview-fonts/610.woff2",
      "sha256": "c00c51b6bce4c9a941b66be048030d9399594e4b8d4bc403d05b9eb54a9429ba",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "611": {
      "name": "Zaza",
      "asset": "preview-fonts/611.woff2",
      "sha256": "ae0ebdfbcbb80e56adaa54ea3b2278989a97f3f25d2247503515c6b407fb43f4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "612": {
      "name": "Zaza_DU",
      "asset": "preview-fonts/612.woff2",
      "sha256": "e0593a2843c1528efdf2c4fa222737e0136058320f440c1c64dc5e899f40ee3f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "613": {
      "name": "Zaza SP",
      "asset": "preview-fonts/613.woff2",
      "sha256": "72b9901ecbb7b84bb5974201245020381102f02298ec075f3191b0ac0f739f07",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "614": {
      "name": "Titus Mxedruli Normal",
      "asset": "preview-fonts/614.woff2",
      "sha256": "7ff147c51f529a1c3d61281f9b67c419a5ffe352eb29de8ee2382af613f584c9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "615": {
      "name": "Titus Mxedruli Bold",
      "asset": "preview-fonts/615.woff2",
      "sha256": "5e2998d0ffcc181f2a7c326b3abd6c13fc0c142cdadd8ce92ebbce7acbb91429",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "616": {
      "name": "# Dumbadze",
      "asset": "preview-fonts/616.woff2",
      "sha256": "079f35e797f4114cc6dc857eefb3a7935e8a89ce01b85f155e14295b66550aed",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "0": ")",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "&",
        "8": "*",
        "9": "(",
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "6",
        ".": "7",
        ":": "5",
        ";": "8",
        "!": "=",
        "?": "9",
        "(": "~",
        ")": "0",
        "%": "`"
      },
      "missing": [],
      "evidence": "Rendered 33-letter chart reviewed on 2026-09-30; missing characters recorded separately",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "617": {
      "name": "acad",
      "asset": "preview-fonts/617.woff2",
      "sha256": "93b697b6df340482a06f5ba8eeaf1d434a99be4f1c0c92ad253009e475607a68",
      "status": "verified",
      "profile": {
        "table": "Academic",
        "layout": "unchanged",
        "label": "Legacy typewriter"
      },
      "map": {
        "0": "_",
        "1": "!",
        "2": "@",
        "3": "#",
        "4": "$",
        "5": "%",
        "6": "^",
        "7": "*",
        "8": "(",
        "9": ")",
        "ა": "g",
        "ბ": ".",
        "გ": "u",
        "დ": ";",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "f",
        "ი": "n",
        "კ": "r",
        "ლ": "l",
        "მ": "b",
        "ნ": "y",
        "ო": "k",
        "პ": "h",
        "ჟ": "'",
        "რ": "j",
        "ს": "v",
        "ტ": "m",
        "უ": "e",
        "ფ": "a",
        "ქ": ",",
        "ღ": "q",
        "ყ": "c",
        "შ": "i",
        "ჩ": "x",
        "ც": "]",
        "ძ": "s",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "w",
        "ჰ": "/",
        ",": "7",
        ".": "8",
        ":": "5",
        ";": "9",
        "!": "=",
        "?": "0",
        "(": "~",
        ")": "`",
        "%": "+",
        "-": "2",
        "/": "-"
      },
      "missing": [],
      "evidence": "Actual browser ASCII charts reviewed 2026-09-30: typewriter lowercase layout differs from capital slots; 33 modern letters, digit and punctuation samples checked",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "618": {
      "name": "! kolkheti 98 Pix",
      "asset": "preview-fonts/618.woff2",
      "sha256": "bc8f9eaf5bfa6b669e2698ab2b668db768e7e27c3fb9113e2e41994b8e9a2d91",
      "status": "partial",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "ძ",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "(",
        "(": "~",
        ")": "`",
        "%": ")",
        "$": "#"
      },
      "missing": [
        "ძ"
      ],
      "evidence": "Rendered 33-letter chart reviewed on 2026-09-30; missing characters recorded separately",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "619": {
      "name": "! kolkheti 98 Pix Normal",
      "asset": "preview-fonts/619.woff2",
      "sha256": "6b4b8745882e83a24c82d30619a4ee91d56edf08aad4e95a1bcb14914d65cb8f",
      "status": "partial",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "ძ",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "(",
        "(": "~",
        ")": "`",
        "%": ")"
      },
      "missing": [
        "ძ"
      ],
      "evidence": "Rendered 33-letter chart reviewed on 2026-09-30; missing characters recorded separately; ASCII punctuation chart checked 2026-09-30",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "620": {
      "name": "!kolxeti_96",
      "asset": "preview-fonts/620.woff2",
      "sha256": "d9a59fa48941d055ae7c44878d73c1fcdab9c87676ea2375412588f4063bfa27",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "(",
        "(": "~",
        ")": "`",
        "%": ")"
      },
      "missing": [],
      "evidence": "Rendered 33-letter chart reviewed on 2026-09-30; missing characters recorded separately; ASCII punctuation chart checked 2026-09-30",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "621": {
      "name": "!kolxeti_ BJG_96",
      "asset": "preview-fonts/621.woff2",
      "sha256": "57a0a9015391de31728990af1cff183a79475d796def5123fb6451910a656924",
      "status": "verified-letters",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "map": {
        "ა": "f",
        "ბ": ",",
        "გ": "u",
        "დ": "l",
        "ე": "t",
        "ვ": "d",
        "ზ": "p",
        "თ": "s",
        "ი": "b",
        "კ": "r",
        "ლ": "k",
        "მ": "v",
        "ნ": "y",
        "ო": "j",
        "პ": "g",
        "ჟ": ";",
        "რ": "h",
        "ს": "c",
        "ტ": "n",
        "უ": "e",
        "ფ": "a",
        "ქ": "m",
        "ღ": "q",
        "ყ": ".",
        "შ": "i",
        "ჩ": "x",
        "ც": "w",
        "ძ": "'",
        "წ": "o",
        "ჭ": "z",
        "ხ": "[",
        "ჯ": "]",
        "ჰ": "/",
        ",": "^",
        ".": "&",
        ":": "%",
        ";": "*",
        "?": "(",
        "(": "~",
        ")": "`",
        "%": ")",
        "$": "#"
      },
      "missing": [],
      "evidence": "Rendered 33-letter chart reviewed on 2026-09-30; missing characters recorded separately",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "622": {
      "name": "#Kolkhety",
      "asset": "fonts/622.ttf",
      "sha256": "455c3e6674b8080c29d6432c4c13b0a97360815729818c0f8bcb7794e2f6af97",
      "status": "download-only",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "623": {
      "name": "_Kolkheti",
      "asset": "preview-fonts/623.woff2",
      "sha256": "74edc995ca3c45bbec83355717616e7bc562f756766d6afc9a0ad4f5819f695e",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "624": {
      "name": "_Kolkhety",
      "asset": "preview-fonts/624.woff2",
      "sha256": "0d467f39533564793ffca47cdbd8e9d43d289f793924d7468ce0cb43114187d9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "625": {
      "name": "G&G_GRigoliaM",
      "asset": "preview-fonts/625.woff2",
      "sha256": "a97aeee3e7f6c8141d886f10c05c088e53711e6b9136d6cfe7bdd54aba1f6da8",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "626": {
      "name": "Geo G&G_Grigolia",
      "asset": "preview-fonts/626.woff2",
      "sha256": "6385751199d4da83a899b3c19fd598f36fc79c6898caad32a24cc5aa9c24ffba",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "627": {
      "name": "Geo Akad Nebraska",
      "asset": "preview-fonts/627.woff2",
      "sha256": "121ae9d98b463e729b91556d10c0d66dc2d23ca08e2853a42b491df87cec8e68",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "628": {
      "name": "metroffM",
      "asset": "preview-fonts/628.woff2",
      "sha256": "b9583909433703691b3bb1e4b9413d83e437ef39a5845a6fcc4f0961698e1a90",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "629": {
      "name": "Geo Chveulebrivi",
      "asset": "preview-fonts/629.woff2",
      "sha256": "fe393e173171b9fd3c491480533639bc8fae42bf51ff6733b5cfddbfc7e96eac",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "630": {
      "name": "Geo Chveulebrivi",
      "asset": "preview-fonts/630.woff2",
      "sha256": "e19cd54532bd69138de99bbbc8719bda919ed2c2b099b06f8fd91c269bb9c18a",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "631": {
      "name": "GEO CHVEULEBRIVI",
      "asset": "preview-fonts/631.woff2",
      "sha256": "432576898719a64b5b2808a6efd06ad54ecdffde63827ff7a03a3f48cc4a9695",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "632": {
      "name": "GEO_CVEULEBRIVI",
      "asset": "preview-fonts/632.woff2",
      "sha256": "3ccdcec827727221d9666c3ac877e7d2592f26d88efcd2bf82f5925480b476b6",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "633": {
      "name": "bombei mtavr",
      "asset": "preview-fonts/633.woff2",
      "sha256": "d4dfb29a127b1f0aeb5448a4217d3edcfc5cd28c4bab5fa233db057dc1bf2ab4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "634": {
      "name": "IChveulebrivy1",
      "asset": "preview-fonts/634.woff2",
      "sha256": "149d67bb1dabafc8498ce5a94441d815f7d7898a1fb25e4d9addabe57dc4c785",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "635": {
      "name": "I-Chveulebrivy Bold1",
      "asset": "preview-fonts/635.woff2",
      "sha256": "a0e2f2eeb718bd7b2dff0abf063d3f96773338789db589516be7b87940265e59",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "636": {
      "name": "MG Niniko",
      "asset": "preview-fonts/636.woff2",
      "sha256": "62bec55c9722bb61840c1d412714728315603d521dcbaa90f78ae04583f72578",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "637": {
      "name": "LitNusxTemo",
      "asset": "preview-fonts/637.woff2",
      "sha256": "57b4b49a2fe875f52d9b11e329051a08bb721ad6a5f7472a3ca5e74197fa6f5e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "638": {
      "name": "3D Unicode",
      "asset": "preview-fonts/638.woff2",
      "sha256": "0333693d8dae7c457bdfa388e7d6a5efd0a22d39c576788b628282e11fa67017",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "639": {
      "name": "CQVITO",
      "asset": "preview-fonts/639.woff2",
      "sha256": "956ec0eaf4701395f2a3e626d7c2bed611ff27e52617fef3cb85d159f915788c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "640": {
      "name": "CQWITO Bold",
      "asset": "preview-fonts/640.woff2",
      "sha256": "8e683b9068b723fa902c35d6b128807611e10393dd547a9a52f95b0d37bde201",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "641": {
      "name": "ZanuriZS",
      "asset": "preview-fonts/641.woff2",
      "sha256": "cfc81c0e7866ad5294b6536f83f938bc26aa3218cd4e2e8a5f71dc245aad99e4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "642": {
      "name": "Litnusx-bold",
      "asset": "preview-fonts/642.woff2",
      "sha256": "aabe9b77906769c5ac96a99623120c70814bfc0c88854c5bc2094cc405d47820",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "643": {
      "name": "BG Console",
      "asset": "preview-fonts/643.woff2",
      "sha256": "e54405ea2a641005fc28d4c25a9cf6345c9ef2a8d7fb03660eec4f7dea1b5f01",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "644": {
      "name": "BG Courier",
      "asset": "preview-fonts/644.woff2",
      "sha256": "a0ced557bbe2d495311a6252ecb423894d6e48ba966822d32dfeb487e3286919",
      "status": "verified",
      "profile": {
        "table": "bg-modern",
        "layout": "unchanged",
        "label": "BG modern alphabet"
      },
      "map": {
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "ა": "À",
        "ბ": "Á",
        "გ": "Â",
        "დ": "Ã",
        "ე": "Ä",
        "ვ": "Å",
        "ზ": "Æ",
        "თ": "Ç",
        "ი": "È",
        "კ": "É",
        "ლ": "Ê",
        "მ": "Ë",
        "ნ": "Ì",
        "ო": "Í",
        "პ": "Î",
        "ჟ": "Ï",
        "რ": "Ð",
        "ს": "Ñ",
        "ტ": "Ò",
        "უ": "Ó",
        "ფ": "Ô",
        "ქ": "Õ",
        "ღ": "Ö",
        "ყ": "×",
        "შ": "Ø",
        "ჩ": "Ù",
        "ც": "Ú",
        "ძ": "Û",
        "წ": "Ü",
        "ჭ": "Ý",
        "ხ": "Þ",
        "ჯ": "ß",
        "ჰ": "à",
        ",": ",",
        ".": ".",
        ":": ":",
        ";": ";",
        "!": "!",
        "?": "?",
        "(": "(",
        ")": ")",
        "%": "%"
      },
      "missing": [],
      "evidence": "Rendered full alphabet and punctuation chart checked on 2026-09-30",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "645": {
      "name": "BG Literaturuli",
      "asset": "preview-fonts/645.woff2",
      "sha256": "e83fe3fa36fd74e9d3e3d566ff826863fac121cd54541068dfda5c9144930c2e",
      "status": "verified",
      "profile": {
        "table": "bg-modern",
        "layout": "unchanged",
        "label": "BG modern alphabet"
      },
      "map": {
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "ა": "À",
        "ბ": "Á",
        "გ": "Â",
        "დ": "Ã",
        "ე": "Ä",
        "ვ": "Å",
        "ზ": "Æ",
        "თ": "Ç",
        "ი": "È",
        "კ": "É",
        "ლ": "Ê",
        "მ": "Ë",
        "ნ": "Ì",
        "ო": "Í",
        "პ": "Î",
        "ჟ": "Ï",
        "რ": "Ð",
        "ს": "Ñ",
        "ტ": "Ò",
        "უ": "Ó",
        "ფ": "Ô",
        "ქ": "Õ",
        "ღ": "Ö",
        "ყ": "×",
        "შ": "Ø",
        "ჩ": "Ù",
        "ც": "Ú",
        "ძ": "Û",
        "წ": "Ü",
        "ჭ": "Ý",
        "ხ": "Þ",
        "ჯ": "ß",
        "ჰ": "à",
        ",": ",",
        ".": ".",
        ":": ":",
        ";": ";",
        "!": "!",
        "?": "?",
        "(": "(",
        ")": ")",
        "%": "%"
      },
      "missing": [],
      "evidence": "Rendered full alphabet and punctuation chart checked on 2026-09-30",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "646": {
      "name": "Geo Kikabidze Nusx",
      "asset": "preview-fonts/646.woff2",
      "sha256": "0b88012fc6a48498d449dca2cf92941954592f273a6736891217da56844d014a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "647": {
      "name": "Rustaveli Nusx Normal",
      "asset": "preview-fonts/647.woff2",
      "sha256": "54dedab47b04e13fa07874180db7aa5a4f4e11112bc314898a4ee92bacb57c9a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "648": {
      "name": "MG BitNeon",
      "asset": "preview-fonts/648.woff2",
      "sha256": "49e2d8155482b4c6d8ce9b40c3aab9c3fab93e3e05504f5056d8f928a4f7c4cb",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "649": {
      "name": "MG BitNeon Chaos",
      "asset": "preview-fonts/649.woff2",
      "sha256": "abd7434244e07b50d5d9c87926670ffbdb3e668fbf600d1eab32904233dadc21",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "650": {
      "name": "MG BitNeon Hollow",
      "asset": "preview-fonts/650.woff2",
      "sha256": "3c68b72a736a242fea83c9b5cf26e05f226adf88af85db4104b9bb2f67a5c00c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "651": {
      "name": "zveleburi",
      "asset": "preview-fonts/651.woff2",
      "sha256": "d392a821635f32353cb9455ca143d358f53b9d15e752ec265b7b502a22350280",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "652": {
      "name": "Geo Rajavi",
      "asset": "preview-fonts/652.woff2",
      "sha256": "2cfcf8a7105c0c153f41a3203d9c01118eb78b2c02be58b815eb7b085c0f8f2f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "653": {
      "name": "MG Glaho Drunk",
      "asset": "preview-fonts/653.woff2",
      "sha256": "95b929a8e2c08810def3a21bd96829c6b072c0e75c7c917a9273c9c75c439015",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "654": {
      "name": "Fixedsys Excelsior 3.01",
      "asset": "preview-fonts/654.woff2",
      "sha256": "b3e21f0e326aae28485e70524b2330e9fe37380c29cfd7f0a9db26e43f144d48",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "655": {
      "name": "GEO DumbaNusx",
      "asset": "preview-fonts/655.woff2",
      "sha256": "6c1c4fe6fb4330e6d8ed407a1334f85abd6c81b4bb32d60272e9a0393a684701",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "656": {
      "name": "Rajavi Vazi",
      "asset": "preview-fonts/656.woff2",
      "sha256": "a5603470f9e96782da9c5cc25a4cddc5a9728e97d17b09e4e1914d1e075a7a48",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "657": {
      "name": "LiterNusx Normal",
      "asset": "preview-fonts/657.woff2",
      "sha256": "449673f35946aacb32222334bf8999d23171ffbb633f7142b07f1786542b92cd",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "658": {
      "name": "LiterNusx Bold",
      "asset": "preview-fonts/658.woff2",
      "sha256": "aa205dd326457c8c9411b3bb675a437f598d3dfcf48be2af79bce7c8496c7904",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "659": {
      "name": "LiterMtavr",
      "asset": "preview-fonts/659.woff2",
      "sha256": "9f33c9b924cb690fade36937721e9414402f6c76600337f6551aae026e6e9a76",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "660": {
      "name": "LiterMtavr Bold",
      "asset": "preview-fonts/660.woff2",
      "sha256": "eb71638897e02bbde3ade7b5e052894e2aaf74dd1cad47819c8e75bf7a0a95f2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "661": {
      "name": "Aag",
      "asset": "preview-fonts/661.woff2",
      "sha256": "cbd0c4f7c851fa0d65dce7e238347cecee606d6e2b2124a31f72e6e23491cc03",
      "status": "verified-letters",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "map": {
        "ა": "À",
        "ბ": "Á",
        "გ": "Â",
        "დ": "Ã",
        "ე": "Ä",
        "ვ": "Å",
        "ზ": "Æ",
        "თ": "Ç",
        "ი": "È",
        "კ": "É",
        "ლ": "Ê",
        "მ": "Ë",
        "ნ": "Ì",
        "ო": "Í",
        "პ": "Î",
        "ჟ": "Ï",
        "რ": "Ð",
        "ს": "Ñ",
        "ტ": "Ò",
        "უ": "Ó",
        "ფ": "Ô",
        "ქ": "Õ",
        "ღ": "Ö",
        "ყ": "×",
        "შ": "Ø",
        "ჩ": "Ù",
        "ც": "Ú",
        "ძ": "Û",
        "წ": "Ü",
        "ჭ": "Ý",
        "ხ": "Þ",
        "ჯ": "ß",
        "ჰ": "ý"
      },
      "missing": [],
      "evidence": "Actual browser chart reviewed 2026-09-30: modern alphabet at C0–DF; ჰ at FD, not E0",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "662": {
      "name": "BPG Nateli Regular",
      "asset": "preview-fonts/662.woff2",
      "sha256": "4af17c069411eafe5ba16c5050f5f445f8921a349206735c1fa8bc3329be2a05",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "663": {
      "name": "BPG Nateli Nusxuri Regular",
      "asset": "preview-fonts/663.woff2",
      "sha256": "43dd312dee122cc1b9792dbc1392e33d1986961be1b5f53453a0f1092e40535d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "664": {
      "name": "BPG Nateli Mtavruli Regular",
      "asset": "preview-fonts/664.woff2",
      "sha256": "299adb91c56c38233d752959919528970ddde1d9254beff794ec205aa5dab141",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "665": {
      "name": "BPG Nateli AsoMtavruli Regular",
      "asset": "preview-fonts/665.woff2",
      "sha256": "004ee50fc79117b78915c1aaadaa97e07f784aa12bb7a04e1c7402d6f6561411",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "666": {
      "name": "G_MDumbadze",
      "asset": "preview-fonts/666.woff2",
      "sha256": "20d32aa018a99c7a22dc6c6b396a7167498ff70d5aac791c8a713d3b3fc99f8e",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "667": {
      "name": "G_Nlordkipanidze Normal",
      "asset": "preview-fonts/667.woff2",
      "sha256": "afee51beb533ec448bcde91895f9007bb699259f27e6fca4e9876864c1696a55",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "668": {
      "name": "G_NSItalik",
      "asset": "preview-fonts/668.woff2",
      "sha256": "6eae97f8512fc7015f8e7bf44138915713f62a0d5640f48142a5c9c81e0541d1",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "669": {
      "name": "BPG Excelsior Caps DejaVu 2010",
      "asset": "fonts/669.ttf",
      "sha256": "7be68fac3f434b169f0170940f1d75c237abc427245e74fd0011a2c2d26fbbcc",
      "status": "download-only",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "670": {
      "name": "BPG Excelsior DejaVu 2010",
      "asset": "fonts/670.ttf",
      "sha256": "6a3e4cded51bd59a595a2f8197bf0246a5ee709f73f372d15a207bac561634dd",
      "status": "download-only",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "671": {
      "name": "BPG Venuri 2010",
      "asset": "preview-fonts/671.woff2",
      "sha256": "ca0f2dbf663bb93bfeb15a2d5e90280343662e9ef6a40f5c8625921c47cac389",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "672": {
      "name": "BPG Mrgvlovani 2010",
      "asset": "preview-fonts/672.woff2",
      "sha256": "e37855c88dabe7ec41506ded8abd5323355bc823d76399f71e8ffc91c1dbc77f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "673": {
      "name": "BPG Mrgvlovani Caps 2010",
      "asset": "preview-fonts/673.woff2",
      "sha256": "4440667778e43f87707078b80f2c408b85530f2d23f1c611dff2c22d3333948b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "674": {
      "name": "Kolcheti Regular",
      "asset": "preview-fonts/674.woff2",
      "sha256": "484f033fb10ecff29e515ad7bb178d8823cd14dec979e5d89977e7b2103d6b42",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "675": {
      "name": "Kolcheti",
      "asset": "preview-fonts/675.woff2",
      "sha256": "75412a3223ad14246407e23b24e9e834e398ac69cb69980b0bf2050fda934218",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "eng-to-rus",
        "label": "Legacy Latin · Russian keyboard"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "676": {
      "name": "Edimaia",
      "asset": "preview-fonts/676.woff2",
      "sha256": "ad0ba922cc943de95b35f8bfd96d6310cdd404084bfae8a0e7dd13f565bafca8",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "677": {
      "name": "GE Gorda_ Nusx",
      "asset": "preview-fonts/677.woff2",
      "sha256": "7f8f5fb8b774bbcfc49caf51d24b23607a0dce48fb8bc3b924b2635332e48d08",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "678": {
      "name": "kaxa-dekor",
      "asset": "preview-fonts/678.woff2",
      "sha256": "358f9e9ced966c98f3d1bc6b2411fbf76e50e4dbefda81463cab073cd212003a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "679": {
      "name": "GEO_BALAVARI",
      "asset": "preview-fonts/679.woff2",
      "sha256": "a166f4b312b13aa4f197d8e5c7e7fe977afd64c77ec7677b3fbafced12c78db5",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "680": {
      "name": "mindia",
      "asset": "preview-fonts/680.woff2",
      "sha256": "a70af59b5592d8d81f2a4da94581c48d9faee8a3560484f420349130d1635c49",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "683": {
      "name": "69_tall",
      "asset": "preview-fonts/683.woff2",
      "sha256": "bd042e3fe43f74b6617b5dcfd035c8874f800a7cbb52cf4ed6fb458e7587a3ab",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "684": {
      "name": "ALK Rounded Nusx Med",
      "asset": "preview-fonts/684.woff2",
      "sha256": "d612242d71a5063668b2a362e8133b39be89e73b0adb46bbcd4c8c89ea2ae169",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "685": {
      "name": "ALK Rounded Mtav Med",
      "asset": "preview-fonts/685.woff2",
      "sha256": "25d92163aeb54bde82f8b6c243c9b952e8c11dc2bee2edf610b348f01e087801",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "686": {
      "name": "DKR Hu1",
      "asset": "preview-fonts/686.woff2",
      "sha256": "24d1f5af5e97ee90b0206f9640fa4f1ea9e90f7288e3b9605e8b597f850382e4",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "687": {
      "name": "Dkr Mt1",
      "asset": "preview-fonts/687.woff2",
      "sha256": "7dce37187da99155c5d4811443491340b4dbd0a28fa2d9d5b173fb5f5cc8e9e9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "688": {
      "name": "AKolkhetyN",
      "asset": "preview-fonts/688.woff2",
      "sha256": "6d0ec7a4e99eaaf95de1663b74c8dfc8a5edebf0a823e036352680b795f2a1a7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "689": {
      "name": "AKolkhetyN Bold",
      "asset": "preview-fonts/689.woff2",
      "sha256": "c90bc4285f649f40e89127c0a103151f595f445452b3aaa9f1ec84340d3e9c71",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "690": {
      "name": "AKolkhetyN Italic",
      "asset": "preview-fonts/690.woff2",
      "sha256": "928172571b5bcc803cd2b29762701a4919a5d1edcb51f5d668bee7a64a8df58c",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "691": {
      "name": "AKolkhetyN Bold Italic",
      "asset": "preview-fonts/691.woff2",
      "sha256": "9c66964ed2fe5d4552b0fdf847f4be59848c746948038e8dcfa6e6c13e422110",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "692": {
      "name": "Avaza SP",
      "asset": "preview-fonts/692.woff2",
      "sha256": "6eec3fe15836b01b494d716f2b8ba12cc21cf372541c88024b28603888fc899c",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "693": {
      "name": "ALKBasri-Light",
      "asset": "preview-fonts/693.woff2",
      "sha256": "212a800f4e5634c61418a7c7234cdc7b31ee9d9a13b0629dd993b0f6986a6738",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "694": {
      "name": "ALKDots",
      "asset": "preview-fonts/694.woff2",
      "sha256": "f0567bfbf50690ed09e5c5e0806808af012e6f985c603f274ca64c10676e8d6e",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "695": {
      "name": "tablonRegular",
      "asset": "preview-fonts/695.woff2",
      "sha256": "da901ed8c80256ae1b408697a5db9818fa870a567e8ec3aba881650f38843d63",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "696": {
      "name": "AR Archy Regular",
      "asset": "preview-fonts/696.woff2",
      "sha256": "fdc9487a2388443b85ee72392c554ea1b0121ebb6c7fef455a62d18859c28264",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "700": {
      "name": "AR Archy ExtraLight",
      "asset": "preview-fonts/700.woff2",
      "sha256": "f2e17fc3dce714ea843470e99e1301fba09afd186c60c15346c18147f37cac2a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "701": {
      "name": "AR Archy SemiBold",
      "asset": "preview-fonts/701.woff2",
      "sha256": "ff799e5973bfac5724dcef7e0c0691c081bf69c071f2b0cc4b7c645b77de595d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "702": {
      "name": "AR Archy Thin",
      "asset": "preview-fonts/702.woff2",
      "sha256": "8d4a1296e24868350b56a3f831f6428c989822db3c017efc79fd8c0509d049ff",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "703": {
      "name": "ALK Katerina",
      "asset": "preview-fonts/703.woff2",
      "sha256": "99de1d93af70827e72aedf1e5eb7b17fe6bd9aa9fc3aa0cce5dededab39db40f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "704": {
      "name": "ALK Sanet",
      "asset": "preview-fonts/704.woff2",
      "sha256": "19b3d2bde709c3a5667e30637e4a8b0166cdb701faf8b25686f47b4b8f0c74c9",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "705": {
      "name": "ALK Rex Bold",
      "asset": "preview-fonts/705.woff2",
      "sha256": "adec254ec7e8b60433d6a1f9210cba6f2e9dae3a91f2c30c0cf9835f99f80d2b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "707": {
      "name": "ALK Tall Mtavruli Regular",
      "asset": "preview-fonts/707.woff2",
      "sha256": "39525bd1d97e290994c992bbb076e56349c070083117b0d2b7934d2bd9e3d5d2",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "708": {
      "name": "ALK Tall Nusxuri Regular",
      "asset": "preview-fonts/708.woff2",
      "sha256": "1a4b80fd60a20526b0c16cf10693ef29029e57817bb4f4f52ce859c628779d31",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "709": {
      "name": "G_Grem",
      "asset": "preview-fonts/709.woff2",
      "sha256": "3ea04f993b3646d39374fc9e31457c0e14006ece1dd36e6dca1e9a6e7384eb1f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "711": {
      "name": "ALK Tommaso",
      "asset": "preview-fonts/711.woff2",
      "sha256": "e90da51be86786eac5178081bd056a072e410ad9aac20d26a4367b1ad11c73ad",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "712": {
      "name": "BPG Banner",
      "asset": "preview-fonts/712.woff2",
      "sha256": "3a7211f5dbda63fc47cc5c3a8ea718a0d69a2e07812982edbe655e7b87ef07fd",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "713": {
      "name": "BPG Banner Caps",
      "asset": "preview-fonts/713.woff2",
      "sha256": "bb20ca8df1a9e224d7670e7c97b4fc09457d28118c521f16752f94b080e40f40",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "714": {
      "name": "BPG Banner Caps Alpha",
      "asset": "preview-fonts/714.woff2",
      "sha256": "e005ac2569fea82294294bbeea2fd10e4cd7f777fbb9ffe75797405bd2415311",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "715": {
      "name": "BPG Banner ExtraSquare",
      "asset": "preview-fonts/715.woff2",
      "sha256": "9643aace780f4171179dbc7311c0679c07848d541a04b47ddcab39b30d382337",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "716": {
      "name": "BPG Banner ExtraSquare Caps",
      "asset": "preview-fonts/716.woff2",
      "sha256": "2bb18b99b81d8c3f5884c0fd92b367beafafaac1599a06589d2ad64cb5c646cb",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "717": {
      "name": "BPG Banner QuadroSquare",
      "asset": "preview-fonts/717.woff2",
      "sha256": "df1b5ecef7ccae3999e45bfaa2da11f18a26d6c543160e59c6fe35482af09b13",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "718": {
      "name": "BPG Banner QuadroSquare Caps",
      "asset": "preview-fonts/718.woff2",
      "sha256": "3e8eef5d0ba6f138b0323f724281b1e53fcde0309339fceb426a657277624698",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "719": {
      "name": "BPG Banner SuperSquare",
      "asset": "preview-fonts/719.woff2",
      "sha256": "d85b30d7a05323dec3e6a282c8c9a16535fb13de7daca2e53ea382f71eed100c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "720": {
      "name": "BPG Banner SuperSquare Caps",
      "asset": "preview-fonts/720.woff2",
      "sha256": "7ed7cc4f883304493168645379abb6da4c1e6d2c6fa62a2634cb0141e31e0dd7",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "721": {
      "name": "Arial GEO Bold",
      "asset": "preview-fonts/721.woff2",
      "sha256": "2205c3de404e685c506a0cfa581144cc497d826dc81a29548ab50eb91d58114f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "722": {
      "name": "Arial GEO Italic",
      "asset": "preview-fonts/722.woff2",
      "sha256": "43bea8a8b0c46fc685e5ba778039d91fded0bd6ecb7933e1c1622c464ba1cc0f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "723": {
      "name": "Arial GEO BoldItalic",
      "asset": "preview-fonts/723.woff2",
      "sha256": "b63cccdabf7c862b6d558f7d584cecd8eeefa8a54d756a58e0e295b1a36a6aa8",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "724": {
      "name": "BPG LE Studio 02",
      "asset": "preview-fonts/724.woff2",
      "sha256": "79a0f86bfcee975de9181a90f8732c474b45186c006bf3d3ae5f507abd71ebd5",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "725": {
      "name": "BPG LE Studio 02 Caps",
      "asset": "preview-fonts/725.woff2",
      "sha256": "c06047c6ed9121c5d8c73c5804420f7017c0e8b242a88c59c9eae3603da712e1",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "726": {
      "name": "BPG No9",
      "asset": "preview-fonts/726.woff2",
      "sha256": "6b169ef0a407d51b6a9d5b3f2564e3c0a8c1db547746db36dc9425e45649f4c0",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "727": {
      "name": "ALK Life",
      "asset": "preview-fonts/727.woff2",
      "sha256": "a6a5b4174bf28010e453050644a1846824cfc03e72a02a30f0b2e9620a558351",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "728": {
      "name": "Gugeshashvili_Slfn_2",
      "asset": "preview-fonts/728.woff2",
      "sha256": "3b6265a28a02c1ab56ef269ec5e66ab19d0c8ecc2e6ceab25a0a4398f66a4020",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "729": {
      "name": "Gugeshashvili_5_Mthavruli",
      "asset": "preview-fonts/729.woff2",
      "sha256": "08928922e46026abcf014b6bf43afe25bb7a17d8bee983fdcbbb6813722f301a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "730": {
      "name": "Gugeshashvili_8c1_Nuskhur",
      "asset": "preview-fonts/730.woff2",
      "sha256": "3b3ba4729eeeff21ce0b0593d8373f7c3362b51c2e9340864c8bffa34b348494",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "731": {
      "name": "Gugeshashvili_Slfn_2",
      "asset": "preview-fonts/731.woff2",
      "sha256": "eaf14136da6f51713450ee772b3738a41e92517d5a35a378a0f0e7947549ed6d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "732": {
      "name": "Gugeshashvili_7_KMthavruli",
      "asset": "preview-fonts/732.woff2",
      "sha256": "d134e0765a963772f48e5d868a3e920e9e1833f3af0dffc96f0ebda047e02222",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "733": {
      "name": "Gugeshashvili_Asomthavruli_1 Bold",
      "asset": "preview-fonts/733.woff2",
      "sha256": "0926fade7ac2ec43284df16c4828fbb2cc54a77dd67eb81668a8b951e324e163",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "734": {
      "name": "Gugeshashvili_8_Mthavruli Bold",
      "asset": "preview-fonts/734.woff2",
      "sha256": "186854db62118e6a09a43edf798cee4d5f4fe68715dce935b7c34bf9729dd141",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "735": {
      "name": "_! KolhetyMt Normal",
      "asset": "preview-fonts/735.woff2",
      "sha256": "3bdf33c9786a5354c320d36ff21913168f79f3604eb5e642fdb0bc3d1f1855de",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "736": {
      "name": "_! KolhetyMt Bold",
      "asset": "preview-fonts/736.woff2",
      "sha256": "f5afb7324a7ce942ab0b14ad9183d295ea0a74f8e58cac3f08a71c18ef5585ee",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "737": {
      "name": "BPG QuadroSquare Caps 2013",
      "asset": "preview-fonts/737.woff2",
      "sha256": "bd6da34bcbf08c17eade2855909db66bc2b672f9a53f645c2e9c0b713609d3bd",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "738": {
      "name": "BPG QuadroSquare 2013",
      "asset": "preview-fonts/738.woff2",
      "sha256": "d58b293f3e0d72af359e2cffc2855fba1f549846d8fa86fc6a9e47abfa304ddb",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "739": {
      "name": "BPG Square Banner 2013",
      "asset": "preview-fonts/739.woff2",
      "sha256": "6d9556c97dfd9e996c1bca0ea98846f7e6d945fb5133f4e33d4ae39dbe1e1be6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "740": {
      "name": "BPG Square Banner Caps 2013",
      "asset": "preview-fonts/740.woff2",
      "sha256": "1db2b2b0a5f3b079895c7d94c0d3e521e4dab6e092f154a16fe7b1f607180b39",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "741": {
      "name": "BPG SuperSquare 2013",
      "asset": "preview-fonts/741.woff2",
      "sha256": "2188ab7c9b16ca890deee9e699cdfa9dbbf0c5258d28e397d92a9a935faccf70",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "742": {
      "name": "BPG SuperSquare Caps 2013",
      "asset": "preview-fonts/742.woff2",
      "sha256": "bbb2aa3b3375fa4a767c1311b638cf3ee07fecc5abac91e288b5aa7659320adf",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "743": {
      "name": "ArchyEDT-Thin",
      "asset": "preview-fonts/743.woff2",
      "sha256": "602d798b19c58c49c17ce3d36b5eb1ea7c5ea8688b46726305efccd56deb3a1d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "744": {
      "name": "ArchyEDT-Bold",
      "asset": "preview-fonts/744.woff2",
      "sha256": "d3f4bf92648ddc9161ccb5ff0200aefc33e93981e42a80bafdfea3a3596ebdd9",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "745": {
      "name": "GEO_AKADEMIURI_MT",
      "asset": "preview-fonts/745.woff2",
      "sha256": "80239dfd7018c9745475a693f422e2f74b5a4820bca6576a8c4712c0e0bd4574",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "746": {
      "name": "GEO_LITERATURULI_MT",
      "asset": "preview-fonts/746.woff2",
      "sha256": "82796e6c380ace2379a1910e4c2f736ef966441e4629e1bc6f847f3483caad37",
      "status": "needs-review",
      "profile": {
        "table": "_standart_",
        "layout": "unchanged",
        "label": "STD8"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "747": {
      "name": "Gugeshashvili1",
      "asset": "preview-fonts/747.woff2",
      "sha256": "c84d20dbfeaec69d90ab9fa08f8a9fd01e38ec38ddebd0ddbd382478c0c3f345",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "748": {
      "name": "LariTethriLogo1",
      "asset": "preview-fonts/748.woff2",
      "sha256": "2feeeccb1af5ff1e1a3cfcbe5cc518deb2de4728e67b985420eda7d9738ca757",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "749": {
      "name": "Gugeshashvili2",
      "asset": "preview-fonts/749.woff2",
      "sha256": "dd37d6562f9c33c8cf3782e1a48eb08b120246ec5f312e95c61ec3905ef2aa5b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "750": {
      "name": "infobuk",
      "asset": "preview-fonts/750.woff2",
      "sha256": "79e66c2cecd2806c33736c0d8d48dee5878e9e58e680a855f9c3bbd81451a34f",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "751": {
      "name": "New",
      "asset": "preview-fonts/751.woff2",
      "sha256": "28f4715a3b33888a4882e611f74d199e000bc570947b9dd02bc4669334ac9dfb",
      "status": "needs-review",
      "profile": {
        "table": "raw",
        "layout": "unchanged",
        "label": "Unknown mapping",
        "uncertain": true
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "752": {
      "name": "LGV 2014 Mtavruli Regular",
      "asset": "preview-fonts/752.woff2",
      "sha256": "938b2d42ad2541dd9e0825c79d2b39932b534e9ceee3f35d03efc8353f7d8456",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "754": {
      "name": "LGV 2014 Nuskhuri Regular",
      "asset": "preview-fonts/754.woff2",
      "sha256": "a190c03f318e021fbda2de0a332c463c35a28c9e513e87cecb9fab3e03df1b38",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "755": {
      "name": "Gugeshashvili_Rachveli",
      "asset": "preview-fonts/755.woff2",
      "sha256": "43cdc7306140d59b1052d5a0037612e562d76fa8880d8214ffb7017fb053098a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "756": {
      "name": "Gugeshashvili_Rachveli_2",
      "asset": "preview-fonts/756.woff2",
      "sha256": "8d4c844a6f831a284516a35bb6d2a123e960e81d2d54e8784c1a7dd3b9ba03c2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "757": {
      "name": "GF Aisi Mt Regular",
      "asset": "preview-fonts/757.woff2",
      "sha256": "132e88cdab69c45a933c87f341eb8bd26c02781f163933f276d36cdc394c3705",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "758": {
      "name": "GF Aisi Mt Bold",
      "asset": "preview-fonts/758.woff2",
      "sha256": "0545a090c977db9f41a06b4db388f80a6d74f13eaa88c61447a9c9ce6bbb120f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "759": {
      "name": "GF Aisi Mt Italic",
      "asset": "preview-fonts/759.woff2",
      "sha256": "982171a14fe6eba36da84b41215b2bd1132d4d9ee88b6c3af9d961083994f472",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "760": {
      "name": "GF Aisi Mt Bold Italic",
      "asset": "preview-fonts/760.woff2",
      "sha256": "accb2714fd2c6c367e780e78fe91a535c1a588cf055a3f5b9a1c857dc8c109bf",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "761": {
      "name": "GF Aisi Mt Medium Medium",
      "asset": "preview-fonts/761.woff2",
      "sha256": "dff04dec5def3391360910e6ddd49b47a9295e4e2b1a3c899bc79cc47dd33947",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "762": {
      "name": "GF Aisi Mt Medium Medium Italic",
      "asset": "preview-fonts/762.woff2",
      "sha256": "f8178ef55567ded205a4c17545e2a6d54706cde1bad5a1a3beedfba9f7175387",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "763": {
      "name": "GF Aisi Mt Light Light",
      "asset": "preview-fonts/763.woff2",
      "sha256": "d4b3875283c245f65609c84b4bff779eda49edc9a2079e2f4f9097e39b59c798",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "764": {
      "name": "GF Aisi Mt Light Light Italic",
      "asset": "preview-fonts/764.woff2",
      "sha256": "9319768ee81c774db386086a7fb0b45bc2bf0106f7dbeed120e2522d6567d918",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "765": {
      "name": "GF Aisi Nus Regular",
      "asset": "preview-fonts/765.woff2",
      "sha256": "f3e8395afd568a688dcc7fdff505d26d418aeac20b24ff8cb42f1fcca3c64b1f",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "766": {
      "name": "GF Aisi Nus Bold",
      "asset": "preview-fonts/766.woff2",
      "sha256": "93b15133da229cc068e1c215b7f4786755ca828f1e055ca1dac23d8ed6dea105",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "767": {
      "name": "GF Aisi Nus Italic",
      "asset": "preview-fonts/767.woff2",
      "sha256": "36fb5aa440a8932eb18b36112824ff56f60a977c3608ffa1e7cf63540bd1ed76",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "768": {
      "name": "GF Aisi Nus Bold Italic",
      "asset": "preview-fonts/768.woff2",
      "sha256": "c7331c2221bad296569e36cbf68403f3374cc69b02cc6d3f5c9c99c93a4f7956",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "769": {
      "name": "GF Aisi Nus Medium Medium",
      "asset": "preview-fonts/769.woff2",
      "sha256": "2e5dd1218e45a0dc00a4478dad1183956deeae744e89c29ed6ea367869759357",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "770": {
      "name": "GF Aisi Nus Medium Medium Italic",
      "asset": "preview-fonts/770.woff2",
      "sha256": "b523a9978419b7ee2e1b0dd9e8e47b231f21d437b0935eedaafff3c7882450b6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "771": {
      "name": "GF Aisi Nus Light Light",
      "asset": "preview-fonts/771.woff2",
      "sha256": "ec93fdc55a965a6a7ecbba617ceb0538cd0554fbd012b15beb86874e9db77534",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "772": {
      "name": "GF Aisi Nus Light Light Italic",
      "asset": "preview-fonts/772.woff2",
      "sha256": "780a602dd4b7d657973410bcf8321d1e92c07a506ef89f1dbb291580c47678d3",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "773": {
      "name": "Barata Regular",
      "asset": "preview-fonts/773.woff2",
      "sha256": "0ecea2ef388d494dbe981b851f1dd12435329652a18912070a96222219a8b9e6",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "774": {
      "name": "Alva Normal",
      "asset": "preview-fonts/774.woff2",
      "sha256": "6ffaa5459859300382ba5e67b5b6bd264c500027a0d3e1b23181c6265e1e96b9",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "775": {
      "name": "Alva Bold",
      "asset": "preview-fonts/775.woff2",
      "sha256": "e0725e94ce17609676cf3454bc6929ba2efa0add3c011a7562562cff3d64cc06",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "776": {
      "name": "LGV Bebas Neue Book Book",
      "asset": "preview-fonts/776.woff2",
      "sha256": "c6edc0fbfeed2fd967e8c46d654cb1930603f676067d95942fb421428fc5d44b",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "777": {
      "name": "LGV Bebas Neue Regular",
      "asset": "preview-fonts/777.woff2",
      "sha256": "c7ae4bbe8f6a02ff61170d96c15ffeb5ea5c6fe646585d7f98a7306d14c8ef87",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "778": {
      "name": "Datebashvili",
      "asset": "preview-fonts/778.woff2",
      "sha256": "e5eff42a2d6c9efe751ca646a794c42947b07e04c5d5c7d590400c8f51f385bf",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "779": {
      "name": "LGV Baxy Regular",
      "asset": "preview-fonts/779.woff2",
      "sha256": "58736f5b3531bdd722ec019954db273dba304198b74654a47823ddc2f897a672",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "780": {
      "name": "zarapxana Normal",
      "asset": "preview-fonts/780.woff2",
      "sha256": "d72545a93b6ac6e9457c4597d6c86fca95192e8d8a0299bcd2e92e703e098d70",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "782": {
      "name": "XShevardnadzeAcademyN Regular",
      "asset": "preview-fonts/782.woff2",
      "sha256": "af0cd1ed765fb1ff83abbf23ea1762b8096ae9c7bf178f0b26dfe55d9fa054b7",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "783": {
      "name": "XShevardnadzeAcademyM Regular",
      "asset": "preview-fonts/783.woff2",
      "sha256": "a31c0712edce0599956d77967c92ae14b661911b3d913af82895b2d871174de0",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "784": {
      "name": "Dino Regular",
      "asset": "preview-fonts/784.woff2",
      "sha256": "74dfc4bafa02ecf0cb55ccfbaee9a0c5264da5e6cdb9aec05f1633652fc6c078",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "785": {
      "name": "Dara1981-Nus Regular",
      "asset": "preview-fonts/785.woff2",
      "sha256": "b4e2dd07408de392c6e7b7e86163472d196a50ec35597afda08730dc3b78c21a",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "786": {
      "name": "Dara1981-Nus Bold",
      "asset": "preview-fonts/786.woff2",
      "sha256": "d16047efe3b91154e67de3d45633d83b3b58eb70df80b901d694c1769068f434",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "787": {
      "name": "Dara1981-Mt Regular",
      "asset": "preview-fonts/787.woff2",
      "sha256": "8a37aa8e0ef5642eacd15db6429db62ce9fbb4ff5a68ed3bcf4e8fa52bb95356",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "788": {
      "name": "Dara1981-Mt Bold",
      "asset": "preview-fonts/788.woff2",
      "sha256": "54f139d75264af3e4dc64a7c1cc9b1ebb3506ad409ff0d29e055b9094e6613d1",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "789": {
      "name": "Baron Medium",
      "asset": "preview-fonts/789.woff2",
      "sha256": "bfabb1ff56cdd777994ad9f0d84b1ed6a7ad5be17f953c40f60712afb50b5b45",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "790": {
      "name": "LGVBebas Neue Bold Bold",
      "asset": "preview-fonts/790.woff2",
      "sha256": "bc6c11671a33070b8f00e49e685641917868518e642e57ba943717a6d37bc243",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "791": {
      "name": "TWS Borg Regular",
      "asset": "preview-fonts/791.woff2",
      "sha256": "f34325611442d14f6b3c53448e6ccc2ad306d109797c869e404991c93969248a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "792": {
      "name": "DejaVu Sans Book",
      "asset": "preview-fonts/792.woff2",
      "sha256": "c8e210817a1ea49b349d2f79c03853a3383821e02d795d019510d46c780b906a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "793": {
      "name": "DejaVu Sans Bold",
      "asset": "preview-fonts/793.woff2",
      "sha256": "b686f768e896a14c2c0e19ce5c3e1747d056aec093a7e570d422568687d9d5fc",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "794": {
      "name": "DejaVu Sans Oblique",
      "asset": "preview-fonts/794.woff2",
      "sha256": "1e86f234849db5fe1b02f714a92008b606a502e4498ef5ab208ec46cbe5816ef",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "795": {
      "name": "DejaVu Sans Bold Oblique",
      "asset": "preview-fonts/795.woff2",
      "sha256": "b4b0ab19c1c893581daadc87f00110fa487a426f9ffdd2041b1fcfaa253dc6b0",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "796": {
      "name": "DejaVu Sans ExtraLight",
      "asset": "preview-fonts/796.woff2",
      "sha256": "406fe9b0a9c96f4396c11ebb14c7eaa81772d537e13497ab478202caaf6526bc",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "798": {
      "name": "FuturaBookMta",
      "asset": "preview-fonts/798.woff2",
      "sha256": "59231b5d6abf4483a4ab81405d1982dd24ac7b96f435ec030a9e0b9aff5ace1d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "799": {
      "name": "LGV shxvarti Regular",
      "asset": "preview-fonts/799.woff2",
      "sha256": "1e48bf34ec00d0bd4cba7770d69fad97141067fcddb819b6512bf74434bfc1bc",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "800": {
      "name": "LGVtavdrigina Regular",
      "asset": "preview-fonts/800.woff2",
      "sha256": "a8a72998b1a5307ec6d9ac2b2ee5df5289223e7a6f34899d41458607a8a47554",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "801": {
      "name": "Bebas Neue Book Regular",
      "asset": "preview-fonts/801.woff2",
      "sha256": "e2d5edbf9d9e480804bb610b8e31a34e776a79fb5d15663a11b8958d43092df9",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "802": {
      "name": "Bebas Neue Regular Regular",
      "asset": "preview-fonts/802.woff2",
      "sha256": "dacd2bd7fbe01ed72bdd06f153e0f96be2b018804a466fc77ea0cce5a7d48652",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "803": {
      "name": "Bebas Neue Bold Regular",
      "asset": "preview-fonts/803.woff2",
      "sha256": "955af2bd48c4de31269801ac954327f6621ad0920991fac5a371f2f01d82f77e",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "804": {
      "name": "Eurostile LT Std GEO_Nus Regular",
      "asset": "preview-fonts/804.woff2",
      "sha256": "23e8b90bfc52da6d72422ef3854dbeb06392d7b0937378d3a430223477bf40e9",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "805": {
      "name": "Eurostile LT Std GEO_Nus Bold",
      "asset": "preview-fonts/805.woff2",
      "sha256": "8ac9428f07e5327de29842fa1524e59d13a8413e7bfef05eface2f249383bf91",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 2,
        "ambiguousCharacters": [
          "გ",
          "დ",
          "ე",
          "ვ",
          "ზ",
          "თ",
          "ი",
          "კ",
          "ლ",
          "მ",
          "ნ",
          "ო",
          "პ",
          "ჟ",
          "რ",
          "ს",
          "ტ",
          "უ",
          "ფ",
          "ქ",
          "ღ",
          "ყ",
          "შ",
          "ჩ",
          "ც",
          "ძ",
          "წ",
          "ჭ",
          "ხ",
          "ჯ",
          "ჰ"
        ]
      }
    },
    "806": {
      "name": "Eurostile LT Std GEO_Nus Italic",
      "asset": "preview-fonts/806.woff2",
      "sha256": "f2f69aef04e3af58a6fbe0c6d8a2132b230a2921573fc1154dcde182b5ef5a1b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "807": {
      "name": "Eurostile LT Std GEO_Nus Bold Italic",
      "asset": "preview-fonts/807.woff2",
      "sha256": "a4c907067b63037025fd74f3958ef6bc6d7a4b7215b46ab3d48c20e8c210a690",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 2,
        "ambiguousCharacters": [
          "გ",
          "დ",
          "ე",
          "ვ",
          "ზ",
          "თ",
          "ი",
          "კ",
          "ლ",
          "მ",
          "ნ",
          "ო",
          "პ",
          "ჟ",
          "რ",
          "ს",
          "ტ",
          "უ",
          "ფ",
          "ქ",
          "ღ",
          "ყ",
          "შ",
          "ჩ",
          "ც",
          "ძ",
          "წ",
          "ჭ",
          "ხ",
          "ჯ",
          "ჰ"
        ]
      }
    },
    "808": {
      "name": "Eurostile LT Std GEO_Nus Demi",
      "asset": "preview-fonts/808.woff2",
      "sha256": "8abc7eb2d5321adf2e986a77db75bf670c05b9a555e121f51690cf3b3d524a0c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "809": {
      "name": "Eurostile LT Std GEO_Nus Demi Italic",
      "asset": "preview-fonts/809.woff2",
      "sha256": "7b15174b0cdabcf9eaa3059c3ded2f4f16461224f2115cff041bb627c6b56e1b",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "810": {
      "name": "Eurostile LT Std GEO_Mt Regular",
      "asset": "preview-fonts/810.woff2",
      "sha256": "2e0f9e1c24428ac18110af3c5e1b96ab3ae250c526acdb875b6ed4b7d1f5701d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "811": {
      "name": "Eurostile LT Std GEO_Mt Bold",
      "asset": "preview-fonts/811.woff2",
      "sha256": "c53f734a6aeec44aee4900b0000c19596d6122bfd9a0877b9492a3eff1c83a31",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 2,
        "ambiguousCharacters": [
          "გ",
          "დ",
          "ე",
          "ვ",
          "ზ",
          "თ",
          "ი",
          "კ",
          "ლ",
          "მ",
          "ნ",
          "ო",
          "პ",
          "ჟ",
          "რ",
          "ს",
          "ტ",
          "უ",
          "ფ",
          "ქ",
          "ღ",
          "ყ",
          "შ",
          "ჩ",
          "ც",
          "ძ",
          "წ",
          "ჭ",
          "ხ",
          "ჯ",
          "ჰ"
        ]
      }
    },
    "812": {
      "name": "Eurostile LT Std GEO_Mt Italic",
      "asset": "preview-fonts/812.woff2",
      "sha256": "aa35d0e39201376a1cc684d740a12f44b9202eac525a5f89c52b37193f0f57f1",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "813": {
      "name": "Eurostile LT Std GEO_Mt Bold Italic",
      "asset": "preview-fonts/813.woff2",
      "sha256": "6948ef17f83cf5f4ce964643be00dffd1538cf6c24453eb998be382266b6f049",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 2,
        "ambiguousCharacters": [
          "გ",
          "დ",
          "ე",
          "ვ",
          "ზ",
          "თ",
          "ი",
          "კ",
          "ლ",
          "მ",
          "ნ",
          "ო",
          "პ",
          "ჟ",
          "რ",
          "ს",
          "ტ",
          "უ",
          "ფ",
          "ქ",
          "ღ",
          "ყ",
          "შ",
          "ჩ",
          "ც",
          "ძ",
          "წ",
          "ჭ",
          "ხ",
          "ჯ",
          "ჰ"
        ]
      }
    },
    "814": {
      "name": "Eurostile LT Std GEO_Mt Demi",
      "asset": "preview-fonts/814.woff2",
      "sha256": "2e60d3b9d5fef34e76a875054072648f03c1bcf32107502051b8fab0d493cb17",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "815": {
      "name": "Eurostile LT Std GEO_Mt Demi Italic",
      "asset": "preview-fonts/815.woff2",
      "sha256": "03d8ee0b6f0620bbaf336e40fa7027595c9a2f7a2e3eca5cd3a9569607e0f9d4",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "816": {
      "name": "GF Alaverdi Nus Regular",
      "asset": "preview-fonts/816.woff2",
      "sha256": "fe8e75971e5a1d634e4c6295c37fbad0bc985b169512725c14ca36e4c35ba7a5",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "817": {
      "name": "GF Alaverdi Nus Bold",
      "asset": "preview-fonts/817.woff2",
      "sha256": "1ecf53eb8fdf71dc485c3ab3dc6bf97fc12482f88889b51bb36ca171fe45ec30",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "818": {
      "name": "GF Alaverdi Nus Italic",
      "asset": "preview-fonts/818.woff2",
      "sha256": "3d5327b07e7b01fa79d6b7d618d883a2f5c1d0ebdfe79f4e6e74a49442d3c0a3",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "819": {
      "name": "GF Alaverdi Nus Bold Italic",
      "asset": "preview-fonts/819.woff2",
      "sha256": "65a79a1620eea7c2e9dbbb0670bd18977593fdded613e56d9ca466770390efea",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "820": {
      "name": "GF Alaverdi Nus Light",
      "asset": "preview-fonts/820.woff2",
      "sha256": "cf6dafdcfa7d6b2dfc84a5cc071f54ed8cd642fdd0145e24f36e4b41a42f36db",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "821": {
      "name": "GF Alaverdi Nus Light Italic",
      "asset": "preview-fonts/821.woff2",
      "sha256": "cf0dd83b676b915e05c3607ac8a8ab50526ce231e6798404fa1bf4f7406bf131",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "822": {
      "name": "GF Alaverdi Nus Black",
      "asset": "preview-fonts/822.woff2",
      "sha256": "3fd2bb912c4d26d1b4625dfc72b01c611c5c8e17a9fe10c5026acc56f8c625b6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "823": {
      "name": "GF Alaverdi Nus Black Italic",
      "asset": "preview-fonts/823.woff2",
      "sha256": "120ede6a95110e1124b2df05d962222e1310af46b437876ffa9e5b5934361339",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "824": {
      "name": "GF Alaverdi Mt Regular",
      "asset": "preview-fonts/824.woff2",
      "sha256": "6d0640c77de2546e87c4ecf0feb97ecdd019d99071850f1fa6b503b7b0bdc04a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "825": {
      "name": "GF Alaverdi Mt Bold",
      "asset": "preview-fonts/825.woff2",
      "sha256": "0fc00c54ebb18ae82bc68890e9acaf7c152741bbf9921b35d248ed36b6d80af6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "826": {
      "name": "GF Alaverdi Mt Italic",
      "asset": "preview-fonts/826.woff2",
      "sha256": "90903508924842db31eab9f1dbaf0b7f3f43eb31b2508d7e5ee83128266908d2",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "827": {
      "name": "GF Alaverdi Mt Bold Italic",
      "asset": "preview-fonts/827.woff2",
      "sha256": "5424fb77cbbcf8962211b146c2642cc7f4c715965e055f22aba5ed8c46f6a434",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "828": {
      "name": "GF Alaverdi Mt Light",
      "asset": "preview-fonts/828.woff2",
      "sha256": "e0f359ed2826a98d931c035c88b66b48a28d4a32ec22bf36b7495dc96a814ddd",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "829": {
      "name": "GF Alaverdi Mt Light Italic",
      "asset": "preview-fonts/829.woff2",
      "sha256": "3f6a18870395c648cc00989b39cb4cfefaa00ae38432adff4b0d9fda117ad781",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "830": {
      "name": "GF Alaverdi Mt Black",
      "asset": "preview-fonts/830.woff2",
      "sha256": "47d6a62c7bb53e4ce06f99c75b7bcf7d023884c9ce4b76ae4524281f86520c84",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "831": {
      "name": "GF Alaverdi Mt Black Italic",
      "asset": "preview-fonts/831.woff2",
      "sha256": "ca78172b1b740c3d5db1a37f6916941535695e423b2831bd47b5626ba563b617",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "832": {
      "name": "Mzeqala Regular",
      "asset": "preview-fonts/832.woff2",
      "sha256": "58bb64d5985b4f7792a6f3ac25f94e5c6c272d5a6e90f69bf97e570b898aac07",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "833": {
      "name": "Mzeqala Regular",
      "asset": "preview-fonts/833.woff2",
      "sha256": "7ea2538125927262620d679fb91de336c0277639ca904044e5b56d7aea7421ec",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "834": {
      "name": "Georgian Dactyl Regular",
      "asset": "preview-fonts/834.woff2",
      "sha256": "bda866e1b5a607c9ce08dc0d6f3279a52e70e0efe358a83f7b74ee0fe588d7b8",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "836": {
      "name": "Klivlendichamia Medium",
      "asset": "preview-fonts/836.woff2",
      "sha256": "0e318fa12aa41c12e200c413233081244e1e3895196805882cd252c945a90846",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "837": {
      "name": "Archetype Mkhedruli Bold",
      "asset": "preview-fonts/837.woff2",
      "sha256": "4ce475fc8f09117354dcc697d08a43a88afd66af5917e3d550d779dfb6e029c3",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "838": {
      "name": "Archetype Mtavruli Bold",
      "asset": "preview-fonts/838.woff2",
      "sha256": "f6b888a8e4255a8da217eb4ad3d253f1cf2d6393d421c44232f41b181b51094f",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "839": {
      "name": "Klivlendi_ena Regular",
      "asset": "preview-fonts/839.woff2",
      "sha256": "ebafddb7feb2b769dad97f1b1c410e3b282ecb96fbe7c36c59b91d389fa747ad",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "840": {
      "name": "Klivlendi_kata Regular",
      "asset": "preview-fonts/840.woff2",
      "sha256": "b88efdbbc6c835d086e22afa5c402ddfe99cb8eb1144c37eabd3a75533647147",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "841": {
      "name": "GL Akademiuri Regular",
      "asset": "preview-fonts/841.woff2",
      "sha256": "516531d8ba22917a35b59de7eee08051c2d68766043bee1d5c69f7958edf6085",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "842": {
      "name": "GL Chonchkhi Regular",
      "asset": "preview-fonts/842.woff2",
      "sha256": "2379ffe9c61f8ca265c790bc52e47967c377361710cb04d30a0b8b4031b34c84",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "843": {
      "name": "GL Chonchkhi Light Regular",
      "asset": "preview-fonts/843.woff2",
      "sha256": "4404ec196766207c75b2647e3bb9d772c93891dead04422ea8e1c3e9b3b4c468",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "844": {
      "name": "GL Chonchkhi Book Regular",
      "asset": "preview-fonts/844.woff2",
      "sha256": "ffa5c82a30bbaf9a477d1ed973d881dfa7e26eba691730d89a7d916a4607c0a6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "845": {
      "name": "GL Dumbadze Garnituri Semi bold Regular",
      "asset": "preview-fonts/845.woff2",
      "sha256": "de4fc684629ea6ad24e55e971ef575e48e82147142210abd4d3b5d74c0801966",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 42,
        "ambiguousCharacters": []
      }
    },
    "846": {
      "name": "GL Erekles Stamba Regular",
      "asset": "preview-fonts/846.woff2",
      "sha256": "ef7a97f9f696ef472ff1f72d042e2879f4945572521c7263484c7071a7300b2c",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 39,
        "ambiguousCharacters": []
      }
    },
    "847": {
      "name": "GL Giorgi Nikoladze Regular",
      "asset": "preview-fonts/847.woff2",
      "sha256": "0b7eef611eafebc5f92fde5df3f25834eb03c9f11f98eefc8f69d28f1e43d31a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "848": {
      "name": "GL Gordeziani Regular",
      "asset": "preview-fonts/848.woff2",
      "sha256": "588239fbd9c8237c49ee8dbb3fb24e62dfdb81a4ae01674c2a3e9f7daf58c7cb",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "849": {
      "name": "GL Gordeziani Bold Regular",
      "asset": "preview-fonts/849.woff2",
      "sha256": "32d50b675a074bacc1a3e2de1eb9337bf78d5f0708b5e193d13c82431d728079",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "850": {
      "name": "GL Gordeziani Light Regular",
      "asset": "preview-fonts/850.woff2",
      "sha256": "a0bddfa0b48821917ecb5f4c0f8f0f791f10ecd1895ec557f1840394f78ebe07",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "851": {
      "name": "GL Gordeziani Medium Regular",
      "asset": "preview-fonts/851.woff2",
      "sha256": "0548fd1ee16509b474e0664e0184f839761829423830c6ad006c478be9e54675",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "852": {
      "name": "GL Gordeziani UltraLight Regular",
      "asset": "preview-fonts/852.woff2",
      "sha256": "9f713917671c46702957e26788747a67a55a4825db9c16896e7259239874289a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "853": {
      "name": "GL Italiuri Regular",
      "asset": "preview-fonts/853.woff2",
      "sha256": "3f0a591f5f910a07e3ee5b06bab51dffa55deb961113d912f5fc608bf5168590",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "854": {
      "name": "GL Kirovi Bold Regular",
      "asset": "preview-fonts/854.woff2",
      "sha256": "edf0cdde6f0f22084e0ad4a2d353ce09e0fade421b56f1ef761df013bea9053a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "855": {
      "name": "GL Kupiura Regular",
      "asset": "preview-fonts/855.woff2",
      "sha256": "2477e9e0bc65e8ff9f827d8803bee3002ab6e2ff5c22a33b163e5a61a960a1f3",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "856": {
      "name": "GL Kupiura Bold Regular",
      "asset": "preview-fonts/856.woff2",
      "sha256": "b9f2c7e3e7a94e81de1ae814bd427b270e96092303de9f073e3ba48a17155343",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "857": {
      "name": "GL Kupiura Medium Regular",
      "asset": "preview-fonts/857.woff2",
      "sha256": "1f6bba96f7f44eb2654abb97584cf9daeeae8e9998e991fa7ca9129eea280432",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "858": {
      "name": "GL Kupiura Light Regular",
      "asset": "preview-fonts/858.woff2",
      "sha256": "89ff2f0bcc1c86388d7f2c91028e048c463152cb6dc16338df25daa851cc5d11",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "859": {
      "name": "GL Kupiura UltraLight Regular",
      "asset": "preview-fonts/859.woff2",
      "sha256": "203f02f0d361d980dca7ca4bdda4fc6ac8d1e6f25b9b4f4546a9d2b67382ebda",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "860": {
      "name": "GL Lortkipanidze Regular",
      "asset": "preview-fonts/860.woff2",
      "sha256": "f69249410c49df4caf80fde5117a31f053b4cc7161e613b958577a2011ed53f2",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "861": {
      "name": "GL Lortkipanidze Bold",
      "asset": "preview-fonts/861.woff2",
      "sha256": "18a69d019526cd15323599ff25f05971c785fe6e48349041358b57e85866b250",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "862": {
      "name": "GL Mkafio Regular",
      "asset": "preview-fonts/862.woff2",
      "sha256": "c75dca6577f2ef4691b9464d3745434318d38fabc345e60b2b98f943c360eab7",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "863": {
      "name": "GL Mkafio Book Regular",
      "asset": "preview-fonts/863.woff2",
      "sha256": "c2eb28831e0a3470326f5a36b9e73919201e6d7e0759ad5ddc2f89c251d91b60",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "864": {
      "name": "GL Mkafio Light Regular",
      "asset": "preview-fonts/864.woff2",
      "sha256": "54073c00b9678b8154d2487e5b9b1972fd056f56c5fbafea380e147ca79d0518",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "865": {
      "name": "GL Mkafio ExtraLight Regular",
      "asset": "preview-fonts/865.woff2",
      "sha256": "bb7b43e6d917bbaa3500f49973470d1782831a8c1c86a3b7f8f6c906233334e5",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "866": {
      "name": "GL Mkafio UltraLight Regular",
      "asset": "preview-fonts/866.woff2",
      "sha256": "856a63324d20cb9b75f438c4b18b3b05d27b9c51fac65f4bffd238f336d000dc",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "867": {
      "name": "GL Mkafio Thin Regular",
      "asset": "preview-fonts/867.woff2",
      "sha256": "dd256cde4ac8151921c349079ef6c6ff69215e2427931d97afff87d8d42d8384",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 43,
        "ambiguousCharacters": []
      }
    },
    "868": {
      "name": "GL Moskovis Regular",
      "asset": "preview-fonts/868.woff2",
      "sha256": "b51a64df76c75906bd8c63894939c7fda78a66d8d4497063c3c95b2fba51d2d7",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 44,
        "ambiguousCharacters": []
      }
    },
    "869": {
      "name": "GL Parizuli Regular",
      "asset": "preview-fonts/869.woff2",
      "sha256": "856e16a8f80f9ac9c6e6dff3876df18d7ae88e258bf0cb4e3b65bb0e1fd50a86",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "870": {
      "name": "GL Parizuli Medium Regular",
      "asset": "preview-fonts/870.woff2",
      "sha256": "85cb2c856469a17812294a86bf5f58fdcfbb21cd7939bfdbbcb62acf48e59b91",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "871": {
      "name": "GL Parizuli Bold Regular",
      "asset": "preview-fonts/871.woff2",
      "sha256": "f3357b9985f43a47ddbfb885b17ca607c5570e3fb0537a3f33e230262f935e38",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "872": {
      "name": "GL Saeklesio Regular",
      "asset": "preview-fonts/872.woff2",
      "sha256": "b2e8f7b09aa03a31bc15d970d44aa54b46a7b69b13e583fa8cbd43631fecc6b0",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "873": {
      "name": "GL Satitulo Regular",
      "asset": "preview-fonts/873.woff2",
      "sha256": "cc576a88519327539d0223dc639bfb7bab732fcd04ee25c7bcdeb7faf2e33ac6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "874": {
      "name": "GL Tatishvili 12 Normal Regular",
      "asset": "preview-fonts/874.woff2",
      "sha256": "24c2901160c1ea41d8d26a369612720c32b21b48223d691f984ab893946e3d75",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "875": {
      "name": "GL Tatishvili Metal Bold Regular",
      "asset": "preview-fonts/875.woff2",
      "sha256": "b71829461fb4f6a4099e9b66baf815485fcede65b4d5736f72019b04c3780001",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "876": {
      "name": "GL Universiteti Regular",
      "asset": "preview-fonts/876.woff2",
      "sha256": "029879182f967edc2b0e9da25b9faa84652e146659e622dbb1b26d13ee040259",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 36,
        "ambiguousCharacters": []
      }
    },
    "877": {
      "name": "GL Venuri Regular",
      "asset": "preview-fonts/877.woff2",
      "sha256": "8325714c898599d0fdaa4b3854ddd7e7c8491f4d7e882ee92687069bad2a98cf",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "878": {
      "name": "GL Venuri Bold Regular",
      "asset": "preview-fonts/878.woff2",
      "sha256": "5765e68ea5f8734b4e618ee8f5d81ba4cf752e4f3904a39611821f6f3dd93f19",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "879": {
      "name": "GL Venuri Book Regular",
      "asset": "preview-fonts/879.woff2",
      "sha256": "77b69d5236f261e21ca624f5d8ef9e264639ffecfd8b44237fa166f9037f6e58",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "880": {
      "name": "GL Venuri Medium Regular",
      "asset": "preview-fonts/880.woff2",
      "sha256": "a4d85b45a3914b80c49a419070e36505365966bbe69d79f04bfe51e0953cf183",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "881": {
      "name": "GL Venuri Thin Regular",
      "asset": "preview-fonts/881.woff2",
      "sha256": "ee1f11a5dda8f499076d5e20d70b45f9a5838948a8a680a1a183ae42fa98cbab",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "882": {
      "name": "GL Venuri Light Regular",
      "asset": "preview-fonts/882.woff2",
      "sha256": "50e9966a6c096bd1e5241dd292b7dd012ad8d600ffcebff45ba3a46f877963b4",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "883": {
      "name": "GL Venuri ExtraLight Regular",
      "asset": "preview-fonts/883.woff2",
      "sha256": "7897290f93db50d3425ea88e76a61fca91163ac955010c29fcb5a7d5518f4663",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "884": {
      "name": "GL Venuri Heavy Regular",
      "asset": "preview-fonts/884.woff2",
      "sha256": "71c8bd772f13710cdc9e7426906413628bc831f529eb1bee4590ac6c63d6532a",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "885": {
      "name": "Tsripa Regular",
      "asset": "preview-fonts/885.woff2",
      "sha256": "dfaeba2890106be87a4b5aab59675cdf4722a10be080fa4d865d5421550f85a2",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "886": {
      "name": "Veshapi Regular",
      "asset": "preview-fonts/886.woff2",
      "sha256": "e6104695f06a90f557356eeea7c2405233495107cbedd2331ae2c7b7d55c1b93",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "887": {
      "name": "MG Minecraft Georgian Regular",
      "asset": "preview-fonts/887.woff2",
      "sha256": "395c44db925eb5e875f26a13a595b5a9c72839d750c9d11e4d417c301bdf5801",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 34,
        "ambiguousCharacters": []
      }
    },
    "888": {
      "name": "MG Press Start 2P Regular",
      "asset": "fonts/888.ttf",
      "sha256": "bca84d2cc5f1e26b6240cca6b3cd62137b876df30213e1a01f5fc7364296fa4c",
      "status": "download-only",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "889": {
      "name": "TG Square Regular",
      "asset": "preview-fonts/889.woff2",
      "sha256": "d33521c6c818d62e1df051189b5a12bc20cd2490129e7444b8477ee58cbbafd9",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "890": {
      "name": "Frapu 2x Geo Regular",
      "asset": "preview-fonts/890.woff2",
      "sha256": "3bd970affdc5fea2d44080413e1112aaf07f77c2193bd01752e523eb3601f8aa",
      "status": "needs-review",
      "profile": {
        "table": "_eng_",
        "layout": "unchanged",
        "label": "Legacy Latin · QWERTY"
      },
      "evidence": "Catalog-derived candidate; glyph order not yet verified",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": []
      }
    },
    "891": {
      "name": "DM Niko Nikoladze Regular",
      "asset": "preview-fonts/891.woff2",
      "sha256": "15dd3c8b3d705892b3730a7cd5358579974f27b02cc11888bd47f2d13d7271a6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "892": {
      "name": "Mosheneba Regular",
      "asset": "preview-fonts/892.woff2",
      "sha256": "06cdde8f1c587badc9d234caa98b68455329b4f309cb8fc7753cd8f76e783349",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "893": {
      "name": "TG Moduli Mtavruli Regular",
      "asset": "preview-fonts/893.woff2",
      "sha256": "687a7b085c49f8737868abef55231bd41e18fc28c2fa7d7681cc4028e7bdaff9",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "894": {
      "name": "TG Compliment Italic",
      "asset": "preview-fonts/894.woff2",
      "sha256": "a75012bead102eefe158290f4bf8a4f88934904e48e0575bb651e38351d2b272",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "895": {
      "name": "DM Iakobi Regular",
      "asset": "preview-fonts/895.woff2",
      "sha256": "7c9272b6709c7bf805f38388ab5aacb943d065c40b2a4c405cf3edb838f167e5",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 38,
        "ambiguousCharacters": []
      }
    },
    "896": {
      "name": "MaZeg 5L Regular",
      "asset": "preview-fonts/896.woff2",
      "sha256": "c3a8fc67b376ef22a1feee4b3f42ce8d969d69347fdff2e5b7c7b79148667892",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "897": {
      "name": "GeoPerf Regular",
      "asset": "preview-fonts/897.woff2",
      "sha256": "1966d702a1d582f1ab899457c26a7d76d0276525f8070ef7f41860002f230607",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "898": {
      "name": "DM Zviadi Regular",
      "asset": "preview-fonts/898.woff2",
      "sha256": "43e87e113359d2aa3efcd87e8e95734b721380536b62c4494fc8983a42d08eba",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "899": {
      "name": "DM Merab Kostava Regular",
      "asset": "preview-fonts/899.woff2",
      "sha256": "9316354608149da9da28b571a386ea113b16aeef5758f4b467f3be429783e84d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "900": {
      "name": "DM Giorgi Khorguashvili Regular",
      "asset": "preview-fonts/900.woff2",
      "sha256": "08f18924ec11f0cf213082e885800d43b8359e4bd6cd89bc4e8800978bc13258",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "901": {
      "name": "DM Anbandidi Regular",
      "asset": "preview-fonts/901.woff2",
      "sha256": "9a4165ec18ed9fdc7ffb69b5611cc065d73787df8e862d47d4a2c3e444d1e9d6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "902": {
      "name": "DM Archium Regular",
      "asset": "preview-fonts/902.woff2",
      "sha256": "d47dbd5deb382222c3342b8bba71c9ab910d134fda312a882cc989a708047ec2",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "903": {
      "name": "DM Gragnili Regular",
      "asset": "preview-fonts/903.woff2",
      "sha256": "ae6d3b0cf996233105ebeeb1450f927ceb97971177b589b6faa1bc8ab4ee61ba",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 0,
        "ambiguousCharacters": [
          "ა",
          "ბ",
          "გ",
          "დ",
          "ე",
          "ვ",
          "ზ",
          "თ",
          "ი",
          "კ",
          "ლ",
          "მ",
          "ნ",
          "ო",
          "პ",
          "ჟ",
          "რ",
          "ს",
          "ტ",
          "უ",
          "ფ",
          "ქ",
          "ღ",
          "ყ",
          "შ",
          "ჩ",
          "ც",
          "ძ",
          "წ",
          "ჭ",
          "ხ",
          "ჯ",
          "ჰ",
          "ჱ",
          "ჲ",
          "ჳ",
          "ჴ",
          "ჵ",
          "ჷ",
          "ჽ"
        ]
      }
    },
    "904": {
      "name": "DM Medea Regular",
      "asset": "preview-fonts/904.woff2",
      "sha256": "3e9a9e323dc5df6a65592b259a94c89d19bdf766c169eb0730b73907f2aa82d6",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 45,
        "ambiguousCharacters": []
      }
    },
    "905": {
      "name": "Bakuri Regular",
      "asset": "preview-fonts/905.woff2",
      "sha256": "27df0b50611b7abb44bc288153479c495caa0b7ebeb8a625c3d80d6c29974b16",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    },
    "906": {
      "name": "Bakuri Italic",
      "asset": "preview-fonts/906.woff2",
      "sha256": "6965b84c89bd2457ae4f51d978cea41e5374cd15a1cfddef696333b74b39bc1d",
      "status": "unicode-native",
      "profile": {
        "table": "_utf8_",
        "layout": "unchanged",
        "label": "Unicode"
      },
      "evidence": "Native Unicode character map",
      "cmapEvidence": {
        "mappedCharacters": 33,
        "ambiguousCharacters": []
      }
    }
  }
}
